const citiesAndAreas =[
    { city: 'Aachen', area: '241'},
    { city: 'Aachen-Kornelimünster', area: '2408'},
    { city: 'Aalen', area: '7361'},
    { city: 'Aalen-Ebnat', area: '7367'},
    { city: 'Aarbergen', area: '6120'},
    { city: 'Abberode', area: '34779'},
    { city: 'Abenberg Mittelfr', area: '9178'},
    { city: 'Abenberg-Wassermungenau', area: '9873'},
    { city: 'Abensberg', area: '9443'},
    { city: 'Abtsgmünd', area: '7366'},
    { city: 'Achberg', area: '8380'},
    { city: 'Achern', area: '7841'},
    { city: 'Achim b Bremen', area: '4202'},
    { city: 'Achterwehr', area: '4340'},
    { city: 'Adelberg', area: '7166'},
    { city: 'Adelebsen', area: '5506'},
    { city: 'Adelmannsfelden', area: '7963'},
    { city: 'Adelsdorf Mittelfr', area: '9195'},
    { city: 'Adelsheim', area: '6291'},
    { city: 'Adelshofen Mittelfr', area: '9865'},
    { city: 'Adenau', area: '2691'},
    { city: 'Adlkofen', area: '8707'},
    { city: 'Adorf Vogtl', area: '37423'},
    { city: 'Aerzen', area: '5154'},
    { city: 'Affing', area: '8207'},
    { city: 'Affinghausen', area: '4247'},
    { city: 'Aglasterhausen', area: '6262'},
    { city: 'Ahaus', area: '2561'},
    { city: 'Ahaus-Alstätte', area: '2567'},
    { city: 'Ahausen-Kirchwalsede', area: '4269'},
    { city: 'Ahlbeck b Torgelow', area: '39775'},
    { city: 'Ahlen Westf', area: '2382'},
    { city: 'Ahlerstedt', area: '4166'},
    { city: 'Ahnatal', area: '5609'},
    { city: 'Ahorn Baden', area: '6296'},
    { city: 'Ahrensbök', area: '4525'},
    { city: 'Ahrensbök-Gnissau', area: '4556'},
    { city: 'Ahrensburg', area: '4102'},
    { city: 'Aichach', area: '8251'},
    { city: 'Aichstetten Kr Ravensburg', area: '7565'},
    { city: 'Aidenbach', area: '8543'},
    { city: 'Aindling', area: '8237'},
    { city: 'Aitrang', area: '8343'},
    { city: 'Aken Elbe', area: '34909'},
    { city: 'Albbruck', area: '7753'},
    { city: 'Albersdorf Holst', area: '4835'},
    { city: 'Albersweiler', area: '6345'},
    { city: 'Albisheim Pfrimm', area: '6355'},
    { city: 'Albstadt-Ebingen', area: '7431'},
    { city: 'Albstadt-Laufen', area: '7435'},
    { city: 'Albstadt-Tailfingen', area: '7432'},
    { city: 'Aldenhoven b Jülich', area: '2464'},
    { city: 'Alerheim', area: '9085'},
    { city: 'Alfeld Leine', area: '5181'},
    { city: 'Alfeld Mittelfr', area: '9157'},
    { city: 'Alfhausen', area: '5464'},
    { city: 'Algermissen', area: '5126'},
    { city: 'Allensbach', area: '7533'},
    { city: 'Allersberg', area: '9176'},
    { city: 'Allershausen Oberbay', area: '8166'},
    { city: 'Allstedt', area: '34652'},
    { city: 'Alpen', area: '2802'},
    { city: 'Alpirsbach', area: '7444'},
    { city: 'Alsdorf Rheinl', area: '2404'},
    { city: 'Alsenz', area: '6362'},
    { city: 'Alsfeld', area: '6631'},
    { city: 'Alsleben Saale', area: '34692'},
    { city: 'Alt Duvenstedt', area: '4338'},
    { city: 'Alt Zachun', area: '38859'},
    { city: 'Alt Zeschdorf', area: '33602'},
    { city: 'Altdöbern', area: '35434'},
    { city: 'Altdorf b Nürnberg', area: '9187'},
    { city: 'Altdorf-Pfettrach', area: '8704'},
    { city: 'Altena Westf', area: '2352'},
    { city: 'Altenahr', area: '2643'},
    { city: 'Altenau Harz', area: '5328'},
    { city: 'Altenbeken', area: '5255'},
    { city: 'Altenberg Sachs', area: '35056'},
    { city: 'Altenberge Westf', area: '2505'},
    { city: 'Altenbrak', area: '39456'},
    { city: 'Altenburg Thür', area: '3447'},
    { city: 'Altendorf a Nabburg', area: '9675'},
    { city: 'Altengrabow', area: '39225'},
    { city: 'Altenhof Kr Barnim', area: '33363'},
    { city: 'Altenkirchen Pfalz', area: '6386'},
    { city: 'Altenkirchen Rügen', area: '38391'},
    { city: 'Altenkirchen Westerwald', area: '2681'},
    { city: 'Altenmedingen', area: '5807'},
    { city: 'Altenmünster Schwab', area: '8295'},
    { city: 'Altenstadt Hess', area: '6047'},
    { city: 'Altenstadt Iller', area: '8337'},
    { city: 'Altensteig Württ', area: '7453'},
    { city: 'Altenthann', area: '9408'},
    { city: 'Altentreptow', area: '3961'},
    { city: 'Altertheim', area: '9307'},
    { city: 'Altfraunhofen', area: '8705'},
    { city: 'Althegnenberg', area: '8202'},
    { city: 'Altkalen', area: '39973'},
    { city: 'Altkünkendorf', area: '33337'},
    { city: 'Altlandsberg', area: '33438'},
    { city: 'Altmannstein', area: '9446'},
    { city: 'Altmannstein-Pondorf', area: '8468'},
    { city: 'Altomünster', area: '8254'},
    { city: 'Altötting', area: '8671'},
    { city: 'Altreetz', area: '33457'},
    { city: 'Altshausen', area: '7584'},
    { city: 'Altusried', area: '8373'},
    { city: 'Altwarp', area: '39773'},
    { city: 'Alzenau i Ufr', area: '6023'},
    { city: 'Alzey', area: '6731'},
    { city: 'Amberg Oberpf', area: '9621'},
    { city: 'Amelinghausen', area: '4132'},
    { city: 'Amerang', area: '8075'},
    { city: 'Ammerbuch', area: '7073'},
    { city: 'Amorbach', area: '9373'},
    { city: 'Ampfing', area: '8636'},
    { city: 'Amrum', area: '4682'},
    { city: 'Andernach', area: '2632'},
    { city: 'Angelbachtal', area: '7265'},
    { city: 'Angelburg', area: '6464'},
    { city: 'Anger', area: '8656'},
    { city: 'Angermünde', area: '3331'},
    { city: 'Angern', area: '39363'},
    { city: 'Anhausen Kr Neuwied', area: '2639'},
    { city: 'Ankershagen', area: '39921'},
    { city: 'Anklam', area: '3971'},
    { city: 'Ankum', area: '5462'},
    { city: 'Annaberg-Buchholz', area: '3733'},
    { city: 'Annaburg', area: '35385'},
    { city: 'Annweiler am Trifels', area: '6346'},
    { city: 'Anröchte', area: '2947'},
    { city: 'Ansbach', area: '981'},
    { city: 'Ansbach-Katterbach', area: '9802'},
    { city: 'Antweiler', area: '2693'},
    { city: 'Apen', area: '4489'},
    { city: 'Apenburg', area: '39001'},
    { city: 'Apensen', area: '4167'},
    { city: 'Apolda', area: '3644'},
    { city: 'Appenweier', area: '7805'},
    { city: 'Arendsee Altmark', area: '39384'},
    { city: 'Arensdorf Kr Oder-Spree', area: '33635'},
    { city: 'Arenshausen', area: '36081'},
    { city: 'Argenbühl', area: '7566'},
    { city: 'Arnbruck', area: '9945'},
    { city: 'Arneburg', area: '39321'},
    { city: 'Arnsberg', area: '2931'},
    { city: 'Arnsberg-Oeventrop', area: '2937'},
    { city: 'Arnschwang', area: '9977'},
    { city: 'Arnsdorf b Dresden', area: '35200'},
    { city: 'Arnsgereuth', area: '36736'},
    { city: 'Arnstadt', area: '3628'},
    { city: 'Arnstein Unterfr', area: '9363'},
    { city: 'Arnstorf', area: '8723'},
    { city: 'Artern Unstrut', area: '3466'},
    { city: 'Arzberg b Torgau', area: '34222'},
    { city: 'Arzberg Oberfr', area: '9233'},
    { city: 'Asbach Westerw', area: '2683'},
    { city: 'Aschaffenburg', area: '6021'},
    { city: 'Aschau i Chiemgau', area: '8052'},
    { city: 'Aschau-Sachrang', area: '8057'},
    { city: 'Ascheberg Holstein', area: '4526'},
    { city: 'Ascheberg Westf', area: '2593'},
    { city: 'Ascheberg-Herbern', area: '2599'},
    { city: 'Ascheffel', area: '4353'},
    { city: 'Aschersleben Sachs-Anh', area: '3473'},
    { city: 'Asendorf Kr Diepholz', area: '4253'},
    { city: 'Attendorn', area: '2722'},
    { city: 'Attenkirchen', area: '8168'},
    { city: 'Attenweiler', area: '7357'},
    { city: 'Au b Bad Aibling', area: '8064'},
    { city: 'Au i d Hallertau', area: '8752'},
    { city: 'Aub Kr Würzburg', area: '9335'},
    { city: 'Aue Sachs', area: '3771'},
    { city: 'Auerbach i d Opf', area: '9643'},
    { city: 'Auerbach Vogtl', area: '3744'},
    { city: 'Auerswalde', area: '37208'},
    { city: 'Auetal-Bernsen', area: '5753'},
    { city: 'Auetal-Hattendorf', area: '5752'},
    { city: 'Aufhausen Oberpf', area: '9454'},
    { city: 'Augsburg', area: '821'},
    { city: 'Augustdorf', area: '5237'},
    { city: 'Augustusburg', area: '37291'},
    { city: 'Aukrug', area: '4873'},
    { city: 'Aulendorf', area: '7525'},
    { city: 'Auma', area: '36626'},
    { city: 'Aumühle b Hamburg', area: '4104'},
    { city: 'Aurach', area: '9804'},
    { city: 'Aurich', area: '4941'},
    { city: 'Aurich-Ogenbargen', area: '4947'},
    { city: 'Ausleben', area: '39404'},
    { city: 'Aying', area: '8095'},
    { city: 'Baar Schwaben', area: '8276'},
    { city: 'Babenhausen Hess', area: '6073'},
    { city: 'Babenhausen Schwab', area: '8333'},
    { city: 'Bacharach', area: '6743'},
    { city: 'Bachhagel', area: '9077'},
    { city: 'Backnang', area: '7191'},
    { city: 'Bad Abbach', area: '9405'},
    { city: 'Bad Aibling', area: '8061'},
    { city: 'Bad Arolsen', area: '5691'},
    { city: 'Bad Arolsen-Landau', area: '5696'},
    { city: 'Bad Bederkesa', area: '4745'},
    { city: 'Bad Bentheim', area: '5922'},
    { city: 'Bad Bentheim-Gildehaus', area: '5924'},
    { city: 'Bad Bergzabern', area: '6343'},
    { city: 'Bad Berka', area: '36458'},
    { city: 'Bad Berleburg', area: '2751'},
    { city: 'Bad Berleburg-Aue', area: '2759'},
    { city: 'Bad Berleburg-Girkhausen', area: '2758'},
    { city: 'Bad Berleburg-Schwarzenau', area: '2755'},
    { city: 'Bad Berneck i Fichtelgebirge', area: '9273'},
    { city: 'Bad Bertrich', area: '2674'},
    { city: 'Bad Bevensen', area: '5821'},
    { city: 'Bad Bibra', area: '34465'},
    { city: 'Bad Birnbach Rottal', area: '8563'},
    { city: 'Bad Blankenburg', area: '36741'},
    { city: 'Bad Bocklet', area: '9708'},
    { city: 'Bad Bodenteich', area: '5824'},
    { city: 'Bad Brambach', area: '37438'},
    { city: 'Bad Bramstedt', area: '4192'},
    { city: 'Bad Brückenau', area: '9741'},
    { city: 'Bad Buchau', area: '7582'},
    { city: 'Bad Camberg', area: '6434'},
    { city: 'Bad Colberg-Heldburg', area: '36871'},
    { city: 'Bad Doberan', area: '38203'},
    { city: 'Bad Driburg', area: '5253'},
    { city: 'Bad Driburg-Neuenheerse', area: '5259'},
    { city: 'Bad Düben', area: '34243'},
    { city: 'Bad Dürkheim', area: '6322'},
    { city: 'Bad Dürrenberg', area: '3462'},
    { city: 'Bad Dürrheim', area: '7726'},
    { city: 'Bad Elster', area: '37437'},
    { city: 'Bad Ems', area: '2603'},
    { city: 'Bad Emstal', area: '5624'},
    { city: 'Bad Endbach-Hartenrod', area: '2776'},
    { city: 'Bad Endorf', area: '8053'},
    { city: 'Bad Essen', area: '5472'},
    { city: 'Bad Feilnbach', area: '8066'},
    { city: 'Bad Frankenhausen Kyffhäuser', area: '34671'},
    { city: 'Bad Freienwalde', area: '3344'},
    { city: 'Bad Friedrichshall', area: '7136'},
    { city: 'Bad Füssing-Aigen', area: '8537'},
    { city: 'Bad Gandersheim', area: '5382'},
    { city: 'Bad Gottleuba', area: '35023'},
    { city: 'Bad Grönenbach', area: '8334'},
    { city: 'Bad Grund Harz', area: '5327'},
    { city: 'Bad Harzburg', area: '5322'},
    { city: 'Bad Heilbrunn', area: '8046'},
    { city: 'Bad Herrenalb', area: '7083'},
    { city: 'Bad Hersfeld', area: '6621'},
    { city: 'Bad Höhenstadt', area: '8506'},
    { city: 'Bad Homburg v d Höhe', area: '6172'},
    { city: 'Bad Honnef', area: '2224'},
    { city: 'Bad Iburg', area: '5403'},
    { city: 'Bad Karlshafen', area: '5672'},
    { city: 'Bad Kissingen', area: '971'},
    { city: 'Bad Kleinen', area: '38423'},
    { city: 'Bad Kohlgrub', area: '8845'},
    { city: 'Bad König', area: '6063'},
    { city: 'Bad Königshofen i Grabfeld', area: '9761'},
    { city: 'Bad Kösen', area: '34463'},
    { city: 'Bad Köstritz', area: '36605'},
    { city: 'Bad Kreuznach', area: '671'},
    { city: 'Bad Laasphe', area: '2752'},
    { city: 'Bad Laasphe-Feudingen', area: '2754'},
    { city: 'Bad Langensalza', area: '3603'},
    { city: 'Bad Lauchstädt', area: '34635'},
    { city: 'Bad Lausick', area: '34345'},
    { city: 'Bad Lauterberg im Harz', area: '5524'},
    { city: 'Bad Liebenstein', area: '36961'},
    { city: 'Bad Liebenwerda', area: '35341'},
    { city: 'Bad Liebenzell', area: '7052'},
    { city: 'Bad Lippspringe', area: '5252'},
    { city: 'Bad Marienberg Westerwald', area: '2661'},
    { city: 'Bad Mergentheim', area: '7931'},
    { city: 'Bad Münder am Deister', area: '5042'},
    { city: 'Bad Münster am Stein-Ebernburg', area: '6708'},
    { city: 'Bad Münstereifel', area: '2253'},
    { city: 'Bad Muskau', area: '35771'},
    { city: 'Bad Nauheim', area: '6032'},
    { city: 'Bad Nenndorf', area: '5723'},
    { city: 'Bad Neuenahr-Ahrweiler', area: '2641'},
    { city: 'Bad Neustadt a d Saale', area: '9771'},
    { city: 'Bad Oeynhausen', area: '5731'},
    { city: 'Bad Oldesloe', area: '4531'},
    { city: 'Bad Orb', area: '6052'},
    { city: 'Bad Peterstal-Griesbach', area: '7806'},
    { city: 'Bad Pyrmont', area: '5281'},
    { city: 'Bad Pyrmont-Kleinenberg', area: '5285'},
    { city: 'Bad Rappenau', area: '7264'},
    { city: 'Bad Rappenau-Bonfeld', area: '7066'},
    { city: 'Bad Rappenau-Obergimpern', area: '7268'},
    { city: 'Bad Rehburg', area: '5037'},
    { city: 'Bad Reichenhall', area: '8651'},
    { city: 'Bad Rippoldsau', area: '7440'},
    { city: 'Bad Rodach', area: '9564'},
    { city: 'Bad Rothenfelde', area: '5424'},
    { city: 'Bad Saarow-Pieskow', area: '33631'},
    { city: 'Bad Sachsa', area: '5523'},
    { city: 'Bad Säckingen', area: '7761'},
    { city: 'Bad Salzdetfurth', area: '5063'},
    { city: 'Bad Salzschlirf', area: '6648'},
    { city: 'Bad Salzuflen', area: '5222'},
    { city: 'Bad Salzungen', area: '3695'},
    { city: 'Bad Schandau', area: '35022'},
    { city: 'Bad Schmiedeberg', area: '34925'},
    { city: 'Bad Schönborn', area: '7253'},
    { city: 'Bad Schussenried', area: '7583'},
    { city: 'Bad Schwalbach', area: '6124'},
    { city: 'Bad Segeberg', area: '4551'},
    { city: 'Bad Sobernheim', area: '6751'},
    { city: 'Bad Soden am Taunus', area: '6196'},
    { city: 'Bad Soden-Salmünster', area: '6056'},
    { city: 'Bad Sooden-Allendorf', area: '5652'},
    { city: 'Bad Steben', area: '9288'},
    { city: 'Bad Sulza', area: '36461'},
    { city: 'Bad Sülze', area: '38229'},
    { city: 'Bad Teinach-Zavelstein', area: '7053'},
    { city: 'Bad Tennstedt', area: '36041'},
    { city: 'Bad Tölz', area: '8041'},
    { city: 'Bad Urach', area: '7125'},
    { city: 'Bad Vilbel', area: '6101'},
    { city: 'Bad Waldsee', area: '7524'},
    { city: 'Bad Wildbad', area: '7081'},
    { city: 'Bad Wildungen', area: '5621'},
    { city: 'Bad Wilsnack', area: '38791'},
    { city: 'Bad Wimpfen', area: '7063'},
    { city: 'Bad Windsheim', area: '9841'},
    { city: 'Bad Wörishofen', area: '8247'},
    { city: 'Bad Wurzach', area: '7564'},
    { city: 'Bad Wurzach-Hauerz', area: '7568'},
    { city: 'Bad Zwesten', area: '5626'},
    { city: 'Bad Zwischenahn', area: '4403'},
    { city: 'Badbergen', area: '5433'},
    { city: 'Baddeckenstedt', area: '5345'},
    { city: 'Badel', area: '39009'},
    { city: 'Baden-Baden', area: '7221'},
    { city: 'Badenweiler', area: '7632'},
    { city: 'Badersleben', area: '39422'},
    { city: 'Baesweiler', area: '2401'},
    { city: 'Bagenz', area: '35697'},
    { city: 'Bahrdorf-Mackendorf', area: '5358'},
    { city: 'Bahro', area: '33656'},
    { city: 'Baiersbronn', area: '7442'},
    { city: 'Baiersbronn-Obertal', area: '7449'},
    { city: 'Baiersbronn-Schwarzenberg', area: '7447'},
    { city: 'Baiersdorf Mittelfr', area: '9133'},
    { city: 'Baisweil', area: '8340'},
    { city: 'Bakum Kr Vechta', area: '4446'},
    { city: 'Bakum-Lüsche', area: '5438'},
    { city: 'Balderschwang', area: '8328'},
    { city: 'Balingen', area: '7433'},
    { city: 'Balje', area: '4753'},
    { city: 'Ballenstedt', area: '39483'},
    { city: 'Baltrum', area: '4939'},
    { city: 'Balve', area: '2375'},
    { city: 'Bamberg', area: '951'},
    { city: 'Barby Elbe', area: '39298'},
    { city: 'Barderup', area: '4630'},
    { city: 'Barendorf', area: '4137'},
    { city: 'Bärenklau NL', area: '35691'},
    { city: 'Bärenstein Kr Annaberg', area: '37347'},
    { city: 'Bargteheide', area: '4532'},
    { city: 'Barleben', area: '39203'},
    { city: 'Barlt', area: '4857'},
    { city: 'Barmstedt', area: '4123'},
    { city: 'Bärnau', area: '9635'},
    { city: 'Barnstorf Kr Diepholz', area: '5442'},
    { city: 'Barntrup', area: '5263'},
    { city: 'Barsinghausen', area: '5105'},
    { city: 'Barssel', area: '4499'},
    { city: 'Barßel-Harkebrügge', area: '4497'},
    { city: 'Bartensleben', area: '39050'},
    { city: 'Barth', area: '38231'},
    { city: 'Barum b Bad Bevensen', area: '5806'},
    { city: 'Baruth Mark', area: '33704'},
    { city: 'Barver', area: '5448'},
    { city: 'Basdahl', area: '4766'},
    { city: 'Basslitz', area: '35249'},
    { city: 'Bassum', area: '4241'},
    { city: 'Bassum-Neubruchhausen', area: '4248'},
    { city: 'Bassum-Nordwohlde', area: '4249'},
    { city: 'Basthorst', area: '4159'},
    { city: 'Battenberg Eder', area: '6452'},
    { city: 'Baumgarten Meckl', area: '38462'},
    { city: 'Baumholder', area: '6783'},
    { city: 'Baunach', area: '9544'},
    { city: 'Bautzen', area: '3591'},
    { city: 'Bawinkel', area: '5963'},
    { city: 'Bayerbach b Ergoldsbach', area: '8774'},
    { city: 'Bayerisch Eisenstein', area: '9925'},
    { city: 'Bayreuth', area: '921'},
    { city: 'Bayrischzell', area: '8023'},
    { city: 'Bebertal', area: '39062'},
    { city: 'Bebra', area: '6622'},
    { city: 'Bechenheim', area: '6736'},
    { city: 'Becherbach bei Kirn', area: '6757'},
    { city: 'Bechhofen a d Heide', area: '9822'},
    { city: 'Beckingen', area: '6835'},
    { city: 'Beckingen-Reimsbach', area: '6832'},
    { city: 'Beckum', area: '2521'},
    { city: 'Beckum-Neubeckum', area: '2525'},
    { city: 'Bedburg Erft', area: '2272'},
    { city: 'Beedenbostel', area: '5145'},
    { city: 'Beelen', area: '2586'},
    { city: 'Beelitz Mark', area: '33204'},
    { city: 'Beenz b Prenzlau', area: '39856'},
    { city: 'Beerfelde', area: '33637'},
    { city: 'Beerfelden', area: '6068'},
    { city: 'Beeskow', area: '3366'},
    { city: 'Beesten', area: '5905'},
    { city: 'Beetzendorf', area: '39000'},
    { city: 'Behrenhoff', area: '38356'},
    { city: 'Beilngries', area: '8461'},
    { city: 'Beilstein Württ', area: '7062'},
    { city: 'Beimerstetten', area: '7348'},
    { city: 'Belgern Sachs', area: '34224'},
    { city: 'Bellingen b Stendal', area: '39365'},
    { city: 'Belm', area: '5406'},
    { city: 'Belzig', area: '33841'},
    { city: 'Bendingbostel', area: '4237'},
    { city: 'Bendorf Rhein', area: '2622'},
    { city: 'Benediktbeuern', area: '8857'},
    { city: 'Benneckenstein Harz', area: '39457'},
    { city: 'Bennin', area: '38843'},
    { city: 'Bensberg', area: '2204'},
    { city: 'Benshausen', area: '36843'},
    { city: 'Bensheim', area: '6251'},
    { city: 'Benz Usedom', area: '38379'},
    { city: 'Beratzhausen', area: '9493'},
    { city: 'Berau', area: '7747'},
    { city: 'Berching', area: '8462'},
    { city: 'Berching-Holnstein', area: '8460'},
    { city: 'Berchtesgaden', area: '8652'},
    { city: 'Berg b Neumarkt i d Opf', area: '9189'},
    { city: 'Berg Oberfr', area: '9293'},
    { city: 'Berga Elster', area: '36623'},
    { city: 'Berge b Perleberg', area: '38785'},
    { city: 'Berge b Quakenbrück', area: '5435'},
    { city: 'Bergen auf Rügen', area: '3838'},
    { city: 'Bergen Dumme', area: '5845'},
    { city: 'Bergen Kr Celle', area: '5051'},
    { city: 'Bergen Vogtl', area: '37463'},
    { city: 'Bergenhusen', area: '4885'},
    { city: 'Bergen-Sülze', area: '5054'},
    { city: 'Bergheim Erft', area: '2271'},
    { city: 'Bergholz-Rehbrücke', area: '33200'},
    { city: 'Bergisch Gladbach', area: '2202'},
    { city: 'Bergkirchen Westf', area: '5734'},
    { city: 'Berkenbrück Kr Oder-Spree', area: '33634'},
    { city: 'Berkenthin', area: '4544'},
    { city: 'Berlin', area: '30'},
    { city: 'Berlstedt', area: '36452'},
    { city: 'Bernau Baden', area: '7675'},
    { city: 'Bernau Brandenb', area: '3338'},
    { city: 'Bernbeuren', area: '8860'},
    { city: 'Bernburg Saale', area: '3471'},
    { city: 'Berne', area: '4406'},
    { city: 'Bernitt', area: '38464'},
    { city: 'Bernkastel-Kues', area: '6531'},
    { city: 'Bernried Niederbay', area: '9905'},
    { city: 'Bernsdorf OL', area: '35723'},
    { city: 'Bernstadt a d Eigen', area: '35874'},
    { city: 'Bersenbrück', area: '5439'},
    { city: 'Beselich', area: '6484'},
    { city: 'Besigheim', area: '7143'},
    { city: 'Bessenbach', area: '6095'},
    { city: 'Bestensee', area: '33763'},
    { city: 'Bestwig', area: '2904'},
    { city: 'Bestwig-Ramsbeck', area: '2905'},
    { city: 'Bettenhausen Thür', area: '36943'},
    { city: 'Betzdorf', area: '2741'},
    { city: 'Betzendorf Kr Lünebeburg', area: '4138'},
    { city: 'Betzenstein', area: '9244'},
    { city: 'Beuren Hochwald', area: '6586'},
    { city: 'Beuron', area: '7466'},
    { city: 'Beverstedt', area: '4747'},
    { city: 'Beverungen', area: '5273'},
    { city: 'Bexbach', area: '6826'},
    { city: 'Biberach an der Riß', area: '7351'},
    { city: 'Bibertal', area: '8226'},
    { city: 'Biblis', area: '6245'},
    { city: 'Bickendorf', area: '6569'},
    { city: 'Bidingen', area: '8348'},
    { city: 'Biebergemünd', area: '6050'},
    { city: 'Biebertal', area: '6409'},
    { city: 'Biedenkopf', area: '6461'},
    { city: 'Biederitz', area: '39292'},
    { city: 'Bielefeld', area: '521'},
    { city: 'Bielefeld-Jöllenbeck', area: '5206'},
    { city: 'Bielefeld-Sennestadt', area: '5205'},
    { city: 'Bienenbüttel', area: '5823'},
    { city: 'Biesenthal Brandenb', area: '3337'},
    { city: 'Bietigheim-Bissingen', area: '7142'},
    { city: 'Bietikow', area: '39858'},
    { city: 'Billerbeck Westf', area: '2543'},
    { city: 'Billigheim Baden', area: '6265'},
    { city: 'Billigheim-Ingenheim', area: '6349'},
    { city: 'Binde', area: '39036'},
    { city: 'Bindlach', area: '9208'},
    { city: 'Bingen am Rhein', area: '6721'},
    { city: 'Binz Ostseebad', area: '38393'},
    { city: 'Birkenfeld b Würzburg', area: '9398'},
    { city: 'Birkenfeld Nahe', area: '6782'},
    { city: 'Birkenhainchen', area: '35471'},
    { city: 'Birkenwerder', area: '3303'},
    { city: 'Birresborn', area: '6594'},
    { city: 'Birstein', area: '6054'},
    { city: 'Birstein-Lichenroth', area: '6668'},
    { city: 'Bischoffen', area: '6444'},
    { city: 'Bischofsgrün', area: '9276'},
    { city: 'Bischofsheim a d Rhön', area: '9772'},
    { city: 'Bischofsheim b Rüsselsheim', area: '6144'},
    { city: 'Bischofsmais', area: '9920'},
    { city: 'Bischofswerda', area: '3594'},
    { city: 'Bisingen', area: '7476'},
    { city: 'Bismark Altmark', area: '39089'},
    { city: 'Bispingen', area: '5194'},
    { city: 'Bissendorf Kr Osnabrück', area: '5402'},
    { city: 'Bissingen Schwab', area: '9084'},
    { city: 'Bissingen-Unterringingen', area: '9089'},
    { city: 'Bitburg', area: '6561'},
    { city: 'Bitterfeld', area: '3493'},
    { city: 'Blankenburg Harz', area: '3944'},
    { city: 'Blankenförde', area: '39829'},
    { city: 'Blankenhain Thür', area: '36459'},
    { city: 'Blankenheim Ahr', area: '2449'},
    { city: 'Blankenheim b Sangerhausen', area: '34659'},
    { city: 'Blankenheim-Ahrhütte', area: '2697'},
    { city: 'Blankenrath', area: '6545'},
    { city: 'Blankensee b Neustrelitz', area: '39826'},
    { city: 'Blaubeuren', area: '7344'},
    { city: 'Blaufelden', area: '7953'},
    { city: 'Blaustein Württ', area: '7304'},
    { city: 'Bleckede', area: '5852'},
    { city: 'Bleckede-Barskamp', area: '5854'},
    { city: 'Bleckede-Brackede', area: '5857'},
    { city: 'Bleialf', area: '6555'},
    { city: 'Bleicherode', area: '36338'},
    { city: 'Blender', area: '4233'},
    { city: 'Blieskastel', area: '6842'},
    { city: 'Blieskastel-Altheim', area: '6844'},
    { city: 'Blomberg Lippe', area: '5235'},
    { city: 'Blomberg Ostfriesl', area: '4977'},
    { city: 'Blomberg-Grossenmarpe', area: '5236'},
    { city: 'Blönsdorf', area: '33743'},
    { city: 'Blowatz', area: '38427'},
    { city: 'Blumberg Baden', area: '7702'},
    { city: 'Blumberg Kr Barnim', area: '33394'},
    { city: 'Blumenhagen b Strasburg', area: '39752'},
    { city: 'Blumenthal b Pritzwalk', area: '33984'},
    { city: 'Blunk', area: '4557'},
    { city: 'Bobenheim-Roxheim', area: '6239'},
    { city: 'Bobenneukirchen', area: '37434'},
    { city: 'Bobingen', area: '8234'},
    { city: 'Bobitz', area: '38424'},
    { city: 'Böblingen', area: '7031'},
    { city: 'Bocholt', area: '2871'},
    { city: 'Bochum', area: '234'},
    { city: 'Bochum-Wattenscheid', area: '2327'},
    { city: 'Bockenem', area: '5067'},
    { city: 'Bodenburg', area: '5060'},
    { city: 'Bodenfelde', area: '5572'},
    { city: 'Bodenheim Rhein', area: '6135'},
    { city: 'Bodenkirchen', area: '8745'},
    { city: 'Bodenmais', area: '9924'},
    { city: 'Bodenwerder', area: '5533'},
    { city: 'Bodenwöhr', area: '9434'},
    { city: 'Bodman-Ludwigshafen', area: '7773'},
    { city: 'Bodnegg', area: '7520'},
    { city: 'Bogen Niederbay', area: '9422'},
    { city: 'Böhen', area: '8338'},
    { city: 'Böhmfeld', area: '8406'},
    { city: 'Bohmte', area: '5471'},
    { city: 'Bohmte-Hunteburg', area: '5475'},
    { city: 'Boitzenburg', area: '39889'},
    { city: 'Boizenburg Elbe', area: '38847'},
    { city: 'Bokhorst', area: '4394'},
    { city: 'Böklund', area: '4623'},
    { city: 'Boll Kr Göppingen', area: '7164'},
    { city: 'Bollendorf', area: '6526'},
    { city: 'Bönen', area: '2383'},
    { city: 'Bonese', area: '39039'},
    { city: 'Bonn', area: '228'},
    { city: 'Bonndorf im Schwarzwald', area: '7703'},
    { city: 'Boossen', area: '33605'},
    { city: 'Boostedt', area: '4393'},
    { city: 'Bopfingen', area: '7362'},
    { city: 'Boppard', area: '6742'},
    { city: 'Bordesholm', area: '4322'},
    { city: 'Borgentreich', area: '5643'},
    { city: 'Borgentreich-Borgholz', area: '5645'},
    { city: 'Börger', area: '5953'},
    { city: 'Borgholzhausen', area: '5425'},
    { city: 'Borken Hessen', area: '5682'},
    { city: 'Borken Westf', area: '2861'},
    { city: 'Borkenfriede', area: '39777'},
    { city: 'Borkheide', area: '33845'},
    { city: 'Borkum', area: '4922'},
    { city: 'Born a Darß', area: '38234'},
    { city: 'Borna Stadt', area: '3433'},
    { city: 'Bornheim Rheinl', area: '2222'},
    { city: 'Bornheim-Merten', area: '2227'},
    { city: 'Bornhöved', area: '4323'},
    { city: 'Börnicke Kr Havelland', area: '33230'},
    { city: 'Borsdorf', area: '34291'},
    { city: 'Borstel b Sulingen', area: '4276'},
    { city: 'Bosau', area: '4527'},
    { city: 'Bösel Oldenburg', area: '4494'},
    { city: 'Bötersen', area: '4268'},
    { city: 'Bottrop', area: '2041'},
    { city: 'Bottrop-Kirchhellen', area: '2045'},
    { city: 'Bous', area: '6834'},
    { city: 'Bovenden-Lenglern', area: '5593'},
    { city: 'Bovenden-Reyershausen', area: '5594'},
    { city: 'Boxberg Baden', area: '7930'},
    { city: 'Boxberg Sachs', area: '35774'},
    { city: 'Brachbach Sieg', area: '2745'},
    { city: 'Brackenheim', area: '7135'},
    { city: 'Brake Unterweser', area: '4401'},
    { city: 'Brakel Westf', area: '5272'},
    { city: 'Brakel-Gehrden', area: '5648'},
    { city: 'Bramsche Hase', area: '5461'},
    { city: 'Bramsche-Engter', area: '5468'},
    { city: 'Brandenburg an der Havel', area: '3381'},
    { city: 'Brand-Erbisdorf', area: '37322'},
    { city: 'Brandis b Wurzen', area: '34292'},
    { city: 'Brannenburg', area: '8034'},
    { city: 'Braubach', area: '2627'},
    { city: 'Braunfels', area: '6442'},
    { city: 'Braunlage', area: '5520'},
    { city: 'Braunlage-Hohegeiss', area: '5583'},
    { city: 'Bräunlingen', area: '7707'},
    { city: 'Braunsbach', area: '7906'},
    { city: 'Braunsbedra', area: '34633'},
    { city: 'Braunschweig', area: '531'},
    { city: 'Braunschweig-Wenden', area: '5307'},
    { city: 'Breckerfeld', area: '2338'},
    { city: 'Breddin', area: '33972'},
    { city: 'Bredenbek b Rendsburg', area: '4334'},
    { city: 'Bredenfelde b Strasburg', area: '3964'},
    { city: 'Bredereiche', area: '33087'},
    { city: 'Bredstedt', area: '4671'},
    { city: 'Breidenbach b Biedenkopf', area: '6465'},
    { city: 'Breisach am Rhein', area: '7667'},
    { city: 'Breitbrunn a Chiemsee', area: '8054'},
    { city: 'Breitenbach a Herzberg', area: '6675'},
    { city: 'Breitenberg Niederbay', area: '8584'},
    { city: 'Breitenbrunn Erzgeb', area: '37756'},
    { city: 'Breitenbrunn Oberpf', area: '9495'},
    { city: 'Breitenbrunn Schwab', area: '8263'},
    { city: 'Breitscheid Hess', area: '2777'},
    { city: 'Bremen', area: '421'},
    { city: 'Bremerhaven', area: '471'},
    { city: 'Bremervörde', area: '4761'},
    { city: 'Bremervörde-Bevern', area: '4767'},
    { city: 'Bremervörde-Iselersheim', area: '4769'},
    { city: 'Brennberg', area: '9484'},
    { city: 'Brensbach', area: '6161'},
    { city: 'Bretten', area: '7252'},
    { city: 'Bretzfeld', area: '7946'},
    { city: 'Breuberg', area: '6165'},
    { city: 'Brielow', area: '33837'},
    { city: 'Brieselang', area: '33232'},
    { city: 'Briesen b Cottbus', area: '35606'},
    { city: 'Briesen Mark', area: '33607'},
    { city: 'Brieskow-Finkenheerd', area: '33609'},
    { city: 'Briesnig', area: '35696'},
    { city: 'Brilon', area: '2961'},
    { city: 'Brilon-Alme', area: '2964'},
    { city: 'Brilon-Messinghausen', area: '2963'},
    { city: 'Brockel', area: '4266'},
    { city: 'Broderstorf', area: '38204'},
    { city: 'Brohl-Lützing', area: '2633'},
    { city: 'Brokstedt', area: '4324'},
    { city: 'Brome', area: '5833'},
    { city: 'Bruchhausen-Vilsen', area: '4252'},
    { city: 'Bruchmühlbach-Miesau', area: '6372'},
    { city: 'Bruchmühlen Westf', area: '5226'},
    { city: 'Bruchsal', area: '7251'},
    { city: 'Bruchsal-Untergrombach', area: '7257'},
    { city: 'Brück Brandenb', area: '33844'},
    { city: 'Bruckberg Niederbay', area: '8765'},
    { city: 'Bruckmühl Mangfall', area: '8062'},
    { city: 'Brüel', area: '38483'},
    { city: 'Brühl Rheinl', area: '2232'},
    { city: 'Brunau', area: '39030'},
    { city: 'Brunsbüttel', area: '4852'},
    { city: 'Brüssow b Pasewalk', area: '39742'},
    { city: 'Buch b Illertissen', area: '7343'},
    { city: 'Buchbach Oberbay', area: '8086'},
    { city: 'Büchel b Cochem', area: '2678'},
    { city: 'Büchen', area: '4155'},
    { city: 'Buchen Odenwald', area: '6281'},
    { city: 'Buchenberg b Kempten', area: '8378'},
    { city: 'Büchenbeuren', area: '6543'},
    { city: 'Buchholz in der Nordheide', area: '4181'},
    { city: 'Buchholz-Trelde', area: '4186'},
    { city: 'Buchloe', area: '8241'},
    { city: 'Bückeburg', area: '5722'},
    { city: 'Buckow Märk Schweiz', area: '33433'},
    { city: 'Büden', area: '39224'},
    { city: 'Budenheim', area: '6139'},
    { city: 'Büdesheim Eifel', area: '6558'},
    { city: 'Büdingen Hess', area: '6042'},
    { city: 'Büdingen-Eckartshausen', area: '6048'},
    { city: 'Büdlich', area: '6509'},
    { city: 'Bühl Baden', area: '7223'},
    { city: 'Bühlerzell', area: '7974'},
    { city: 'Bühl-Sand', area: '7226'},
    { city: 'Bühnsdorf', area: '4550'},
    { city: 'Bülkau', area: '4754'},
    { city: 'Bullay', area: '6542'},
    { city: 'Bunde', area: '4953'},
    { city: 'Bünde', area: '5223'},
    { city: 'Bundenthal', area: '6394'},
    { city: 'Burbach Siegerl', area: '2736'},
    { city: 'Büren', area: '2951'},
    { city: 'Büren-Harth', area: '2958'},
    { city: 'Büren-Wewelsburg', area: '2955'},
    { city: 'Burg auf Fehmarn', area: '4371'},
    { city: 'Burg b Magdeburg', area: '3921'},
    { city: 'Burg Dithmarschen', area: '4825'},
    { city: 'Burg Spreewald', area: '35603'},
    { city: 'Burg Stargard', area: '39603'},
    { city: 'Burgau Schwab', area: '8222'},
    { city: 'Burgbernheim', area: '9843'},
    { city: 'Burgbrohl', area: '2636'},
    { city: 'Burgdorf b Salzgitter', area: '5347'},
    { city: 'Burgdorf Kr Hannover', area: '5136'},
    { city: 'Burgdorf-Ehlershausen', area: '5085'},
    { city: 'Burgebrach', area: '9546'},
    { city: 'Bürgel', area: '36692'},
    { city: 'Burghammer', area: '35727'},
    { city: 'Burghaslach', area: '9552'},
    { city: 'Burghaun', area: '6653'},
    { city: 'Burghausen Salzach', area: '8677'},
    { city: 'Burgheim', area: '8432'},
    { city: 'Burgkirchen a d Alz', area: '8679'},
    { city: 'Burgkunstadt', area: '9572'},
    { city: 'Burglengenfeld', area: '9471'},
    { city: 'Burgoberbach', area: '9805'},
    { city: 'Burgpreppach', area: '9534'},
    { city: 'Burgsinn', area: '9356'},
    { city: 'Burgstädt', area: '3724'},
    { city: 'Burgthann', area: '9183'},
    { city: 'Burgwald Eder', area: '6457'},
    { city: 'Burgwedel', area: '5139'},
    { city: 'Burgwedel-Fuhrberg', area: '5135'},
    { city: 'Burgwindheim', area: '9551'},
    { city: 'Burkardroth', area: '9734'},
    { city: 'Burkau', area: '35953'},
    { city: 'Burkhardswalde-Munzig', area: '35245'},
    { city: 'Burladingen', area: '7475'},
    { city: 'Burladingen-Melchingen', area: '7126'},
    { city: 'Burow b Altentreptow', area: '3965'},
    { city: 'Burscheid Rheinl', area: '2174'},
    { city: 'Burtenbach', area: '8285'},
    { city: 'Buschow', area: '33876'},
    { city: 'Buseck', area: '6408'},
    { city: 'Büsum', area: '4834'},
    { city: 'Butjadingen-Burhave', area: '4733'},
    { city: 'Butjadingen-Stollhamm', area: '4735'},
    { city: 'Butjadingen-Tossens', area: '4736'},
    { city: 'Buttelstedt', area: '36451'},
    { city: 'Buttenheim', area: '9545'},
    { city: 'Buttenwiesen', area: '8274'},
    { city: 'Bütthard', area: '9336'},
    { city: 'Buttstädt', area: '36373'},
    { city: 'Butzbach', area: '6033'},
    { city: 'Bützow', area: '38461'},
    { city: 'Butzow b Brandenburg', area: '33836'},
    { city: 'Buxtehude', area: '4161'},
    { city: 'Cadenberge', area: '4777'},
    { city: 'Cadolzburg', area: '9103'},
    { city: 'Calau', area: '3541'},
    { city: 'Calbe Saale', area: '39291'},
    { city: 'Calden-Westuffeln', area: '5677'},
    { city: 'Calvörde', area: '39051'},
    { city: 'Calw', area: '7051'},
    { city: 'Cambs', area: '3866'},
    { city: 'Camburg', area: '36421'},
    { city: 'Cappeln Oldenburg', area: '4478'},
    { city: 'Caputh', area: '33209'},
    { city: 'Carlow', area: '38873'},
    { city: 'Carlsberg Pfalz', area: '6356'},
    { city: 'Carpin', area: '39821'},
    { city: 'Casekow', area: '33331'},
    { city: 'Castrop-Rauxel', area: '2305'},
    { city: 'Cavertitz', area: '34363'},
    { city: 'Celle', area: '5141'},
    { city: 'Celle-Scheuen', area: '5086'},
    { city: 'Cham', area: '9971'},
    { city: 'Chemnitz Sachs', area: '371'},
    { city: 'Chieming', area: '8664'},
    { city: 'Chorin', area: '33366'},
    { city: 'Christiansholm', area: '4339'},
    { city: 'Claussnitz b Chemnitz', area: '37202'},
    { city: 'Clausthal-Zellerfeld', area: '5323'},
    { city: 'Clenze', area: '5844'},
    { city: 'Cloppenburg', area: '4471'},
    { city: 'Cobbelsdorf', area: '34923'},
    { city: 'Coburg', area: '9561'},
    { city: 'Cochem', area: '2671'},
    { city: 'Coesfeld', area: '2541'},
    { city: 'Coesfeld-Lette', area: '2546'},
    { city: 'Cölbe-Schönstadt', area: '6427'},
    { city: 'Colbitz', area: '39207'},
    { city: 'Colditz', area: '34381'},
    { city: 'Collenberg', area: '9376'},
    { city: 'Colmberg', area: '9803'},
    { city: 'Colnrade', area: '4434'},
    { city: 'Cölpin', area: '3966'},
    { city: 'Coppenbrügge', area: '5156'},
    { city: 'Coppenbrügge-Bisperode', area: '5159'},
    { city: 'Cornberg', area: '5650'},
    { city: 'Coswig Anhalt', area: '34903'},
    { city: 'Coswig b Dresden', area: '3523'},
    { city: 'Cottbus', area: '355'},
    { city: 'Crailsheim', area: '7951'},
    { city: 'Cranzahl', area: '37342'},
    { city: 'Creglingen', area: '7933'},
    { city: 'Cremlingen', area: '5306'},
    { city: 'Creussen', area: '9270'},
    { city: 'Creuzburg', area: '36926'},
    { city: 'Crimmitschau', area: '3762'},
    { city: 'Crinitz', area: '35324'},
    { city: 'Crivitz', area: '3863'},
    { city: 'Crossen an der Elster', area: '36693'},
    { city: 'Crottendorf Sachs', area: '37344'},
    { city: 'Cumlosen', area: '38794'},
    { city: 'Cunewalde', area: '35877'},
    { city: 'Cuxhaven', area: '4721'},
    { city: 'Cuxhaven-Altenbruch', area: '4722'},
    { city: 'Cuxhaven-Altenwalde', area: '4723'},
    { city: 'Cuxhaven-Lüdingworth', area: '4724'},
    { city: 'Daaden', area: '2743'},
    { city: 'Dabel', area: '38485'},
    { city: 'Daberkow', area: '39991'},
    { city: 'Dabringhausen', area: '2193'},
    { city: 'Dachau', area: '8131'},
    { city: 'Dachsbach', area: '9163'},
    { city: 'Dachsenhausen', area: '6776'},
    { city: 'Dagebüll', area: '4667'},
    { city: 'Dahlem b Kall', area: '2447'},
    { city: 'Dahlen Sachs', area: '34361'},
    { city: 'Dahlenburg', area: '5851'},
    { city: 'Dahme Brandenb', area: '35451'},
    { city: 'Dahme Kr Ostholstein', area: '4364'},
    { city: 'Dahn', area: '6391'},
    { city: 'Dähre', area: '39031'},
    { city: 'Dallmin', area: '38783'},
    { city: 'Dambeck b Röbel', area: '39922'},
    { city: 'Damme Dümmer', area: '5491'},
    { city: 'Damp', area: '4352'},
    { city: 'Dänischenhagen', area: '4349'},
    { city: 'Dannenberg Elbe', area: '5861'},
    { city: 'Dannenwalde Kr Prignitz', area: '33975'},
    { city: 'Dargun', area: '39959'},
    { city: 'Darmstadt', area: '6151'},
    { city: 'Dasing', area: '8205'},
    { city: 'Dassel', area: '5564'},
    { city: 'Dassel-Markoldendorf', area: '5562'},
    { city: 'Dassow', area: '38826'},
    { city: 'Datteln', area: '2363'},
    { city: 'Daun', area: '6592'},
    { city: 'Dautphetal-Friedensdorf', area: '6466'},
    { city: 'Dautphetal-Mornshausen', area: '6468'},
    { city: 'Deggendorf', area: '991'},
    { city: 'Deggenhausertal', area: '7555'},
    { city: 'Deggingen', area: '7334'},
    { city: 'Deidesheim', area: '6326'},
    { city: 'Deining Oberpf', area: '9184'},
    { city: 'Deisslingen', area: '7420'},
    { city: 'Delbrück Westf', area: '5250'},
    { city: 'Delitzsch', area: '34202'},
    { city: 'Dellfeld', area: '6336'},
    { city: 'Delligsen', area: '5187'},
    { city: 'Delmenhorst', area: '4221'},
    { city: 'Demen', area: '38488'},
    { city: 'Demmin', area: '3998'},
    { city: 'Denkendorf Oberbay', area: '8466'},
    { city: 'Dentlein a Forst', area: '9855'},
    { city: 'Denzlingen', area: '7666'},
    { city: 'Derenburg', area: '39453'},
    { city: 'Dergenthin', area: '38793'},
    { city: 'Dermbach Rhön', area: '36964'},
    { city: 'Dessau Anh', area: '340'},
    { city: 'Dessow', area: '33974'},
    { city: 'Detern', area: '4957'},
    { city: 'Detmold', area: '5231'},
    { city: 'Dettelbach', area: '9324'},
    { city: 'Dettmannsdorf-Kölzow', area: '38228'},
    { city: 'Dettum', area: '5333'},
    { city: 'Deutschneudorf', area: '37368'},
    { city: 'Dieburg', area: '6071'},
    { city: 'Diedenshausen', area: '2750'},
    { city: 'Diedorf b Mühlhausen Thür', area: '36024'},
    { city: 'Diedrichshagen b Grevesmühlen', area: '38822'},
    { city: 'Diemelsee', area: '5633'},
    { city: 'Diemelstadt', area: '5694'},
    { city: 'Diepenau', area: '5775'},
    { city: 'Diepenau-Essern', area: '5777'},
    { city: 'Diepholz', area: '5441'},
    { city: 'Dierdorf', area: '2689'},
    { city: 'Dierhagen Ostseebad', area: '38226'},
    { city: 'Diesbar-Seusslitz', area: '35267'},
    { city: 'Diesdorf Altm', area: '3902'},
    { city: 'Dießen a Ammersee', area: '8807'},
    { city: 'Dietenheim', area: '7347'},
    { city: 'Dietenhofen', area: '9824'},
    { city: 'Dietersburg-Baumgarten', area: '8565'},
    { city: 'Dietfurt a d Altmühl', area: '8464'},
    { city: 'Dietmannsried', area: '8374'},
    { city: 'Dietramszell', area: '8027'},
    { city: 'Dietzhölztal', area: '2774'},
    { city: 'Diez', area: '6432'},
    { city: 'Dillenburg', area: '2771'},
    { city: 'Dillingen a d Donau', area: '9071'},
    { city: 'Dingelstädt Eichsfeld', area: '36075'},
    { city: 'Dingelstedt a Huy', area: '39425'},
    { city: 'Dingolfing', area: '8731'},
    { city: 'Dinkelsbühl', area: '9851'},
    { city: 'Dinkelscherben', area: '8292'},
    { city: 'Dinklage', area: '4443'},
    { city: 'Dinslaken', area: '2064'},
    { city: 'Dippmannsdorf', area: '33846'},
    { city: 'Dippoldiswalde', area: '3504'},
    { city: 'Dirlewang', area: '8267'},
    { city: 'Dirmstein', area: '6238'},
    { city: 'Dischingen', area: '7327'},
    { city: 'Dissen am Teutoburger Wald', area: '5421'},
    { city: 'Dittersdorf b Schleiz', area: '36648'},
    { city: 'Ditzingen', area: '7156'},
    { city: 'Döbeln', area: '3431'},
    { city: 'Doberlug-Kirchhain', area: '35322'},
    { city: 'Döbern NL', area: '35600'},
    { city: 'Dobitschen', area: '34495'},
    { city: 'Dobritz', area: '39248'},
    { city: 'Dockweiler', area: '6595'},
    { city: 'Dollart', area: '4959'},
    { city: 'Dolle', area: '39364'},
    { city: 'Dollenchen', area: '35329'},
    { city: 'Dollnstein', area: '8422'},
    { city: 'Dömitz', area: '38758'},
    { city: 'Dommitzsch', area: '34223'},
    { city: 'Domsühl', area: '38728'},
    { city: 'Donaueschingen', area: '771'},
    { city: 'Donaustauf', area: '9403'},
    { city: 'Donauwörth', area: '906'},
    { city: 'Donnersdorf', area: '9528'},
    { city: 'Dörentrup', area: '5265'},
    { city: 'Dorfen Stadt', area: '8081'},
    { city: 'Dormagen', area: '2133'},
    { city: 'Dornburg Hess', area: '6436'},
    { city: 'Dornburg Saale', area: '36427'},
    { city: 'Dorndorf Rhön', area: '36963'},
    { city: 'Dornhan', area: '7455'},
    { city: 'Dornstetten', area: '7443'},
    { city: 'Dornum Ostfriesl', area: '4933'},
    { city: 'Dörpen', area: '4963'},
    { city: 'Dörpstedt', area: '4627'},
    { city: 'Dorsten', area: '2362'},
    { city: 'Dorsten-Rhade', area: '2866'},
    { city: 'Dorsten-Wulfen', area: '2369'},
    { city: 'Dortmund', area: '231'},
    { city: 'Dorum', area: '4742'},
    { city: 'Dörverden', area: '4234'},
    { city: 'Dörverden-Westen', area: '4239'},
    { city: 'Dörzbach', area: '7937'},
    { city: 'Dötlingen', area: '4433'},
    { city: 'Dötlingen-Brettorf', area: '4432'},
    { city: 'Drachhausen', area: '35609'},
    { city: 'Drage Elbe', area: '4177'},
    { city: 'Drahnsdorf', area: '35453'},
    { city: 'Drangstedt', area: '4704'},
    { city: 'Dranse', area: '33966'},
    { city: 'Dransfeld', area: '5502'},
    { city: 'Drebber', area: '5445'},
    { city: 'Drebkau', area: '35602'},
    { city: 'Dreileben', area: '39293'},
    { city: 'Drense', area: '39857'},
    { city: 'Drensteinfurt', area: '2508'},
    { city: 'Drensteinfurt-Rinkerode', area: '2538'},
    { city: 'Drensteinfurt-Walstedde', area: '2387'},
    { city: 'Dresden', area: '351'},
    { city: 'Driedorf', area: '2775'},
    { city: 'Drochtersen', area: '4143'},
    { city: 'Drochtersen-Assel', area: '4148'},
    { city: 'Drognitz', area: '36737'},
    { city: 'Drolshagen-Bleche', area: '2763'},
    { city: 'Drönnewitz b Hagenow', area: '38853'},
    { city: 'Droyssig', area: '34425'},
    { city: 'Ducherow', area: '39726'},
    { city: 'Dudeldorf', area: '6565'},
    { city: 'Duderstadt', area: '5527'},
    { city: 'Duingen', area: '5185'},
    { city: 'Duisburg', area: '203'},
    { city: 'Duisburg-Homberg', area: '2066'},
    { city: 'Duisburg-Rheinhausen', area: '2065'},
    { city: 'Dülmen', area: '2594'},
    { city: 'Dülmen-Buldern', area: '2590'},
    { city: 'Dülmen-Rorup', area: '2548'},
    { city: 'Dümmer', area: '3869'},
    { city: 'Dunningen', area: '7403'},
    { city: 'Düren', area: '2421'},
    { city: 'Durmersheim', area: '7245'},
    { city: 'Dürrröhrsdorf-Dittersbach', area: '35026'},
    { city: 'Dürrwangen', area: '9856'},
    { city: 'Dürrweitzschen B Grimma', area: '34386'},
    { city: 'Düsseldorf', area: '211'},
    { city: 'Ebeleben', area: '36020'},
    { city: 'Eberbach Baden', area: '6271'},
    { city: 'Ebergötzen', area: '5507'},
    { city: 'Eberhardzell-Füramoos', area: '7358'},
    { city: 'Ebermannstadt', area: '9194'},
    { city: 'Ebern', area: '9531'},
    { city: 'Ebersbach an der Fils', area: '7163'},
    { city: 'Ebersbrunn Sachs', area: '37607'},
    { city: 'Ebersburg', area: '6656'},
    { city: 'Ebersdorf b Bremervörde', area: '4765'},
    { city: 'Eberswalde', area: '3334'},
    { city: 'Ebhausen', area: '7458'},
    { city: 'Ebrach Oberfr', area: '9553'},
    { city: 'Ebsdorfergrund', area: '6424'},
    { city: 'Ebstorf', area: '5822'},
    { city: 'Eching Niederbay', area: '8709'},
    { city: 'Echzell', area: '6008'},
    { city: 'Eckartsberga', area: '34467'},
    { city: 'Eckental', area: '9126'},
    { city: 'Eckernförde', area: '4351'},
    { city: 'Eddelak', area: '4855'},
    { city: 'Edemissen', area: '5176'},
    { city: 'Edemissen-Abbensen', area: '5177'},
    { city: 'Edenkoben', area: '6323'},
    { city: 'Edertal', area: '5623'},
    { city: 'Edewecht', area: '4405'},
    { city: 'Edewecht-Friedrichsfehn', area: '4486'},
    { city: 'Ediger-Eller', area: '2675'},
    { city: 'Efringen-Kirchen', area: '7628'},
    { city: 'Egeln', area: '39268'},
    { city: 'Egesheim', area: '7429'},
    { city: 'Egestorf Nordheide', area: '4175'},
    { city: 'Eggebek', area: '4609'},
    { city: 'Eggenfelden', area: '8721'},
    { city: 'Eggesin', area: '39779'},
    { city: 'Eggstätt', area: '8056'},
    { city: 'Eging a See', area: '8544'},
    { city: 'Egling a d Paar', area: '8206'},
    { city: 'Egling b Wolfratshausen', area: '8176'},
    { city: 'Egloffstein', area: '9197'},
    { city: 'Ehekirchen', area: '8435'},
    { city: 'Ehingen Donau', area: '7391'},
    { city: 'Ehingen Mittelfr', area: '9835'},
    { city: 'Ehingen-Dächingen', area: '7395'},
    { city: 'Ehningen', area: '7034'},
    { city: 'Ehra-Lessien', area: '5377'},
    { city: 'Ehrenberg Rhön', area: '6683'},
    { city: 'Ehrenburg', area: '4275'},
    { city: 'Ehrenfriedersdorf', area: '37341'},
    { city: 'Ehrenhain', area: '34494'},
    { city: 'Ehringshausen Dill', area: '6443'},
    { city: 'Ehringshausen-Katzenfurt', area: '6449'},
    { city: 'Eibelstadt', area: '9303'},
    { city: 'Eibenstock', area: '37752'},
    { city: 'Eich Rheinhess', area: '6246'},
    { city: 'Eichenbarleben', area: '39206'},
    { city: 'Eichenbühl-Riedern', area: '9378'},
    { city: 'Eichendorf', area: '9952'},
    { city: 'Eichendorf-Aufhausen', area: '9956'},
    { city: 'Eichenzell', area: '6659'},
    { city: 'Eichigt', area: '37430'},
    { city: 'Eichstätt Bay', area: '8421'},
    { city: 'Eichstetten', area: '7663'},
    { city: 'Eickendorf Kr Schönebeck', area: '39297'},
    { city: 'Eigeltingen', area: '7774'},
    { city: 'Eilenburg', area: '3423'},
    { city: 'Eilsleben', area: '39409'},
    { city: 'Eimke', area: '5873'},
    { city: 'Einbeck', area: '5561'},
    { city: 'Einbeck-Wenzen', area: '5565'},
    { city: 'Einsiedel b Chemnitz', area: '37209'},
    { city: 'Eisenach Thür', area: '3691'},
    { city: 'Eisenbach Hochschwarzwald', area: '7657'},
    { city: 'Eisenberg Pfalz', area: '6351'},
    { city: 'Eisenberg Thür', area: '36691'},
    { city: 'Eisenhüttenstadt', area: '3364'},
    { city: 'Eisfeld', area: '3686'},
    { city: 'Eiterfeld', area: '6672'},
    { city: 'Eitorf', area: '2243'},
    { city: 'Elbingerode Harz', area: '39454'},
    { city: 'Eldena', area: '38755'},
    { city: 'Ellenz-Poltersdorf', area: '2673'},
    { city: 'Ellerhoop', area: '4120'},
    { city: 'Ellrich', area: '36332'},
    { city: 'Ellwangen Jagst', area: '7961'},
    { city: 'Ellwangen-Röhlingen', area: '7965'},
    { city: 'Elmenhorst Vorpom', area: '38327'},
    { city: 'Elmshorn', area: '4121'},
    { city: 'Elmstein', area: '6328'},
    { city: 'Elsdorf Rheinl', area: '2274'},
    { city: 'Elsendorf Niederbay', area: '8753'},
    { city: 'Elsfleth', area: '4404'},
    { city: 'Elsfleth-Huntorf', area: '4485'},
    { city: 'Elster Elbe', area: '35383'},
    { city: 'Elsterberg b Plauen', area: '36621'},
    { city: 'Elsterwerda', area: '3533'},
    { city: 'Elstra', area: '35793'},
    { city: 'Eltmann', area: '9522'},
    { city: 'Eltville am Rhein', area: '6123'},
    { city: 'Elxleben b Arnstadt', area: '36200'},
    { city: 'Elzach', area: '7682'},
    { city: 'Elze Leine', area: '5068'},
    { city: 'Embsen Kr Lünebeburg', area: '4134'},
    { city: 'Emden Stadt', area: '4921'},
    { city: 'Emkendorf', area: '4330'},
    { city: 'Emlichheim', area: '5943'},
    { city: 'Emmelsbüll-Horsbüll', area: '4665'},
    { city: 'Emmelshausen', area: '6747'},
    { city: 'Emmendingen', area: '7641'},
    { city: 'Emmendorf', area: '5875'},
    { city: 'Emmerich', area: '2822'},
    { city: 'Emmerich-Elten', area: '2828'},
    { city: 'Emmerthal', area: '5155'},
    { city: 'Emmerthal-Börry', area: '5157'},
    { city: 'Emmingen-Liptingen', area: '7465'},
    { city: 'Empfingen', area: '7485'},
    { city: 'Emsbüren', area: '5903'},
    { city: 'Emsdetten', area: '2572'},
    { city: 'Emskirchen', area: '9104'},
    { city: 'Emstek', area: '4473'},
    { city: 'Emtinghausen', area: '4295'},
    { city: 'Emtmannsberg', area: '9209'},
    { city: 'Endingen Kaiserstuhl', area: '7642'},
    { city: 'Engden', area: '5926'},
    { city: 'Engelskirchen', area: '2263'},
    { city: 'Engen Hegau', area: '7733'},
    { city: 'Enger Westf', area: '5224'},
    { city: 'Enkenbach-Alsenborn', area: '6303'},
    { city: 'Ennepetal', area: '2333'},
    { city: 'Ennigerloh', area: '2524'},
    { city: 'Ennigerloh-Enniger', area: '2528'},
    { city: 'Ennigerloh-Westkirchen', area: '2587'},
    { city: 'Ensdorf Oberpf', area: '9624'},
    { city: 'Ense', area: '2938'},
    { city: 'Enzklösterle', area: '7085'},
    { city: 'Epfendorf', area: '7404'},
    { city: 'Eppelborn', area: '6827'},
    { city: 'Eppelsheim', area: '6735'},
    { city: 'Eppendorf Sachs', area: '37293'},
    { city: 'Eppingen', area: '7262'},
    { city: 'Eppstein', area: '6198'},
    { city: 'Erbach Donau', area: '7305'},
    { city: 'Erbach Odenw', area: '6062'},
    { city: 'Erbendorf', area: '9682'},
    { city: 'Erbenhausen Thür', area: '36946'},
    { city: 'Erding', area: '8122'},
    { city: 'Erfde', area: '4333'},
    { city: 'Erftstadt', area: '2235'},
    { city: 'Erfurt', area: '361'},
    { city: 'Ergersheim', area: '9847'},
    { city: 'Ergoldsbach', area: '8771'},
    { city: 'Ering', area: '8573'},
    { city: 'Erkelenz', area: '2431'},
    { city: 'Erkelenz-Lövenich', area: '2435'},
    { city: 'Erkheim', area: '8336'},
    { city: 'Erkner', area: '3362'},
    { city: 'Erlangen', area: '9131'},
    { city: 'Erlensee', area: '6183'},
    { city: 'Ermsleben', area: '34743'},
    { city: 'Ermstedt', area: '36208'},
    { city: 'Erndtebrück', area: '2753'},
    { city: 'Erolzheim', area: '7354'},
    { city: 'Ershausen', area: '36082'},
    { city: 'Erwitte', area: '2943'},
    { city: 'Erxleben b Haldensleben', area: '39052'},
    { city: 'Eschau', area: '9374'},
    { city: 'Eschede', area: '5142'},
    { city: 'Eschenbach i d Opf', area: '9645'},
    { city: 'Eschenburg', area: '2770'},
    { city: 'Eschershausen a d Lenne', area: '5534'},
    { city: 'Eschlkam', area: '9948'},
    { city: 'Eschwege', area: '5651'},
    { city: 'Eschweiler Rheinl', area: '2403'},
    { city: 'Esens', area: '4971'},
    { city: 'Eslarn', area: '9653'},
    { city: 'Eslohe Sauerland', area: '2973'},
    { city: 'Espelkamp', area: '5772'},
    { city: 'Espelkamp-Gestringen', area: '5743'},
    { city: 'Esselbach', area: '9394'},
    { city: 'Essen', area: '201'},
    { city: 'Essen Oldenburg', area: '5434'},
    { city: 'Essenbach', area: '8703'},
    { city: 'Essen-Kettwig', area: '2054'},
    { city: 'Essing', area: '9447'},
    { city: 'Essingen Württ', area: '7365'},
    { city: 'Estenfeld', area: '9305'},
    { city: 'Esterwegen', area: '5955'},
    { city: 'Estorf Kr Stade', area: '4140'},
    { city: 'Estorf Weser', area: '5025'},
    { city: 'Ettenheim', area: '7822'},
    { city: 'Ettenstatt', area: '9148'},
    { city: 'Ettlingen', area: '7243'},
    { city: 'Ettringen Wertach', area: '8249'},
    { city: 'Euerbach', area: '9726'},
    { city: 'Euerdorf', area: '9704'},
    { city: 'Eurasburg a d Loisach', area: '8179'},
    { city: 'Eurasburg b Augsburg', area: '8208'},
    { city: 'Euskirchen', area: '2251'},
    { city: 'Euskirchen-Flamersheim', area: '2255'},
    { city: 'Eussenheim-Hundsbach', area: '9350'},
    { city: 'Eutin', area: '4521'},
    { city: 'Everswinkel', area: '2582'},
    { city: 'Extertal', area: '5262'},
    { city: 'Extertal-Bremke', area: '5754'},
    { city: 'Eystrup', area: '4254'},
    { city: 'Fahrenbach Baden', area: '6267'},
    { city: 'Fahrland', area: '33208'},
    { city: 'Falkenberg Elster', area: '35365'},
    { city: 'Falkenberg Mark', area: '33458'},
    { city: 'Falkenberg Niederbay', area: '8727'},
    { city: 'Falkenberg Oberpf', area: '9637'},
    { city: 'Falkenhagen b Seelow', area: '33603'},
    { city: 'Falkenhagen Kr Prignitz', area: '33986'},
    { city: 'Falkenhain b Wurzen', area: '34262'},
    { city: 'Falkensee', area: '3322'},
    { city: 'Falkenstein Oberpf', area: '9462'},
    { city: 'Falkenstein Vogtl', area: '3745'},
    { city: 'Falkenthal', area: '33088'},
    { city: 'Fallingbostel', area: '5162'},
    { city: 'Fallingbostel-Dorfmark', area: '5163'},
    { city: 'Fassberg', area: '5055'},
    { city: 'Faßberg-Müden', area: '5053'},
    { city: 'Faulbach Unterfr', area: '9392'},
    { city: 'Faulenrost', area: '39951'},
    { city: 'Fedderwarden', area: '4423'},
    { city: 'Fehrbellin', area: '33932'},
    { city: 'Feldafing', area: '8157'},
    { city: 'Feldatal', area: '6637'},
    { city: 'Feldberg Meckl', area: '39831'},
    { city: 'Feldberg Schwarzwald', area: '7676'},
    { city: 'Feldberg-Altglashütten', area: '7655'},
    { city: 'Feldkirchen Niederbay', area: '9420'},
    { city: 'Feldkirchen-Westerham', area: '8063'},
    { city: 'Felgentreu', area: '33734'},
    { city: 'Fellheim', area: '8335'},
    { city: 'Felsberg Hess', area: '5662'},
    { city: 'Fensterbach', area: '9438'},
    { city: 'Ferdinandshof b Torgelow', area: '39778'},
    { city: 'Fermerswalde', area: '35363'},
    { city: 'Feucht', area: '9128'},
    { city: 'Feuchtwangen', area: '9852'},
    { city: 'Fichtelberg', area: '9272'},
    { city: 'Fichtenau', area: '7962'},
    { city: 'Fichtenwalde', area: '33206'},
    { city: 'Finnentrop-Rönkhausen', area: '2395'},
    { city: 'Finnentrop-Serkenrode', area: '2724'},
    { city: 'Finowfurt', area: '3335'},
    { city: 'Finsterwalde', area: '3531'},
    { city: 'Fintel', area: '4265'},
    { city: 'Fischach', area: '8236'},
    { city: 'Fischbach bei Dahn', area: '6393'},
    { city: 'Fischbachau', area: '8028'},
    { city: 'Fischbachtal', area: '6166'},
    { city: 'Fischen i Allgäu', area: '8326'},
    { city: 'Flachslanden', area: '9829'},
    { city: 'Fladungen', area: '9778'},
    { city: 'Flammersfeld', area: '2685'},
    { city: 'Flechtingen', area: '39054'},
    { city: 'Fleckeby', area: '4354'},
    { city: 'Flecken Zechlin', area: '33923'},
    { city: 'Fleetmark', area: '39034'},
    { city: 'Flensburg', area: '461'},
    { city: 'Flintbek', area: '4347'},
    { city: 'Flöha', area: '3726'},
    { city: 'Flonheim', area: '6734'},
    { city: 'Flörsbachtal', area: '6057'},
    { city: 'Flörsheim am Main', area: '6145'},
    { city: 'Floss', area: '9603'},
    { city: 'Fluorn-Winzeln', area: '7402'},
    { city: 'Forbach', area: '7228'},
    { city: 'Forbach-Hundsbach', area: '7220'},
    { city: 'Forchheim Oberfr', area: '9191'},
    { city: 'Forchtenberg', area: '7947'},
    { city: 'Förderstedt', area: '39266'},
    { city: 'Forst Lausitz', area: '3562'},
    { city: 'Forstern Oberbay', area: '8124'},
    { city: 'Frammersbach', area: '9355'},
    { city: 'Frankenau Hess', area: '6455'},
    { city: 'Frankenberg Eder', area: '6451'},
    { city: 'Frankenberg Sachs', area: '37206'},
    { city: 'Frankenhardt', area: '7959'},
    { city: 'Frankenstein Sachs', area: '37321'},
    { city: 'Frankenthal Pfalz', area: '6233'},
    { city: 'Frankfurt (Oder)', area: '335'},
    { city: 'Frankfurt am Main', area: '69'},
    { city: 'Frankfurt-Bergen-Enkheim', area: '6109'},
    { city: 'Frankleben', area: '34637'},
    { city: 'Frauenau', area: '9926'},
    { city: 'Frauenstein Sachs', area: '37326'},
    { city: 'Frechen', area: '2234'},
    { city: 'Freden Leine', area: '5184'},
    { city: 'Fredenbeck', area: '4149'},
    { city: 'Fredersdorf-Vogelsdorf', area: '33439'},
    { city: 'Freiamt', area: '7645'},
    { city: 'Freiberg Sachs', area: '3731'},
    { city: 'Freiburg Elbe', area: '4779'},
    { city: 'Freiburg im Breisgau', area: '761'},
    { city: 'Freiburg-Tiengen', area: '7664'},
    { city: 'Freiensteinau', area: '6666'},
    { city: 'Freienwill', area: '4602'},
    { city: 'Freigericht', area: '6055'},
    { city: 'Freihung', area: '9646'},
    { city: 'Freilassing', area: '8654'},
    { city: 'Freilingen Westerw', area: '2666'},
    { city: 'Freinsheim', area: '6353'},
    { city: 'Freisen', area: '6855'},
    { city: 'Freising', area: '8161'},
    { city: 'Frellstedt', area: '5355'},
    { city: 'Fremdingen', area: '9086'},
    { city: 'Frensdorf', area: '9502'},
    { city: 'Freren', area: '5902'},
    { city: 'Fretzdorf', area: '33964'},
    { city: 'Freudenberg Baden', area: '9375'},
    { city: 'Freudenberg Oberpf', area: '9627'},
    { city: 'Freudenberg Westf', area: '2734'},
    { city: 'Freudenberg-Boxtal', area: '9377'},
    { city: 'Freudenburg', area: '6582'},
    { city: 'Freudenstadt', area: '7441'},
    { city: 'Freyburg Unstrut', area: '34464'},
    { city: 'Freyenstein', area: '33967'},
    { city: 'Freystadt', area: '9179'},
    { city: 'Freystadt-Burggriesbach', area: '8469'},
    { city: 'Freyung', area: '8551'},
    { city: 'Fridolfing', area: '8684'},
    { city: 'Friedberg Hess', area: '6031'},
    { city: 'Friedeburg Ostfriesl', area: '4465'},
    { city: 'Friedeburg-Reepsholt', area: '4468'},
    { city: 'Friedenfels', area: '9683'},
    { city: 'Friedersdorf b Berlin', area: '33767'},
    { city: 'Friedewald Hess', area: '6674'},
    { city: 'Friedland b Beeskow', area: '33676'},
    { city: 'Friedland Kr Göttingen', area: '5504'},
    { city: 'Friedland Meckl', area: '39601'},
    { city: 'Friedrichroda', area: '3623'},
    { city: 'Friedrichsbrunn', area: '39487'},
    { city: 'Friedrichsdorf Taunus', area: '6175'},
    { city: 'Friedrichshafen', area: '7541'},
    { city: 'Friedrichskoog', area: '4854'},
    { city: 'Friedrichstadt', area: '4881'},
    { city: 'Friedrichswalde Brandenb', area: '33367'},
    { city: 'Friedrichswerth', area: '36254'},
    { city: 'Frielendorf', area: '5684'},
    { city: 'Friemar', area: '36258'},
    { city: 'Friesack', area: '33235'},
    { city: 'Friesenried', area: '8347'},
    { city: 'Friesoythe', area: '4491'},
    { city: 'Friesoythe-Gehlenberg', area: '4493'},
    { city: 'Friesoythe-Markhausen', area: '4496'},
    { city: 'Friesoythe-Thüle', area: '4495'},
    { city: 'Fritzlar', area: '5622'},
    { city: 'Frohburg', area: '34348'},
    { city: 'Fröndenberg-Langschede', area: '2378'},
    { city: 'Fronhausen', area: '6426'},
    { city: 'Fronreute', area: '7505'},
    { city: 'Frontenhausen', area: '8732'},
    { city: 'Frose', area: '34741'},
    { city: 'Fuchstal', area: '8243'},
    { city: 'Fulda', area: '661'},
    { city: 'Fuldatal', area: '5607'},
    { city: 'Fünfeichen', area: '33654'},
    { city: 'Fürfeld Kr Bad Kreuznach', area: '6709'},
    { city: 'Fürstenau b Bramsche', area: '5901'},
    { city: 'Fürstenberg Havel', area: '33093'},
    { city: 'Fürstenfeldbruck', area: '8141'},
    { city: 'Fürstenwalde Spree', area: '3361'},
    { city: 'Fürstenwerder', area: '39859'},
    { city: 'Fürstenzell', area: '8502'},
    { city: 'Furth i Wald', area: '9973'},
    { city: 'Fürth Odenw', area: '6253'},
    { city: 'Furtwangen im Schwarzwald', area: '7723'},
    { city: 'Füssen', area: '8362'},
    { city: 'Gablingen', area: '8230'},
    { city: 'Gadebusch', area: '3886'},
    { city: 'Gaggenau', area: '7225'},
    { city: 'Gaildorf', area: '7971'},
    { city: 'Gailingen', area: '7734'},
    { city: 'Gaimersheim', area: '8458'},
    { city: 'Gallin b Lübz', area: '38732'},
    { city: 'Gammelin', area: '38850'},
    { city: 'Gammelsdorf', area: '8766'},
    { city: 'Gammertingen', area: '7574'},
    { city: 'Ganderkesee', area: '4222'},
    { city: 'Ganderkesee-Bookholzberg', area: '4223'},
    { city: 'Gangelt', area: '2454'},
    { city: 'Gangkofen', area: '8722'},
    { city: 'Gangkofen-Kollbach', area: '8735'},
    { city: 'Ganzlin', area: '38737'},
    { city: 'Garbsen', area: '5131'},
    { city: 'Garching a d Alz', area: '8634'},
    { city: 'Gardelegen', area: '3907'},
    { city: 'Garding', area: '4862'},
    { city: 'Garlstedt', area: '4795'},
    { city: 'Garmisch-Partenkirchen', area: '8821'},
    { city: 'Garrel', area: '4474'},
    { city: 'Gars a Inn', area: '8073'},
    { city: 'Gartow Niedersachs', area: '5846'},
    { city: 'Gartz Oder', area: '33332'},
    { city: 'Garz Rügen', area: '38304'},
    { city: 'Gaschwitz', area: '34299'},
    { city: 'Gatersleben', area: '39482'},
    { city: 'Gau-Algesheim', area: '6725'},
    { city: 'Gaukönigshofen', area: '9337'},
    { city: 'Gau-Odernheim', area: '6733'},
    { city: 'Gebstedt', area: '36463'},
    { city: 'Gechingen', area: '7056'},
    { city: 'Gedern', area: '6045'},
    { city: 'Geeste', area: '5907'},
    { city: 'Geeste-Gross Hesepe', area: '5937'},
    { city: 'Geestgottberg', area: '39397'},
    { city: 'Geesthacht', area: '4152'},
    { city: 'Gefell b Schleiz', area: '36649'},
    { city: 'Gefrees', area: '9254'},
    { city: 'Gehlberg', area: '36845'},
    { city: 'Gehrden Han', area: '5108'},
    { city: 'Gehren Thür', area: '36783'},
    { city: 'Geilenkirchen', area: '2451'},
    { city: 'Geisa', area: '36967'},
    { city: 'Geiselhöring', area: '9423'},
    { city: 'Geiselwind', area: '9556'},
    { city: 'Geisenfeld', area: '8452'},
    { city: 'Geisenhausen', area: '8743'},
    { city: 'Geisingen Baden', area: '7704'},
    { city: 'Geisingen-Leipferdingen', area: '7708'},
    { city: 'Geislingen an der Steige', area: '7331'},
    { city: 'Geithain', area: '34341'},
    { city: 'Gelbensande', area: '38201'},
    { city: 'Geldern', area: '2831'},
    { city: 'Gelnhausen', area: '6051'},
    { city: 'Gelsenkirchen', area: '209'},
    { city: 'Geltendorf', area: '8193'},
    { city: 'Gelting Angeln', area: '4643'},
    { city: 'Gemmingen', area: '7267'},
    { city: 'Gemünden a Main', area: '9351'},
    { city: 'Gemünden Felda', area: '6634'},
    { city: 'Gemünden Hunsrück', area: '6765'},
    { city: 'Gemünden Wohra', area: '6453'},
    { city: 'Gengenbach', area: '7803'},
    { city: 'Gensingen', area: '6727'},
    { city: 'Genthin', area: '3933'},
    { city: 'Georgenberg', area: '9658'},
    { city: 'Georgensgmünd', area: '9172'},
    { city: 'Georgenthal Thür Wald', area: '36253'},
    { city: 'Georgsdorf', area: '5946'},
    { city: 'Georgsmarienhütte', area: '5401'},
    { city: 'Gera', area: '365'},
    { city: 'Gerabronn', area: '7952'},
    { city: 'Geratskirchen', area: '8728'},
    { city: 'Gerbstedt', area: '34783'},
    { city: 'Gerchsheim', area: '9344'},
    { city: 'Gerdau', area: '5808'},
    { city: 'Geringswalde', area: '37382'},
    { city: 'Germersheim', area: '7274'},
    { city: 'Gernrode Harz', area: '39485'},
    { city: 'Gernsbach', area: '7224'},
    { city: 'Gernsheim', area: '6258'},
    { city: 'Geroda Bay', area: '9747'},
    { city: 'Geroldshausen Unterfr', area: '9366'},
    { city: 'Gerolsbach', area: '8445'},
    { city: 'Gerolstein', area: '6591'},
    { city: 'Gerolzhofen', area: '9382'},
    { city: 'Gersdorf b Chemnitz', area: '37203'},
    { city: 'Gersdorf b Görlitz', area: '35829'},
    { city: 'Gersfeld Rhön', area: '6654'},
    { city: 'Gersheim', area: '6843'},
    { city: 'Gerstetten', area: '7323'},
    { city: 'Gerstungen', area: '36922'},
    { city: 'Gerswalde', area: '39887'},
    { city: 'Gerzen', area: '8744'},
    { city: 'Geschendorf', area: '4553'},
    { city: 'Gescher', area: '2542'},
    { city: 'Gesees', area: '9201'},
    { city: 'Geseke', area: '2942'},
    { city: 'Geslau', area: '9867'},
    { city: 'Gessertshausen', area: '8238'},
    { city: 'Gettorf', area: '4346'},
    { city: 'Gevelsberg', area: '2332'},
    { city: 'Geyer', area: '37346'},
    { city: 'Giebelstadt', area: '9334'},
    { city: 'Gieboldehausen', area: '5528'},
    { city: 'Gielde', area: '5339'},
    { city: 'Gielow', area: '39957'},
    { city: 'Giengen a d Brenz', area: '7322'},
    { city: 'Giersleben', area: '34746'},
    { city: 'Giessen', area: '641'},
    { city: 'Gifhorn', area: '5371'},
    { city: 'Gilching', area: '8105'},
    { city: 'Gillenfeld', area: '6573'},
    { city: 'Gilserberg', area: '6696'},
    { city: 'Gingst', area: '38305'},
    { city: 'Gladau', area: '39342'},
    { city: 'Gladbeck', area: '2043'},
    { city: 'Gladenbach', area: '6462'},
    { city: 'Glandorf', area: '5426'},
    { city: 'Glan-Münchweiler', area: '6383'},
    { city: 'Glashütte Sachs', area: '35053'},
    { city: 'Glasin', area: '38429'},
    { city: 'Glaubitz', area: '35265'},
    { city: 'Glauburg', area: '6041'},
    { city: 'Glauchau', area: '3763'},
    { city: 'Gleichen-Bremke', area: '5592'},
    { city: 'Gleichen-Rittmarshausen', area: '5508'},
    { city: 'Glienicke b Beeskow', area: '33677'},
    { city: 'Glienke', area: '39606'},
    { city: 'Globig-Bleddin', area: '34927'},
    { city: 'Glonn Kr Ebersberg', area: '8093'},
    { city: 'Glött', area: '9075'},
    { city: 'Glottertal', area: '7684'},
    { city: 'Glöwen', area: '38787'},
    { city: 'Glücksburg Ostsee', area: '4631'},
    { city: 'Glückstadt', area: '4124'},
    { city: 'Gnarrenburg', area: '4763'},
    { city: 'Gnarrenburg-Klenkendorf', area: '4764'},
    { city: 'Gnoien', area: '39971'},
    { city: 'Goch', area: '2823'},
    { city: 'Goch-Hassum', area: '2827'},
    { city: 'Göhren Rügen', area: '38308'},
    { city: 'Goldbach b Gotha', area: '36255'},
    { city: 'Goldbeck Altm', area: '39388'},
    { city: 'Goldberg Meckl', area: '38736'},
    { city: 'Goldenstedt', area: '4444'},
    { city: 'Gollin', area: '39882'},
    { city: 'Gollmitz b Calau', area: '35435'},
    { city: 'Golssen', area: '35452'},
    { city: 'Golzow b Brandenburg', area: '33835'},
    { city: 'Golzow b Seelow', area: '33472'},
    { city: 'Gomadingen', area: '7385'},
    { city: 'Gomaringen', area: '7072'},
    { city: 'Gommern', area: '39200'},
    { city: 'Gondershausen', area: '6745'},
    { city: 'Göppingen', area: '7161'},
    { city: 'Göppingen-Hohenstaufen', area: '7165'},
    { city: 'Görisried', area: '8302'},
    { city: 'Göritz b Prenzlau', area: '39851'},
    { city: 'Gorleben', area: '5882'},
    { city: 'Görlitz', area: '3581'},
    { city: 'Görmin', area: '39992'},
    { city: 'Görwihl', area: '7754'},
    { city: 'Görzig Kr Köthen', area: '34975'},
    { city: 'Görzke', area: '33847'},
    { city: 'Gosda b Klinge', area: '35694'},
    { city: 'Gosheim', area: '7426'},
    { city: 'Goslar', area: '5321'},
    { city: 'Goslar-Hahnenklee', area: '5325'},
    { city: 'Gossa', area: '34955'},
    { city: 'Gössenheim', area: '9358'},
    { city: 'Gößnitz Thür', area: '34493'},
    { city: 'Gößweinstein', area: '9242'},
    { city: 'Gotha Thür', area: '3621'},
    { city: 'Göttingen', area: '551'},
    { city: 'Goyatz', area: '35478'},
    { city: 'Graal-Müritz Seeheilbad', area: '38206'},
    { city: 'Graben-Neudorf', area: '7255'},
    { city: 'Grabenstätt Chiemsee', area: '8661'},
    { city: 'Grabow Meckl', area: '38756'},
    { city: 'Grabowhöfe', area: '39926'},
    { city: 'Grafenau Niederbay', area: '8552'},
    { city: 'Gräfenberg', area: '9192'},
    { city: 'Gräfendorf Bay', area: '9357'},
    { city: 'Gräfenhainichen', area: '34953'},
    { city: 'Grafenhausen Hochschwarzw', area: '7748'},
    { city: 'Gräfenroda', area: '36205'},
    { city: 'Gräfenthal', area: '36703'},
    { city: 'Grafenwöhr', area: '9641'},
    { city: 'Gräfinau-Angstedt', area: '36785'},
    { city: 'Grafing b München', area: '8092'},
    { city: 'Grafrath', area: '8144'},
    { city: 'Grainet', area: '8585'},
    { city: 'Grambow b Pasewalk', area: '39749'},
    { city: 'Grammendorf', area: '38334'},
    { city: 'Grammentin', area: '39952'},
    { city: 'Gramzow b Prenzlau', area: '39861'},
    { city: 'Gransee', area: '3306'},
    { city: 'Grasberg', area: '4208'},
    { city: 'Grasleben', area: '5357'},
    { city: 'Grassau Kr Traunstein', area: '8641'},
    { city: 'Grävenwiesbach', area: '6086'},
    { city: 'Grebbin', area: '38720'},
    { city: 'Grebenau', area: '6646'},
    { city: 'Grebenhain', area: '6644'},
    { city: 'Grebenstein', area: '5674'},
    { city: 'Grebin', area: '4383'},
    { city: 'Greding', area: '8463'},
    { city: 'Grefrath b Krefeld', area: '2158'},
    { city: 'Greifenhagen', area: '34781'},
    { city: 'Greifenstein-Beilstein', area: '2779'},
    { city: 'Greifenstein-Nenderoth', area: '6477'},
    { city: 'Greifenstein-Ulm', area: '6478'},
    { city: 'Greiffenberg', area: '33334'},
    { city: 'Greifswald', area: '3834'},
    { city: 'Greiz', area: '3661'},
    { city: 'Grenzach-Wyhlen', area: '7624'},
    { city: 'Gresenhorst', area: '38224'},
    { city: 'Grettstadt', area: '9729'},
    { city: 'Greussen', area: '3636'},
    { city: 'Greven Westf', area: '2571'},
    { city: 'Grevenbroich', area: '2181'},
    { city: 'Grevenbroich-Kapellen', area: '2182'},
    { city: 'Greven-Reckenfeld', area: '2575'},
    { city: 'Grevesmühlen', area: '3881'},
    { city: 'Grieben b Tangerhütte', area: '39362'},
    { city: 'Grieben Kr Oberhavel', area: '33086'},
    { city: 'Griesbach i Rottal', area: '8532'},
    { city: 'Griesheim Hess', area: '6155'},
    { city: 'Grimma', area: '3437'},
    { city: 'Grimmen', area: '38326'},
    { city: 'Gröbers', area: '34605'},
    { city: 'Gröbzig', area: '34976'},
    { city: 'Gröditz b Riesa', area: '35263'},
    { city: 'Groitzsch b Pegau', area: '34296'},
    { city: 'Grömitz', area: '4562'},
    { city: 'Grömitz-Cismar', area: '4366'},
    { city: 'Gronau Leine', area: '5182'},
    { city: 'Gronau Westfalen', area: '2562'},
    { city: 'Gronau-Epe', area: '2565'},
    { city: 'Gröningen Sachs-Ahn', area: '39403'},
    { city: 'Gross Ammensleben', area: '39202'},
    { city: 'Gross Behnitz', area: '33239'},
    { city: 'Gross Bisdorf', area: '38332'},
    { city: 'Groß Bützin', area: '39976'},
    { city: 'Groß Dölln', area: '39883'},
    { city: 'Groß Düngen', area: '5064'},
    { city: 'Gross Garz', area: '39398'},
    { city: 'Gross Glienicke', area: '33201'},
    { city: 'Gross Godems', area: '38725'},
    { city: 'Groß Grönau', area: '4509'},
    { city: 'Gross Ippener', area: '4224'},
    { city: 'Gross Kreutz', area: '33207'},
    { city: 'Gross Munzel', area: '5035'},
    { city: 'Gross Nemerow', area: '39605'},
    { city: 'Gross Neuendorf', area: '33478'},
    { city: 'Gross Oesingen', area: '5838'},
    { city: 'Gross Ossnig', area: '35608'},
    { city: 'Gross Pankow Kr Prignitz', area: '33983'},
    { city: 'Groß Plasten', area: '39934'},
    { city: 'Gross Roge', area: '39978'},
    { city: 'Gross Rosenburg', area: '39294'},
    { city: 'Groß Särchen', area: '35726'},
    { city: 'Gross Schönebeck Kr Barnim', area: '33393'},
    { city: 'Gross Warnow', area: '38788'},
    { city: 'Gross Wittensee', area: '4356'},
    { city: 'Gross Ziethen Kr Barnim', area: '33364'},
    { city: 'Grossaitingen', area: '8203'},
    { city: 'Grossalmerode', area: '5604'},
    { city: 'Grossbeeren', area: '33701'},
    { city: 'Grossberndten', area: '36330'},
    { city: 'Grossbodungen', area: '36077'},
    { city: 'Grossbothen', area: '34384'},
    { city: 'Grossbottwar', area: '7148'},
    { city: 'Grossbreitenbach', area: '36781'},
    { city: 'Grossbundenbach', area: '6337'},
    { city: 'Grossdubrau', area: '35934'},
    { city: 'Grossefehn', area: '4943'},
    { city: 'Grossefehn-Bagband', area: '4946'},
    { city: 'Grossefehn-Timmel', area: '4945'},
    { city: 'Grossenaspe', area: '4327'},
    { city: 'Grossenbrode', area: '4367'},
    { city: 'Grossenehrich', area: '36370'},
    { city: 'Grossengottern', area: '36022'},
    { city: 'Grossenhain Sachs', area: '3522'},
    { city: 'Grossenkneten', area: '4435'},
    { city: 'Grossenkneten-Huntlosen', area: '4487'},
    { city: 'Grossenlupnitz', area: '36920'},
    { city: 'Grossenwiehe', area: '4604'},
    { city: 'Grossenwörden', area: '4775'},
    { city: 'Grossfahner', area: '36206'},
    { city: 'Gross-Gerau', area: '6152'},
    { city: 'Grosshabersdorf', area: '9105'},
    { city: 'Grossharthau', area: '35954'},
    { city: 'Grosshartmannsdorf', area: '37329'},
    { city: 'Grossheide', area: '4936'},
    { city: 'Grosskorbetha', area: '34446'},
    { city: 'Grosskrotzenburg', area: '6186'},
    { city: 'Grossmehring', area: '8407'},
    { city: 'Grossostheim', area: '6026'},
    { city: 'Großpostwitz OL', area: '35938'},
    { city: 'Großräschen', area: '35753'},
    { city: 'Großröhrsdorf OL', area: '35952'},
    { city: 'Grossrosseln', area: '6809'},
    { city: 'Grossschirma', area: '37328'},
    { city: 'Großschönau Sachs', area: '35841'},
    { city: 'Grosssteinhausen', area: '6339'},
    { city: 'Gross-Umstadt', area: '6078'},
    { city: 'Grosswechsungen', area: '36335'},
    { city: 'Grosswenkheim', area: '9766'},
    { city: 'Grosswudicke', area: '33873'},
    { city: 'Grub a Forst', area: '9560'},
    { city: 'Grünberg Hess', area: '6401'},
    { city: 'Gründau', area: '6058'},
    { city: 'Grünenbach Allgäu', area: '8383'},
    { city: 'Grünhainichen', area: '37294'},
    { city: 'Grunow Kr Oder-Spree', area: '33655'},
    { city: 'Grünsfeld', area: '9346'},
    { city: 'Grünstadt', area: '6359'},
    { city: 'Gschwend b Gaildorf', area: '7972'},
    { city: 'Guben', area: '3561'},
    { city: 'Gudensberg', area: '5603'},
    { city: 'Gudow Lauenb', area: '4547'},
    { city: 'Gühlen-Glienicke', area: '33929'},
    { city: 'Gülze', area: '38844'},
    { city: 'Gummersbach', area: '2261'},
    { city: 'Gumtow', area: '33977'},
    { city: 'Gundelfingen a d Donau', area: '9073'},
    { city: 'Gundelsheim Württ', area: '6269'},
    { city: 'Güntersberge', area: '39488'},
    { city: 'Guntersblum', area: '6249'},
    { city: 'Günzburg', area: '8221'},
    { city: 'Gunzenhausen', area: '9831'},
    { city: 'Gunzenhausen-Cronheim', area: '9836'},
    { city: 'Gusborn', area: '5865'},
    { city: 'Güsen', area: '39344'},
    { city: 'Gustävel', area: '38486'},
    { city: 'Güsten Anh', area: '39262'},
    { city: 'Güstrow', area: '3843'},
    { city: 'Gutach-Bleibach', area: '7685'},
    { city: 'Gutenfürst', area: '37433'},
    { city: 'Gutengermendorf', area: '33084'},
    { city: 'Güterglück', area: '39247'},
    { city: 'Gütersloh', area: '5241'},
    { city: 'Gütersloh-Friedrichsdorf', area: '5209'},
    { city: 'Guttau', area: '35932'},
    { city: 'Gützkow b Greifswald', area: '38353'},
    { city: 'Guxhagen', area: '5665'},
    { city: 'Gyhum', area: '4286'},
    { city: 'Haag i OB', area: '8072'},
    { city: 'Haan Rheinl*1', area: '2129'},
    { city: 'Haarbach', area: '8535'},
    { city: 'Hachenburg', area: '2662'},
    { city: 'Hadamar', area: '6433'},
    { city: 'Hadmersleben', area: '39408'},
    { city: 'Hagen b Bremerhaven', area: '4746'},
    { city: 'Hagen Westf', area: '2331'},
    { city: 'Hagenbach Pfalz', area: '7273'},
    { city: 'Hagen-Dahl', area: '2337'},
    { city: 'Hagen-Hohenlimburg', area: '2334'},
    { city: 'Hagenow', area: '3883'},
    { city: 'Hagenwerder', area: '35822'},
    { city: 'Hagermarsch', area: '4938'},
    { city: 'Hahnbach', area: '9664'},
    { city: 'Hähnichen', area: '35894'},
    { city: 'Hahnstätten', area: '6430'},
    { city: 'Haidmühle', area: '8556'},
    { city: 'Haiger', area: '2773'},
    { city: 'Haigerloch', area: '7474'},
    { city: 'Haimhausen Oberbay', area: '8133'},
    { city: 'Haina Kloster', area: '6456'},
    { city: 'Hainichen Sachs', area: '37207'},
    { city: 'Haiterbach', area: '7456'},
    { city: 'Halberstadt', area: '3941'},
    { city: 'Halblech', area: '8368'},
    { city: 'Haldensleben', area: '3904'},
    { city: 'Halfing', area: '8055'},
    { city: 'Hallbergmoos', area: '811'},
    { city: 'Halle Saale', area: '345'},
    { city: 'Halle Westf', area: '5201'},
    { city: 'Hallenberg', area: '2984'},
    { city: 'Hallschlag', area: '6557'},
    { city: 'Haltern Westf', area: '2364'},
    { city: 'Haltern-Lippramsdorf', area: '2360'},
    { city: 'Halver', area: '2353'},
    { city: 'Hambergen', area: '4793'},
    { city: 'Hambühren', area: '5084'},
    { city: 'Hamburg', area: '40'},
    { city: 'Hamdorf b Rendsburg', area: '4332'},
    { city: 'Hameln', area: '5151'},
    { city: 'Hamm Sieg', area: '2682'},
    { city: 'Hamm Westf', area: '2381'},
    { city: 'Hammelburg', area: '9732'},
    { city: 'Hammersbach Hess', area: '6185'},
    { city: 'Hamminkeln', area: '2852'},
    { city: 'Hamminkeln-Brünen', area: '2856'},
    { city: 'Hamm-Rhynern', area: '2385'},
    { city: 'Hamm-Uentrop', area: '2388'},
    { city: 'Hanau', area: '6181'},
    { city: 'Handewitt', area: '4608'},
    { city: 'Hanerau-Hademarschen', area: '4872'},
    { city: 'Hangelsberg', area: '33632'},
    { city: 'Hankensbüttel', area: '5832'},
    { city: 'Hann. Münden', area: '5541'},
    { city: 'Hannover', area: '511'},
    { city: 'Hanstedt Nordheide', area: '4184'},
    { city: 'Harbke', area: '39406'},
    { city: 'Harburg Schwaben', area: '9080'},
    { city: 'Hardegsen', area: '5505'},
    { city: 'Hardheim Odenw', area: '6283'},
    { city: 'Haren Ems', area: '5932'},
    { city: 'Haren-Rütenbrock', area: '5934'},
    { city: 'Harpstedt', area: '4244'},
    { city: 'Harra', area: '36642'},
    { city: 'Harsefeld', area: '4164'},
    { city: 'Harsewinkel', area: '5247'},
    { city: 'Harsewinkel-Greffen', area: '2588'},
    { city: 'Harsum', area: '5127'},
    { city: 'Hartenholm', area: '4195'},
    { city: 'Hartenstein Mittelfr', area: '9152'},
    { city: 'Hartenstein Sachs', area: '37605'},
    { city: 'Hartha b Döbeln', area: '34328'},
    { city: 'Harzgerode', area: '39484'},
    { city: 'Hasbergen Kr Osnabrück', area: '5405'},
    { city: 'Hasborn', area: '6574'},
    { city: 'Haseldorf', area: '4129'},
    { city: 'Haselünne', area: '5961'},
    { city: 'Haslach im Kinzigtal', area: '7832'},
    { city: 'Hasselfelde', area: '39459'},
    { city: 'Hassfurt', area: '9521'},
    { city: 'Hassleben b Prenzlau', area: '39884'},
    { city: 'Hassloch', area: '6324'},
    { city: 'Hassmersheim', area: '6266'},
    { city: 'Hatten', area: '4482'},
    { city: 'Hatten-Sandkrug', area: '4481'},
    { city: 'Hattersheim a Main', area: '6190'},
    { city: 'Hattingen Ruhr', area: '2324'},
    { city: 'Hattorf am Harz', area: '5584'},
    { city: 'Hattstedt', area: '4846'},
    { city: 'Hatzfeld Eder', area: '6467'},
    { city: 'Hauenstein Pfalz', area: '6392'},
    { city: 'Haundorf', area: '9837'},
    { city: 'Haunetal', area: '6673'},
    { city: 'Hausach', area: '7831'},
    { city: 'Hausen Niederbay', area: '9448'},
    { city: 'Hausham', area: '8026'},
    { city: 'Hauzenberg', area: '8586'},
    { city: 'Havelberg', area: '39387'},
    { city: 'Havetoft', area: '4603'},
    { city: 'Havixbeck', area: '2507'},
    { city: 'Hayingen', area: '7386'},
    { city: 'Hayn Harz', area: '34658'},
    { city: 'Hechingen', area: '7471'},
    { city: 'Hechthausen', area: '4774'},
    { city: 'Heckelberg', area: '33451'},
    { city: 'Hedemünden', area: '5545'},
    { city: 'Hedersleben b Aschersleben', area: '39481'},
    { city: 'Heek', area: '2568'},
    { city: 'Heeslingen-Boitzen', area: '4287'},
    { city: 'Heide Holst', area: '481'},
    { city: 'Heideck', area: '9177'},
    { city: 'Heidelberg', area: '6221'},
    { city: 'Heiden Kr Borken', area: '2867'},
    { city: 'Heidenau Sachs', area: '3529'},
    { city: 'Heidenheim a d Brenz', area: '7321'},
    { city: 'Heidenheim Mittelfr', area: '9833'},
    { city: 'Heidmühlen', area: '4320'},
    { city: 'Heigenbrücken', area: '6020'},
    { city: 'Heilbronn Neckar', area: '7131'},
    { city: 'Heiligenberg Baden', area: '7554'},
    { city: 'Heiligengrabe', area: '33962'},
    { city: 'Heiligenhafen', area: '4362'},
    { city: 'Heiligenhaus', area: '2056'},
    { city: 'Heiligenstadt Heilbad', area: '3606'},
    { city: 'Heiligenstadt i Ofr', area: '9198'},
    { city: 'Heilsbronn', area: '9872'},
    { city: 'Heimbach Eifel', area: '2446'},
    { city: 'Heimbach Nahe', area: '6789'},
    { city: 'Heimbuchenthal', area: '6092'},
    { city: 'Heinsberg Rheinl', area: '2452'},
    { city: 'Heinsberg-Randerath', area: '2453'},
    { city: 'Helbra', area: '34772'},
    { city: 'Heldrungen', area: '34673'},
    { city: 'Helgoland', area: '4725'},
    { city: 'Hellenthal', area: '2482'},
    { city: 'Hellenthal-Rescheid', area: '2448'},
    { city: 'Helmbrechts', area: '9252'},
    { city: 'Helmstedt', area: '5351'},
    { city: 'Helmstedt-Barmke', area: '5356'},
    { city: 'Hemau', area: '9491'},
    { city: 'Hemer', area: '2372'},
    { city: 'Hemeringen', area: '5158'},
    { city: 'Hemmoor', area: '4771'},
    { city: 'Hengersberg Bay', area: '9901'},
    { city: 'Henneberg', area: '36945'},
    { city: 'Hennef Sieg', area: '2242'},
    { city: 'Hennef-Uckerath', area: '2248'},
    { city: 'Hennickendorf b Luckenwalde', area: '33732'},
    { city: 'Hennigsdorf', area: '3302'},
    { city: 'Henningen', area: '39038'},
    { city: 'Hennstedt b Itzehoe', area: '4877'},
    { city: 'Hennstedt Dithm', area: '4836'},
    { city: 'Henrichenburg', area: '2367'},
    { city: 'Henstedt-Ulzburg', area: '4193'},
    { city: 'Heppenheim Bergstraße', area: '6252'},
    { city: 'Herbertingen', area: '7586'},
    { city: 'Herbolzheim Breisgau', area: '7643'},
    { city: 'Herborn Hess', area: '2772'},
    { city: 'Herbrechtingen', area: '7324'},
    { city: 'Herbstein', area: '6643'},
    { city: 'Herbstein-Stockhausen', area: '6647'},
    { city: 'Herdecke', area: '2330'},
    { city: 'Herdorf', area: '2744'},
    { city: 'Herdwangen-Schönach', area: '7557'},
    { city: 'Herford', area: '5221'},
    { city: 'Hergatz', area: '8385'},
    { city: 'Hergensweiler', area: '8388'},
    { city: 'Heringen Helme', area: '36333'},
    { city: 'Heringen Werra', area: '6624'},
    { city: 'Heringsdorf Holst', area: '4365'},
    { city: 'Heringsdorf Seebad', area: '38378'},
    { city: 'Herleshausen', area: '5654'},
    { city: 'Hermannsburg', area: '5052'},
    { city: 'Hermeskeil', area: '6503'},
    { city: 'Hermsdorf Erzgeb', area: '35057'},
    { city: 'Hermsdorf Thür', area: '36601'},
    { city: 'Herne', area: '2323'},
    { city: 'Heroldsbach', area: '9190'},
    { city: 'Heroldstatt', area: '7389'},
    { city: 'Herrenberg', area: '7032'},
    { city: 'Herrieden', area: '9825'},
    { city: 'Herrischried', area: '7764'},
    { city: 'Herrnhut', area: '35873'},
    { city: 'Herrsching a Ammersee', area: '8152'},
    { city: 'Herrstein', area: '6785'},
    { city: 'Hersbruck', area: '9151'},
    { city: 'Herscheid Westf', area: '2357'},
    { city: 'Herten Westf', area: '2366'},
    { city: 'Herxheim bei Landau Pfalz', area: '7276'},
    { city: 'Herzberg am Harz', area: '5521'},
    { city: 'Herzberg Elster', area: '3535'},
    { city: 'Herzberg Mark', area: '33926'},
    { city: 'Herzberg-Sieber', area: '5585'},
    { city: 'Herzebrock-Clarholz', area: '5245'},
    { city: 'Herzfelde b Strausberg', area: '33434'},
    { city: 'Herzlake', area: '5962'},
    { city: 'Herzogenaurach', area: '9132'},
    { city: 'Herzogenrath', area: '2406'},
    { city: 'Herzogenrath-Kohlscheid', area: '2407'},
    { city: 'Herzsprung b Wittstock', area: '33965'},
    { city: 'Heßdorf Mittelfr', area: '9135'},
    { city: 'Hessen', area: '39426'},
    { city: 'Hesseneck', area: '6276'},
    { city: 'Hessisch Lichtenau', area: '5602'},
    { city: 'Hessisch Oldendorf', area: '5152'},
    { city: 'Hettstedt Sachs-Anh', area: '3476'},
    { city: 'Hetzdorf b Strasburg', area: '39745'},
    { city: 'Hetzerath Mosel', area: '6508'},
    { city: 'Heubach', area: '7173'},
    { city: 'Heubisch', area: '36761'},
    { city: 'Heuckewalde', area: '34423'},
    { city: 'Heudeber', area: '39458'},
    { city: 'Heusenstamm', area: '6104'},
    { city: 'Heusweiler', area: '6806'},
    { city: 'Heuthen', area: '36084'},
    { city: 'Heyda b Riesa', area: '35266'},
    { city: 'Hilchenbach', area: '2733'},
    { city: 'Hildburghausen', area: '3685'},
    { city: 'Hilden', area: '2103'},
    { city: 'Hilders', area: '6681'},
    { city: 'Hildesheim', area: '5121'},
    { city: 'Hilgermissen', area: '4256'},
    { city: 'Hilgertshausen-Tandern', area: '8250'},
    { city: 'Hille', area: '5703'},
    { city: 'Hillerse Kr Gifhorn', area: '5373'},
    { city: 'Hillesheim Eifel', area: '6593'},
    { city: 'Hilpoltstein', area: '9174'},
    { city: 'Hilter am Teutoburger Wald', area: '5409'},
    { city: 'Hilzingen', area: '7739'},
    { city: 'Himbergen', area: '5828'},
    { city: 'Himmelpfort', area: '33089'},
    { city: 'Himmelpforten', area: '4144'},
    { city: 'Hindelang', area: '8324'},
    { city: 'Hinte', area: '4925'},
    { city: 'Hinterhermsdorf', area: '35974'},
    { city: 'Hintersee', area: '39776'},
    { city: 'Hinterweidenthal', area: '6396'},
    { city: 'Hinterzarten', area: '7652'},
    { city: 'Hipstedt', area: '4768'},
    { city: 'Hirrlingen', area: '7478'},
    { city: 'Hirschaid', area: '9543'},
    { city: 'Hirschau Oberpf', area: '9622'},
    { city: 'Hirschberg Saale', area: '36644'},
    { city: 'Hirschfeld b Elsterwerda', area: '35343'},
    { city: 'Hirschfelde b Zittau', area: '35843'},
    { city: 'Hirschhorn Neckar', area: '6272'},
    { city: 'Hitzacker Elbe', area: '5862'},
    { city: 'Hitzacker-Wietzetze', area: '5858'},
    { city: 'Hochdorf Riß', area: '7355'},
    { city: 'Hochdorf-Assenheim', area: '6231'},
    { city: 'Höchheim', area: '9764'},
    { city: 'Hochheim am Main', area: '6146'},
    { city: 'Hochkirch', area: '35939'},
    { city: 'Hochspeyer', area: '6305'},
    { city: 'Höchst i Odw', area: '6163'},
    { city: 'Höchstadt a d Aisch', area: '9193'},
    { city: 'Höchstädt a d Donau', area: '9074'},
    { city: 'Hochstadt Pfalz', area: '6347'},
    { city: 'Höckendorf b Dippoldiswalde', area: '35055'},
    { city: 'Hockenheim', area: '6205'},
    { city: 'Hodenhagen', area: '5164'},
    { city: 'Hof Saale', area: '9281'},
    { city: 'Hofbieber', area: '6657'},
    { city: 'Hofbieber-Schwarzbach', area: '6684'},
    { city: 'Hofgeismar', area: '5671'},
    { city: 'Hofheim am Taunus', area: '6192'},
    { city: 'Hofheim i Ufr', area: '9523'},
    { city: 'Hofheim-Wallau', area: '6122'},
    { city: 'Hofkirchen Bay', area: '8545'},
    { city: 'Hohberg b Offenburg', area: '7808'},
    { city: 'Hohburg', area: '34263'},
    { city: 'Hohenahr', area: '6446'},
    { city: 'Hohenaspe', area: '4893'},
    { city: 'Hohenau Niederbay', area: '8558'},
    { city: 'Hohenberg-Krusemark', area: '39394'},
    { city: 'Hohenburg', area: '9626'},
    { city: 'Hohenfelde b Kiel', area: '4385'},
    { city: 'Hohenfels Oberpf', area: '9472'},
    { city: 'Hohenhameln', area: '5128'},
    { city: 'Hohenkirchen b Wismar', area: '38428'},
    { city: 'Höhenkirchen-Siegertsbrunn', area: '8102'},
    { city: 'Hohenlockstedt', area: '4826'},
    { city: 'Hohenmocker', area: '39993'},
    { city: 'Hohenmölsen', area: '34441'},
    { city: 'Hohennauen', area: '33872'},
    { city: 'Hohenpeissenberg', area: '8805'},
    { city: 'Hohenpriessnitz', area: '34242'},
    { city: 'Hohenroda Hess', area: '6676'},
    { city: 'Hohensaaten', area: '33368'},
    { city: 'Hohenseefeld', area: '33744'},
    { city: 'Hohenstein Württ', area: '7387'},
    { city: 'Hohenstein-Ernstthal', area: '3723'},
    { city: 'Hohenthann', area: '8784'},
    { city: 'Hohenwart Paar', area: '8443'},
    { city: 'Hohenwarth b Kötzing', area: '9946'},
    { city: 'Hohenwestedt', area: '4871'},
    { city: 'Hohenziatz', area: '39226'},
    { city: 'Hohenzieritz', area: '39824'},
    { city: 'Hohn b Rendsburg', area: '4335'},
    { city: 'Hohne b Celle', area: '5083'},
    { city: 'Hohnstein', area: '35975'},
    { city: 'Hohnstorf Elbe', area: '4139'},
    { city: 'Höhr-Grenzhausen', area: '2624'},
    { city: 'Holdorf Niedersachs', area: '5494'},
    { city: 'Holle b Hildesheim', area: '5062'},
    { city: 'Hollenstedt Nordheide', area: '4165'},
    { city: 'Hollfeld', area: '9274'},
    { city: 'Holm-Seppensen', area: '4187'},
    { city: 'Holsthum', area: '6523'},
    { city: 'Holthusen', area: '3865'},
    { city: 'Holtland', area: '4950'},
    { city: 'Holzappel', area: '6439'},
    { city: 'Holzdorf Elster', area: '35389'},
    { city: 'Holzendorf b Prenzlau', area: '39853'},
    { city: 'Holzengel', area: '36379'},
    { city: 'Holzgünz', area: '8393'},
    { city: 'Holzkirchen', area: '8024'},
    { city: 'Holzminden', area: '5531'},
    { city: 'Holzminden-Neuhaus', area: '5536'},
    { city: 'Holzwickede', area: '2301'},
    { city: 'Homberg Efze', area: '5681'},
    { city: 'Homberg Ohm', area: '6633'},
    { city: 'Homburg Saar', area: '6841'},
    { city: 'Homburg-Einöd', area: '6848'},
    { city: 'Hooge', area: '4849'},
    { city: 'Hoogstede', area: '5944'},
    { city: 'Hoppenrade b Güstrow', area: '38451'},
    { city: 'Hoppenrade Kr Prignitz', area: '33982'},
    { city: 'Hopsten', area: '5458'},
    { city: 'Hopsten-Schale', area: '5457'},
    { city: 'Horb am Neckar', area: '7451'},
    { city: 'Horb-Altheim', area: '7486'},
    { city: 'Horb-Dettingen', area: '7482'},
    { city: 'Horb-Mühringen', area: '7483'},
    { city: 'Horgau', area: '8294'},
    { city: 'Horgenzell', area: '7504'},
    { city: 'Horhausen Westerwald', area: '2687'},
    { city: 'Horka OL', area: '35892'},
    { city: 'Hornbach Pfalz', area: '6338'},
    { city: 'Horn-Bad Meinberg', area: '5234'},
    { city: 'Hornberg Schwarzwaldbahn', area: '7833'},
    { city: 'Hornburg Kr Wolfenbüttel', area: '5334'},
    { city: 'Horneburg Niederelbe', area: '4163'},
    { city: 'Hornow', area: '35698'},
    { city: 'Hörsingen', area: '39055'},
    { city: 'Horsmar', area: '36023'},
    { city: 'Horst b Grimmen', area: '38333'},
    { city: 'Horst Holstein', area: '4126'},
    { city: 'Horstedt Kr Rotenburg', area: '4288'},
    { city: 'Hörstel', area: '5459'},
    { city: 'Hörstel-Dreierwalde', area: '5978'},
    { city: 'Hörstel-Riesenbeck', area: '5454'},
    { city: 'Horstmar', area: '2558'},
    { city: 'Hosena', area: '35756'},
    { city: 'Hosenfeld', area: '6650'},
    { city: 'Hosskirch', area: '7587'},
    { city: 'Hötensleben', area: '39405'},
    { city: 'Hövelhof', area: '5257'},
    { city: 'Hövelhof-Espeln', area: '5294'},
    { city: 'Höxter', area: '5271'},
    { city: 'Höxter-Fürstenau', area: '5277'},
    { city: 'Höxter-Ottbergen', area: '5275'},
    { city: 'Höxter-Ovenhausen', area: '5278'},
    { city: 'Hoya', area: '4251'},
    { city: 'Hoyerswerda', area: '3571'},
    { city: 'Hückelhoven', area: '2433'},
    { city: 'Hückeswagen', area: '2192'},
    { city: 'Hude Oldenburg', area: '4408'},
    { city: 'Hude-Wüsting', area: '4484'},
    { city: 'Hüffenhardt', area: '6268'},
    { city: 'Huglfing', area: '8802'},
    { city: 'Hüllhorst', area: '5744'},
    { city: 'Hünfeld', area: '6652'},
    { city: 'Hünfelden', area: '6438'},
    { city: 'Hungen', area: '6402'},
    { city: 'Hünxe', area: '2858'},
    { city: 'Hürtgenwald', area: '2429'},
    { city: 'Hürth Rheinl', area: '2233'},
    { city: 'Husby', area: '4634'},
    { city: 'Husum Nordsee', area: '4841'},
    { city: 'Hutthurm', area: '8505'},
    { city: 'Ibbenbüren', area: '5451'},
    { city: 'Ichenhausen', area: '8223'},
    { city: 'Icking', area: '8178'},
    { city: 'Idar-Oberstein', area: '6781'},
    { city: 'Iden', area: '39390'},
    { city: 'Idstein', area: '6126'},
    { city: 'Iffezheim', area: '7229'},
    { city: 'Ihlienworth', area: '4755'},
    { city: 'Ihlow Kr Aurich', area: '4929'},
    { city: 'Ihlow-Riepe', area: '4928'},
    { city: 'Ihringen', area: '7668'},
    { city: 'Ilfeld', area: '36331'},
    { city: 'Illerkirchberg', area: '7346'},
    { city: 'Illertissen', area: '7303'},
    { city: 'Illingen Saar', area: '6825'},
    { city: 'Illmensee', area: '7558'},
    { city: 'Illschwang', area: '9666'},
    { city: 'Ilmenau Thür', area: '3677'},
    { city: 'Ilsede', area: '5172'},
    { city: 'Ilsenburg', area: '39452'},
    { city: 'Ilshofen', area: '7904'},
    { city: 'Immendingen', area: '7462'},
    { city: 'Immenhausen Hess', area: '5673'},
    { city: 'Immenstaad am Bodensee', area: '7545'},
    { city: 'Immenstadt i Allgäu', area: '8323'},
    { city: 'Inchenhofen', area: '8257'},
    { city: 'Inden', area: '2465'},
    { city: 'Ingelheim am Rhein', area: '6132'},
    { city: 'Ingolstadt Donau', area: '841'},
    { city: 'Ingolstadt-Zuchering', area: '8450'},
    { city: 'Inning a Ammersee', area: '8143'},
    { city: 'Insel Hiddensee', area: '38300'},
    { city: 'Insul', area: '2695'},
    { city: 'Inzell', area: '8665'},
    { city: 'Iphofen', area: '9323'},
    { city: 'Ippesheim', area: '9339'},
    { city: 'Ipsheim', area: '9846'},
    { city: 'Irrel', area: '6525'},
    { city: 'Irrhausen', area: '6550'},
    { city: 'Isen', area: '8083'},
    { city: 'Isenbüttel', area: '5374'},
    { city: 'Iserlohn', area: '2371'},
    { city: 'Iserlohn-Letmathe', area: '2374'},
    { city: 'Isny im Allgäu', area: '7562'},
    { city: 'Isny-Eisenbach', area: '7569'},
    { city: 'Isselburg', area: '2874'},
    { city: 'Isselburg-Werth', area: '2873'},
    { city: 'Isserstedt', area: '36425'},
    { city: 'Issum', area: '2835'},
    { city: 'Itterbeck', area: '5948'},
    { city: 'Itzehoe', area: '4821'},
    { city: 'Jabel b Waren', area: '39929'},
    { city: 'Jachenau', area: '8043'},
    { city: 'Jacobsdorf Mark', area: '33608'},
    { city: 'Jade', area: '4454'},
    { city: 'Jade-Schweiburg', area: '4455'},
    { city: 'Jagstzell', area: '7967'},
    { city: 'Jakobshagen', area: '39885'},
    { city: 'Jameln', area: '5864'},
    { city: 'Janisroda', area: '34466'},
    { city: 'Janneby', area: '4607'},
    { city: 'Jänschwalde', area: '35607'},
    { city: 'Jarmen', area: '39997'},
    { city: 'Jatznick', area: '39741'},
    { city: 'Jävenitz', area: '39086'},
    { city: 'Jeber-Bergfrieden', area: '34907'},
    { city: 'Jembke', area: '5366'},
    { city: 'Jemgum', area: '4958'},
    { city: 'Jemgum-Ditzum', area: '4902'},
    { city: 'Jena', area: '3641'},
    { city: 'Jerchel Altmark', area: '39087'},
    { city: 'Jerichow', area: '39343'},
    { city: 'Jerxheim', area: '5354'},
    { city: 'Jesberg', area: '6695'},
    { city: 'Jesewitz', area: '34241'},
    { city: 'Jessen Elster', area: '3537'},
    { city: 'Jesteburg', area: '4183'},
    { city: 'Jestetten', area: '7745'},
    { city: 'Jettingen-Scheppach', area: '8225'},
    { city: 'Jevenstedt', area: '4337'},
    { city: 'Jever', area: '4461'},
    { city: 'Joachimsthal', area: '33361'},
    { city: 'Jocketa', area: '37439'},
    { city: 'Johanngeorgenstadt', area: '3773'},
    { city: 'Johanniskirchen', area: '8564'},
    { city: 'Jöhstadt', area: '37343'},
    { city: 'Joldelund', area: '4673'},
    { city: 'Jördenstorf', area: '39977'},
    { city: 'Jork', area: '4162'},
    { city: 'Jossgrund', area: '6059'},
    { city: 'Jübar', area: '39003'},
    { city: 'Jübek', area: '4625'},
    { city: 'Jüchen', area: '2165'},
    { city: 'Jüchen-Otzenrath', area: '2164'},
    { city: 'Jüchsen', area: '36947'},
    { city: 'Juist', area: '4935'},
    { city: 'Jülich', area: '2461'},
    { city: 'Jungingen b Hechingen', area: '7477'},
    { city: 'Jünkerath', area: '6597'},
    { city: 'Jürgenshagen', area: '38466'},
    { city: 'Jürgenstorf Meckl', area: '39955'},
    { city: 'Jüterbog', area: '3372'},
    { city: 'Kaarssen', area: '38845'},
    { city: 'Kade', area: '39347'},
    { city: 'Kahl a Main', area: '6188'},
    { city: 'Kahla Thür', area: '36424'},
    { city: 'Kaisersbach', area: '7184'},
    { city: 'Kaisersesch', area: '2653'},
    { city: 'Kaiserslautern', area: '631'},
    { city: 'Kaisheim', area: '9099'},
    { city: 'Kakerbeck Sachs-Anh', area: '39081'},
    { city: 'Kalbach Rhön', area: '9742'},
    { city: 'Kalbe Milde', area: '39080'},
    { city: 'Kalefeld', area: '5553'},
    { city: 'Kalkar', area: '2824'},
    { city: 'Kalkhorst', area: '38827'},
    { city: 'Kall', area: '2441'},
    { city: 'Kalletal', area: '5264'},
    { city: 'Kalletal-Varenholz', area: '5755'},
    { city: 'Kallmünz', area: '9473'},
    { city: 'Kaltenkirchen Holst', area: '4191'},
    { city: 'Kaltennordheim', area: '36966'},
    { city: 'Kamen', area: '2307'},
    { city: 'Kamenz', area: '3578'},
    { city: 'Kamern', area: '39382'},
    { city: 'Kammerforst Thür', area: '36028'},
    { city: 'Kamp-Bornhofen', area: '6773'},
    { city: 'Kamp-Lintfort', area: '2842'},
    { city: 'Kandel', area: '7275'},
    { city: 'Kandern', area: '7626'},
    { city: 'Kappeln Schlei', area: '4642'},
    { city: 'Kappelrodeck', area: '7842'},
    { city: 'Karben', area: '6039'},
    { city: 'Karbow-Vietlübbe', area: '38733'},
    { city: 'Karby', area: '4644'},
    { city: 'Karlsbad', area: '7202'},
    { city: 'Karlshagen', area: '38371'},
    { city: 'Karlshuld', area: '8454'},
    { city: 'Karlsruhe', area: '721'},
    { city: 'Karlstadt', area: '9353'},
    { city: 'Karlstadt-Wiesenfeld', area: '9359'},
    { city: 'Karow b Lübz', area: '38738'},
    { city: 'Karstädt Kr Prignitz', area: '38797'},
    { city: 'Karwesee', area: '33922'},
    { city: 'Kasendorf-Azendorf', area: '9220'},
    { city: 'Kassel', area: '561'},
    { city: 'Kastellaun', area: '6762'},
    { city: 'Kastl b Amberg', area: '9625'},
    { city: 'Kastorf Holst', area: '4501'},
    { city: 'Katlenburg', area: '5552'},
    { city: 'Katzenelnbogen', area: '6486'},
    { city: 'Katzow', area: '38373'},
    { city: 'Kaub', area: '6774'},
    { city: 'Kaufbeuren', area: '8341'},
    { city: 'Kaufungen Hess', area: '5605'},
    { city: 'Kaulsdorf', area: '36733'},
    { city: 'Kavelstorf', area: '38208'},
    { city: 'Kayna', area: '34426'},
    { city: 'Kefenrod', area: '6049'},
    { city: 'Kehl', area: '7851'},
    { city: 'Kehl-Bodersweier', area: '7853'},
    { city: 'Kehl-Goldscheuer', area: '7854'},
    { city: 'Kehnert', area: '39366'},
    { city: 'Kelberg', area: '2692'},
    { city: 'Kelheim', area: '9441'},
    { city: 'Kelkheim Taunus', area: '6195'},
    { city: 'Kell am See', area: '6589'},
    { city: 'Kellinghusen', area: '4822'},
    { city: 'Kelsterbach', area: '6107'},
    { city: 'Keltern', area: '7236'},
    { city: 'Kemberg', area: '34921'},
    { city: 'Kemnath Stadt', area: '9642'},
    { city: 'Kemnitz b Greifswald', area: '38352'},
    { city: 'Kempen', area: '2152'},
    { city: 'Kempfeld', area: '6786'},
    { city: 'Kempten Allgäu', area: '831'},
    { city: 'Kenzingen', area: '7644'},
    { city: 'Kerken', area: '2833'},
    { city: 'Kerkwitz', area: '35692'},
    { city: 'Kerpen Rheinl-Türnich', area: '2237'},
    { city: 'Kerpen-Buir', area: '2275'},
    { city: 'Kerpen-Horrem', area: '2273'},
    { city: 'Kesseling', area: '2647'},
    { city: 'Ketzin', area: '33233'},
    { city: 'Kevelaer', area: '2832'},
    { city: 'Kiel', area: '431'},
    { city: 'Kienberg Oberbay', area: '8628'},
    { city: 'Kierspe', area: '2359'},
    { city: 'Kierspe-Rönsahl', area: '2269'},
    { city: 'Kindelbrück', area: '36375'},
    { city: 'Kinding', area: '8467'},
    { city: 'Kinsau', area: '8869'},
    { city: 'Kipfenberg', area: '8465'},
    { city: 'Kippenheim', area: '7825'},
    { city: 'Kipsdorf Kurort', area: '35052'},
    { city: 'Kirchanschöring', area: '8685'},
    { city: 'Kirchardt', area: '7266'},
    { city: 'Kirchbarkau', area: '4302'},
    { city: 'Kirchberg an der Jagst', area: '7954'},
    { city: 'Kirchberg Hunsrück', area: '6763'},
    { city: 'Kirchberg Sachs', area: '37602'},
    { city: 'Kirchberg Wald', area: '9927'},
    { city: 'Kirchdorf b Sulingen', area: '4273'},
    { city: 'Kirchdorf i Wald', area: '9928'},
    { city: 'Kirchdorf Poel', area: '38425'},
    { city: 'Kirchenlamitz', area: '9285'},
    { city: 'Kirchenthumbach', area: '9647'},
    { city: 'Kirchgellersen', area: '4135'},
    { city: 'Kirchhain', area: '6422'},
    { city: 'Kirchheilingen', area: '36043'},
    { city: 'Kirchheim i Schw', area: '8266'},
    { city: 'Kirchheim unter Teck', area: '7021'},
    { city: 'Kirchheimbolanden', area: '6352'},
    { city: 'Kirchhundem', area: '2723'},
    { city: 'Kirchlauter', area: '9536'},
    { city: 'Kirchlinteln', area: '4236'},
    { city: 'Kirchroth', area: '9428'},
    { city: 'Kirchseeon', area: '8091'},
    { city: 'Kirchtimke', area: '4289'},
    { city: 'Kirchweidach', area: '8623'},
    { city: 'Kirchzarten', area: '7661'},
    { city: 'Kirkel', area: '6849'},
    { city: 'Kirn Nahe', area: '6752'},
    { city: 'Kirschau', area: '3592'},
    { city: 'Kirtorf', area: '6635'},
    { city: 'Kisselbach', area: '6766'},
    { city: 'Kissenbrück', area: '5337'},
    { city: 'Kissing', area: '8233'},
    { city: 'Kisslegg', area: '7563'},
    { city: 'Kist', area: '9306'},
    { city: 'Kitzingen', area: '9321'},
    { city: 'Kläden b Stendal', area: '39324'},
    { city: 'Kladrum', area: '38723'},
    { city: 'Klanxbüll', area: '4668'},
    { city: 'Kleeth', area: '39602'},
    { city: 'Klein Berssen', area: '5965'},
    { city: 'Klein Bünzow', area: '39724'},
    { city: 'Kleinau', area: '39399'},
    { city: 'Kleinblittersdorf', area: '6805'},
    { city: 'Kleinich', area: '6536'},
    { city: 'Kleinlangheim', area: '9325'},
    { city: 'Kleinmachnow', area: '33203'},
    { city: 'Kleinneuhausen', area: '36372'},
    { city: 'Kleinow Kr Prignitz', area: '38784'},
    { city: 'Kleinschmalkalden', area: '36849'},
    { city: 'Kleinwelka', area: '35935'},
    { city: 'Kleptow', area: '39854'},
    { city: 'Klettbach', area: '36209'},
    { city: 'Klettenberg', area: '36336'},
    { city: 'Klettgau', area: '7742'},
    { city: 'Klettwitz', area: '35754'},
    { city: 'Kleve Niederrhein', area: '2821'},
    { city: 'Klietz', area: '39327'},
    { city: 'Klingenberg a Main', area: '9372'},
    { city: 'Klingenberg Sachs', area: '35202'},
    { city: 'Klingenthal Sachs', area: '37467'},
    { city: 'Klitsche', area: '39348'},
    { city: 'Klitten', area: '35895'},
    { city: 'Klöden', area: '35388'},
    { city: 'Klosterfelde', area: '33396'},
    { city: 'Klötze Altmark', area: '3909'},
    { city: 'Klüden', area: '39056'},
    { city: 'Klütz', area: '38825'},
    { city: 'Knau b Pößneck', area: '36484'},
    { city: 'Knetzgau', area: '9527'},
    { city: 'Knüllwald', area: '5685'},
    { city: 'Kobern-Gondorf', area: '2607'},
    { city: 'Koblenz a Rhein', area: '261'},
    { city: 'Kochel a See', area: '8851'},
    { city: 'Kochel-Walchensee', area: '8858'},
    { city: 'Köckte b Gardelegen', area: '39004'},
    { city: 'Kodersdorf', area: '35825'},
    { city: 'Kohlberg Oberpf', area: '9608'},
    { city: 'Kohren-Sahlis', area: '34344'},
    { city: 'Kolitzheim', area: '9385'},
    { city: 'Kölleda', area: '3635'},
    { city: 'Kollmar', area: '4128'},
    { city: 'Köln', area: '221'},
    { city: 'Köln-Porz', area: '2203'},
    { city: 'Kölschhausen', area: '6440'},
    { city: 'Komptendorf', area: '35605'},
    { city: 'Köngernheim', area: '6737'},
    { city: 'Königheim-Brehmen', area: '9340'},
    { city: 'Königs Wusterhausen', area: '3375'},
    { city: 'Königsbach-Stein', area: '7232'},
    { city: 'Königsberg i Bay', area: '9525'},
    { city: 'Königsbronn', area: '7328'},
    { city: 'Königsbrück', area: '35795'},
    { city: 'Königsbrunn b Augsburg', area: '8231'},
    { city: 'Königsee', area: '36738'},
    { city: 'Königsfeld Eifel', area: '2646'},
    { city: 'Königsfeld im Schwarzwald', area: '7725'},
    { city: 'Königsfeld Oberfr', area: '9207'},
    { city: 'Königshain b Görlitz', area: '35826'},
    { city: 'Königslutter am Elm', area: '5353'},
    { city: 'Königsmoor', area: '4180'},
    { city: 'Königsmoos', area: '8433'},
    { city: 'Königstein im Taunus', area: '6174'},
    { city: 'Königstein Oberpf', area: '9665'},
    { city: 'Königstein Sächs Schweiz', area: '35021'},
    { city: 'Königswartha', area: '35931'},
    { city: 'Königswinter', area: '2223'},
    { city: 'Königswinter-Oberpleis', area: '2244'},
    { city: 'Könitz', area: '36732'},
    { city: 'Konken', area: '6384'},
    { city: 'Könnern', area: '34691'},
    { city: 'Konradsreuth', area: '9292'},
    { city: 'Konstanz', area: '7531'},
    { city: 'Konz', area: '6501'},
    { city: 'Konzell', area: '9963'},
    { city: 'Korbach', area: '5631'},
    { city: 'Kordel', area: '6505'},
    { city: 'Körner', area: '36025'},
    { city: 'Korntal-Münchingen', area: '7150'},
    { city: 'Kornwestheim', area: '7154'},
    { city: 'Körperich', area: '6566'},
    { city: 'Koserow', area: '38375'},
    { city: 'Kößlarn', area: '8536'},
    { city: 'Kotelow', area: '39607'},
    { city: 'Köthen Anhalt', area: '3496'},
    { city: 'Kötzting', area: '9941'},
    { city: 'Krackow', area: '39746'},
    { city: 'Kraftsdorf', area: '36606'},
    { city: 'Kraichtal', area: '7250'},
    { city: 'Krakow am See', area: '38457'},
    { city: 'Kranenburg Niederrhein', area: '2826'},
    { city: 'Kranichfeld', area: '36450'},
    { city: 'Kratzeburg', area: '39822'},
    { city: 'Krauchenwies', area: '7576'},
    { city: 'Krautheim Jagst', area: '6294'},
    { city: 'Krefeld', area: '2151'},
    { city: 'Kreiensen', area: '5563'},
    { city: 'Kreischa b Dresden', area: '35206'},
    { city: 'Kremmen', area: '33055'},
    { city: 'Krempe', area: '4824'},
    { city: 'Krensitz', area: '34295'},
    { city: 'Kressberg', area: '7957'},
    { city: 'Kressbronn am Bodensee', area: '7543'},
    { city: 'Kreuth b Tegernsee', area: '8029'},
    { city: 'Kreuzau', area: '2422'},
    { city: 'Kreuztal', area: '2732'},
    { city: 'Kriegsfeld', area: '6358'},
    { city: 'Krien', area: '39723'},
    { city: 'Krieschow', area: '35604'},
    { city: 'Krippen', area: '35028'},
    { city: 'Kritzkow', area: '38454'},
    { city: 'Krögis', area: '35244'},
    { city: 'Kronach', area: '9261'},
    { city: 'Kronberg im Taunus', area: '6173'},
    { city: 'Kronprinzenkoog', area: '4856'},
    { city: 'Kröpelin', area: '38292'},
    { city: 'Kropp', area: '4624'},
    { city: 'Kroppach', area: '2688'},
    { city: 'Kroppenstedt', area: '39264'},
    { city: 'Kropstädt', area: '34920'},
    { city: 'Kröslin', area: '38370'},
    { city: 'Krumbach Schwaben', area: '8282'},
    { city: 'Krummesse', area: '4508'},
    { city: 'Krummhörn-Greetsiel', area: '4926'},
    { city: 'Krummhörn-Loquard', area: '4927'},
    { city: 'Krummhörn-Pewsum', area: '4923'},
    { city: 'Krün', area: '8825'},
    { city: 'Kuhfelde', area: '39035'},
    { city: 'Kühlungsborn Ostseebad', area: '38293'},
    { city: 'Kühren b Wurzen', area: '34261'},
    { city: 'Kulmbach', area: '9221'},
    { city: 'Külsheim Baden', area: '9345'},
    { city: 'Kunrau', area: '39008'},
    { city: 'Kunreuth', area: '9199'},
    { city: 'Künzelsau', area: '7940'},
    { city: 'Kupferzell', area: '7944'},
    { city: 'Küps', area: '9264'},
    { city: 'Kürten', area: '2268'},
    { city: 'Kürten-Dürscheid', area: '2207'},
    { city: 'Kusel', area: '6381'},
    { city: 'Kusey', area: '39005'},
    { city: 'Küstrin-Kietz', area: '33479'},
    { city: 'Kutenholz', area: '4762'},
    { city: 'Kyllburg', area: '6563'},
    { city: 'Kyritz Brandenb', area: '33971'},
    { city: 'Laaber', area: '9498'},
    { city: 'Laage', area: '38459'},
    { city: 'Laar Vechte', area: '5947'},
    { city: 'Laasow b Calau', area: '35436'},
    { city: 'Laatzen', area: '5102'},
    { city: 'Laboe', area: '4343'},
    { city: 'Ladbergen', area: '5485'},
    { city: 'Ladelund', area: '4666'},
    { city: 'Ladenburg', area: '6203'},
    { city: 'Laer Kr Steinfurt', area: '2554'},
    { city: 'Lage Lippe', area: '5232'},
    { city: 'Lägerdorf', area: '4828'},
    { city: 'Lähden', area: '5964'},
    { city: 'Lahnstein', area: '2621'},
    { city: 'Lahntal', area: '6420'},
    { city: 'Lahr Schwarzwald', area: '7821'},
    { city: 'Lahstedt', area: '5174'},
    { city: 'Laichingen', area: '7333'},
    { city: 'Lalendorf', area: '38452'},
    { city: 'Lalling', area: '9904'},
    { city: 'Lam Oberpf', area: '9943'},
    { city: 'Lambrecht Pfalz', area: '6325'},
    { city: 'Lamerdingen', area: '8248'},
    { city: 'Lampertheim', area: '6206'},
    { city: 'Lampertheim-Hüttenfeld', area: '6256'},
    { city: 'Lamspringe', area: '5183'},
    { city: 'Lamstedt', area: '4773'},
    { city: 'Landau a d Isar', area: '9951'},
    { city: 'Landau in der Pfalz', area: '6341'},
    { city: 'Landsberg a Lech', area: '8191'},
    { city: 'Landsberg Sachs-Anh', area: '34602'},
    { city: 'Landscheid', area: '6575'},
    { city: 'Landshut', area: '871'},
    { city: 'Landstuhl', area: '6371'},
    { city: 'Langballig', area: '4636'},
    { city: 'Langebrück', area: '35201'},
    { city: 'Langelsheim', area: '5326'},
    { city: 'Langen b Bremerhaven', area: '4743'},
    { city: 'Langen Hess', area: '6103'},
    { city: 'Langenau Württ', area: '7345'},
    { city: 'Langenberg Kr Gütersloh', area: '5248'},
    { city: 'Langenburg', area: '7905'},
    { city: 'Langenenslingen', area: '7376'},
    { city: 'Langeneß Hallig', area: '4684'},
    { city: 'Langenfeld Mittelfr', area: '9164'},
    { city: 'Langenfeld Rheinland', area: '2173'},
    { city: 'Langenhennersdorf', area: '35032'},
    { city: 'Langenhorn', area: '4672'},
    { city: 'Langenleuba-Niederhain', area: '34497'},
    { city: 'Langenlonsheim', area: '6704'},
    { city: 'Langen-Neuenwalde', area: '4707'},
    { city: 'Langenneufnach', area: '8239'},
    { city: 'Langenselbold', area: '6184'},
    { city: 'Langenweddingen', area: '39205'},
    { city: 'Langenwetzendorf', area: '36625'},
    { city: 'Langenzenn', area: '9101'},
    { city: 'Langeoog', area: '4972'},
    { city: 'Langerwehe', area: '2423'},
    { city: 'Langgöns-Niederkleen', area: '6447'},
    { city: 'Langhagen b Güstrow', area: '38456'},
    { city: 'Langlingen', area: '5082'},
    { city: 'Langquaid', area: '9452'},
    { city: 'Langwedel Holst', area: '4329'},
    { city: 'Langwedel Kr Verden', area: '4232'},
    { city: 'Langwedel-Etelsen', area: '4235'},
    { city: 'Lanz Brandenb', area: '38780'},
    { city: 'Lassahn', area: '38858'},
    { city: 'Lassan b Wolgast', area: '38374'},
    { city: 'Lastrup', area: '4472'},
    { city: 'Lastrup-Hemmelte', area: '4477'},
    { city: 'Lathen', area: '5933'},
    { city: 'Laubach Hess', area: '6405'},
    { city: 'Laucha Unstrut', area: '34462'},
    { city: 'Lauchhammer', area: '3574'},
    { city: 'Lauchheim', area: '7363'},
    { city: 'Lauda-Königshofen', area: '9343'},
    { city: 'Lauenau', area: '5043'},
    { city: 'Lauenbrück', area: '4267'},
    { city: 'Lauenburg Elbe', area: '4153'},
    { city: 'Lauenstein Sachs', area: '35054'},
    { city: 'Lauf a d Pegnitz', area: '9123'},
    { city: 'Laufach', area: '6093'},
    { city: 'Laufen Salzach', area: '8682'},
    { city: 'Lauffen am Neckar', area: '7133'},
    { city: 'Lauingen Donau', area: '9072'},
    { city: 'Laupheim', area: '7392'},
    { city: 'Lauscha', area: '36702'},
    { city: 'Lauschütz', area: '35693'},
    { city: 'Lauta b Hoyerswerda', area: '35722'},
    { city: 'Lauterbach Hessen', area: '6641'},
    { city: 'Lauterecken', area: '6382'},
    { city: 'Lauterhofen Oberpf', area: '9186'},
    { city: 'Lauterstein', area: '7332'},
    { city: 'Lautertal Odenwald', area: '6254'},
    { city: 'Lautrach', area: '8394'},
    { city: 'Lebach', area: '6881'},
    { city: 'Lebach-Steinbach', area: '6888'},
    { city: 'Lebus', area: '33604'},
    { city: 'Lebusa', area: '35364'},
    { city: 'Leck', area: '4662'},
    { city: 'Leer Ostfriesland', area: '491'},
    { city: 'Leezen', area: '4552'},
    { city: 'Legau', area: '8330'},
    { city: 'Legden', area: '2566'},
    { city: 'Lehesten Thür Wald', area: '36653'},
    { city: 'Lehnin', area: '3382'},
    { city: 'Lehrberg', area: '9820'},
    { city: 'Lehre', area: '5308'},
    { city: 'Lehre-Essenrode', area: '5301'},
    { city: 'Lehre-Wendhausen', area: '5309'},
    { city: 'Lehrte', area: '5132'},
    { city: 'Lehrte-Arpke', area: '5175'},
    { city: 'Leiblfing', area: '9427'},
    { city: 'Leichlingen Rheinland', area: '2175'},
    { city: 'Leidenborn', area: '6559'},
    { city: 'Leimen Pfalz', area: '6397'},
    { city: 'Leinburg', area: '9120'},
    { city: 'Leinefelde', area: '3605'},
    { city: 'Leinzell', area: '7175'},
    { city: 'Leipzig', area: '341'},
    { city: 'Leisnig', area: '34321'},
    { city: 'Leitzkau', area: '39241'},
    { city: 'Lembruch', area: '5447'},
    { city: 'Lemförde', area: '5443'},
    { city: 'Lemgo', area: '5261'},
    { city: 'Lemgo-Kirchheide', area: '5266'},
    { city: 'Lemgow', area: '5883'},
    { city: 'Lengede', area: '5344'},
    { city: 'Lengefeld Erzgeb', area: '37367'},
    { city: 'Lengenfeld Unterm Stein', area: '36027'},
    { city: 'Lengenfeld Vogtl', area: '37606'},
    { city: 'Lengerich Emsl', area: '5904'},
    { city: 'Lengerich Westf', area: '5481'},
    { city: 'Lenggries', area: '8042'},
    { city: 'Lenggries-Fall', area: '8045'},
    { city: 'Lennestadt', area: '2721'},
    { city: 'Lennestadt-Oedingen', area: '2725'},
    { city: 'Lenningen', area: '7026'},
    { city: 'Lensahn', area: '4363'},
    { city: 'Lenting', area: '8456'},
    { city: 'Lenzen (Elbe)', area: '38792'},
    { city: 'Lenzkirch', area: '7653'},
    { city: 'Leonberg Württ', area: '7152'},
    { city: 'Leopoldshöhe', area: '5208'},
    { city: 'Letschin', area: '33475'},
    { city: 'Letzlingen', area: '39088'},
    { city: 'Leuchtenberg', area: '9659'},
    { city: 'Leun', area: '6473'},
    { city: 'Leussow b Ludwigslust', area: '38754'},
    { city: 'Leutenberg', area: '36734'},
    { city: 'Leutershausen', area: '9823'},
    { city: 'Leutkirch im Allgäu', area: '7561'},
    { city: 'Leutkirch-Friesenhofen', area: '7567'},
    { city: 'Leverkusen', area: '214'},
    { city: 'Leverkusen-Opladen', area: '2171'},
    { city: 'Lich Hess', area: '6404'},
    { city: 'Lich-Eberstadt', area: '6004'},
    { city: 'Lichte', area: '36701'},
    { city: 'Lichtenau Baden', area: '7227'},
    { city: 'Lichtenau Mittelfr', area: '9827'},
    { city: 'Lichtenau Westf', area: '5295'},
    { city: 'Lichtenau-Atteln', area: '5292'},
    { city: 'Lichtenau-Kleinenberg', area: '5647'},
    { city: 'Lichtenberg Erzgeb', area: '37323'},
    { city: 'Lichtenfels Bay', area: '9571'},
    { city: 'Lichtenfels-Goddelsheim', area: '5636'},
    { city: 'Lichtenfels-Isling', area: '9576'},
    { city: 'Lichtenfels-Sachsenberg', area: '6454'},
    { city: 'Lichtenstein Sachs', area: '37204'},
    { city: 'Lichtenstein Württ', area: '7129'},
    { city: 'Liebenau Hess', area: '5676'},
    { city: 'Liebenau Kr Nieburg Weser', area: '5023'},
    { city: 'Liebenburg', area: '5346'},
    { city: 'Liebenwalde', area: '33054'},
    { city: 'Lieberose', area: '33671'},
    { city: 'Liebertwolkwitz', area: '34297'},
    { city: 'Liebstadt', area: '35025'},
    { city: 'Lienen', area: '5483'},
    { city: 'Lienen-Kattenvenne', area: '5484'},
    { city: 'Liepe Kr Barnim', area: '33362'},
    { city: 'Liepen b Anklam', area: '39721'},
    { city: 'Lietzen', area: '33470'},
    { city: 'Lilienthal', area: '4298'},
    { city: 'Limbach Baden', area: '6287'},
    { city: 'Limbach-Oberfrohna', area: '3722'},
    { city: 'Limburg a d Lahn', area: '6431'},
    { city: 'Lindau Anh', area: '39246'},
    { city: 'Lindau Bodensee', area: '8382'},
    { city: 'Lindau Harz', area: '5556'},
    { city: 'Linden Hess', area: '6403'},
    { city: 'Lindenberg i Allgäu', area: '8381'},
    { city: 'Lindenfels', area: '6255'},
    { city: 'Lindern Oldenburg', area: '5957'},
    { city: 'Lindhorst b Stadthagen', area: '5725'},
    { city: 'Lindlar', area: '2266'},
    { city: 'Lindow Mark', area: '33933'},
    { city: 'Lindstedt', area: '39084'},
    { city: 'Lingen (Ems)', area: '591'},
    { city: 'Linkenheim-Hochstetten', area: '7247'},
    { city: 'Linnich', area: '2462'},
    { city: 'Linsburg', area: '5027'},
    { city: 'Linz am Rhein', area: '2644'},
    { city: 'Lippetal-Herzfeld', area: '2923'},
    { city: 'Lippetal-Lippborg', area: '2527'},
    { city: 'Lippstadt', area: '2941'},
    { city: 'Lippstadt-Benninghausen', area: '2945'},
    { city: 'Lippstadt-Rebbeke', area: '2948'},
    { city: 'Lisberg', area: '9549'},
    { city: 'Litzendorf', area: '9505'},
    { city: 'Löbau', area: '3585'},
    { city: 'Lobenstein', area: '36651'},
    { city: 'Löbnitz B Delitzsch', area: '34208'},
    { city: 'Loburg', area: '39245'},
    { city: 'Löcknitz Vorpom', area: '39754'},
    { city: 'Löderburg', area: '39265'},
    { city: 'Löf', area: '2605'},
    { city: 'Löffingen', area: '7654'},
    { city: 'Lohkirchen', area: '8637'},
    { city: 'Lohmar Rheinland', area: '2246'},
    { city: 'Löhne', area: '5732'},
    { city: 'Lohne Oldenburg', area: '4442'},
    { city: 'Lohr a Main', area: '9352'},
    { city: 'Lohsa', area: '35724'},
    { city: 'Loitsche', area: '39208'},
    { city: 'Loitz b Demmin', area: '39998'},
    { city: 'Lollar', area: '6406'},
    { city: 'Lommatzsch', area: '35241'},
    { city: 'Löningen', area: '5432'},
    { city: 'Lonsee', area: '7336'},
    { city: 'Loose b Eckernförde', area: '4358'},
    { city: 'Lorch Rheingau', area: '6726'},
    { city: 'Lorch Württ', area: '7172'},
    { city: 'Lörrach', area: '7621'},
    { city: 'Lorup', area: '5954'},
    { city: 'Losheim am See', area: '6872'},
    { city: 'Lossburg', area: '7446'},
    { city: 'Löwenberg', area: '33094'},
    { city: 'Löwenstein Württ', area: '7130'},
    { city: 'Loxstedt', area: '4744'},
    { city: 'Loxstedt-Dedesdorf', area: '4740'},
    { city: 'Loxstedt-Donnern', area: '4703'},
    { city: 'Lübbecke', area: '5741'},
    { city: 'Lübben Spreewald', area: '3546'},
    { city: 'Lübbenau Spreewald', area: '3542'},
    { city: 'Lübeck', area: '451'},
    { city: 'Lübeck-Travemünde', area: '4502'},
    { city: 'Lübstorf', area: '3867'},
    { city: 'Lübtheen', area: '38855'},
    { city: 'Lübz', area: '38731'},
    { city: 'Lüchow Wendland', area: '5841'},
    { city: 'Lucka', area: '34492'},
    { city: 'Luckau Brandenb', area: '3544'},
    { city: 'Luckenwalde', area: '3371'},
    { city: 'Lückstedt', area: '39391'},
    { city: 'Lüdenscheid', area: '2351'},
    { city: 'Lüderitz', area: '39361'},
    { city: 'Lüdersdorf Kr Barnim', area: '33365'},
    { city: 'Lüdersdorf Meckl', area: '38821'},
    { city: 'Lüdershagen b Barth', area: '38227'},
    { city: 'Lüdinghausen', area: '2591'},
    { city: 'Ludwigsau Hess', area: '6670'},
    { city: 'Ludwigsburg Württ', area: '7141'},
    { city: 'Ludwigsfelde', area: '3378'},
    { city: 'Ludwigslust Meckl', area: '3874'},
    { city: 'Ludwigsstadt', area: '9263'},
    { city: 'Lugau Erzgeb', area: '37295'},
    { city: 'Lügde-Rischenau', area: '5283'},
    { city: 'Luhe-Wildenau', area: '9607'},
    { city: 'Luisenthal Thür', area: '36257'},
    { city: 'Lunden', area: '4882'},
    { city: 'Lüneburg', area: '4131'},
    { city: 'Lünen', area: '2306'},
    { city: 'Lünne', area: '5906'},
    { city: 'Lunzenau', area: '37383'},
    { city: 'Lutherstadt Eisleben', area: '3475'},
    { city: 'Lutherstadt Wittenberg', area: '3491'},
    { city: 'Lütjenburg', area: '4381'},
    { city: 'Lüttenmark', area: '38842'},
    { city: 'Lutter am Barenberge', area: '5383'},
    { city: 'Lützen', area: '34444'},
    { city: 'Lutzerath', area: '2677'},
    { city: 'Lützow', area: '38874'},
    { city: 'Lychen', area: '39888'},
    { city: 'Magdala', area: '36454'},
    { city: 'Magdeburg', area: '391'},
    { city: 'Mahlow', area: '3379'},
    { city: 'Mahlsdorf b Salzwedel', area: '39032'},
    { city: 'Mähring', area: '9639'},
    { city: 'Mainburg', area: '8751'},
    { city: 'Mainhardt', area: '7903'},
    { city: 'Mainleus', area: '9229'},
    { city: 'Mainz', area: '6131'},
    { city: 'Mainz-Kastel', area: '6134'},
    { city: 'Malchin', area: '3994'},
    { city: 'Malchow b Waren', area: '39932'},
    { city: 'Malente', area: '4523'},
    { city: 'Mallentin', area: '38824'},
    { city: 'Mallersdorf-Pfaffenberg', area: '8772'},
    { city: 'Malliss', area: '38750'},
    { city: 'Malsch Kr Karlsruhe', area: '7246'},
    { city: 'Malsch-Völkersbach', area: '7204'},
    { city: 'Mammendorf', area: '8145'},
    { city: 'Mamming', area: '9955'},
    { city: 'Manching', area: '8459'},
    { city: 'Mandelbachtal', area: '6804'},
    { city: 'Mandelbachtal-Ommersheim', area: '6803'},
    { city: 'Manderscheid Eifel', area: '6572'},
    { city: 'Mannheim*3', area: '621'},
    { city: 'Mansfeld Südharz', area: '34782'},
    { city: 'Marbach am Neckar', area: '7144'},
    { city: 'Marburg', area: '6421'},
    { city: 'March Breisgau', area: '7665'},
    { city: 'Mariaposching', area: '9906'},
    { city: 'Marienberg Sachs', area: '3735'},
    { city: 'Marienhafe', area: '4934'},
    { city: 'Marienheide', area: '2264'},
    { city: 'Marienmünster', area: '5276'},
    { city: 'Marienthal Kr Oberhavel', area: '33080'},
    { city: 'Markdorf', area: '7544'},
    { city: 'Markgröningen', area: '7145'},
    { city: 'Märkisch Buchholz', area: '33765'},
    { city: 'Markneukirchen', area: '37422'},
    { city: 'Markranstädt', area: '34205'},
    { city: 'Marksuhl', area: '36925'},
    { city: 'Markt Berolzheim', area: '9146'},
    { city: 'Markt Einersheim', area: '9326'},
    { city: 'Markt Erlbach', area: '9106'},
    { city: 'Markt Indersdorf', area: '8136'},
    { city: 'Markt Rettenbach', area: '8392'},
    { city: 'Markt Schwaben', area: '8121'},
    { city: 'Marktbreit', area: '9332'},
    { city: 'Marktheidenfeld', area: '9391'},
    { city: 'Marktl', area: '8678'},
    { city: 'Marktleugast', area: '9255'},
    { city: 'Marktoberdorf', area: '8342'},
    { city: 'Marktoffingen', area: '9087'},
    { city: 'Marktredwitz', area: '9231'},
    { city: 'Marktschellenberg', area: '8650'},
    { city: 'Marktzeuln', area: '9574'},
    { city: 'Marl', area: '2365'},
    { city: 'Marlow', area: '38221'},
    { city: 'Marne', area: '4851'},
    { city: 'Marnitz', area: '38729'},
    { city: 'Maroldsweisach', area: '9532'},
    { city: 'Marpingen', area: '6853'},
    { city: 'Marsberg', area: '2992'},
    { city: 'Marsberg-Bredelar', area: '2991'},
    { city: 'Marsberg-Canstein', area: '2993'},
    { city: 'Marsberg-Westheim', area: '2994'},
    { city: 'Marschacht', area: '4176'},
    { city: 'Martensdorf b Stralsund', area: '38321'},
    { city: 'Martfeld', area: '4255'},
    { city: 'Martinstein', area: '6754'},
    { city: 'Marxen Auetal', area: '4185'},
    { city: 'Marxheim', area: '9097'},
    { city: 'Marxzell', area: '7248'},
    { city: 'Marzahna', area: '33747'},
    { city: 'Massbach', area: '9735'},
    { city: 'Masserberg', area: '36870'},
    { city: 'Massing', area: '8724'},
    { city: 'Mauern Kr Freising', area: '8764'},
    { city: 'Maulbronn', area: '7043'},
    { city: 'Mauth', area: '8557'},
    { city: 'Maxdorf', area: '6237'},
    { city: 'Mayen', area: '2651'},
    { city: 'Mechernich', area: '2443'},
    { city: 'Mechernich-Eiserfey', area: '2484'},
    { city: 'Mechernich-Satzvey', area: '2256'},
    { city: 'Meckenheim Rheinl', area: '2225'},
    { city: 'Meckesheim', area: '6226'},
    { city: 'Medebach', area: '2982'},
    { city: 'Medelby', area: '4605'},
    { city: 'Medow b Anklam', area: '39728'},
    { city: 'Meeder', area: '9566'},
    { city: 'Meerane', area: '3764'},
    { city: 'Meerbusch-Büderich', area: '2132'},
    { city: 'Meerbusch-Lank', area: '2150'},
    { city: 'Meerbusch-Osterath', area: '2159'},
    { city: 'Meersburg', area: '7532'},
    { city: 'Mehltheuer Vogtl', area: '37431'},
    { city: 'Meine', area: '5304'},
    { city: 'Meinersdorf', area: '3721'},
    { city: 'Meinersen', area: '5372'},
    { city: 'Meinerzhagen', area: '2354'},
    { city: 'Meinerzhagen-Valbert', area: '2358'},
    { city: 'Meiningen', area: '3693'},
    { city: 'Meisenheim', area: '6753'},
    { city: 'Meissen', area: '3521'},
    { city: 'Meissner', area: '5657'},
    { city: 'Meitingen', area: '8271'},
    { city: 'Meldorf', area: '4832'},
    { city: 'Melle', area: '5422'},
    { city: 'Melle-Buer', area: '5427'},
    { city: 'Mellen', area: '38781'},
    { city: 'Melle-Neuenkirchen', area: '5428'},
    { city: 'Melle-Wellingholzhausen', area: '5429'},
    { city: 'Mellingen', area: '36453'},
    { city: 'Mellrichstadt', area: '9776'},
    { city: 'Melsungen', area: '5661'},
    { city: 'Memmingen', area: '8331'},
    { city: 'Menden Sauerland', area: '2373'},
    { city: 'Menden-Asbeck', area: '2379'},
    { city: 'Mendig', area: '2652'},
    { city: 'Mengen Württ', area: '7572'},
    { city: 'Mengerskirchen', area: '6476'},
    { city: 'Mengkofen', area: '8733'},
    { city: 'Menslage', area: '5437'},
    { city: 'Menteroda', area: '36029'},
    { city: 'Menz Kr Oberhavel', area: '33082'},
    { city: 'Meppen', area: '5931'},
    { city: 'Meppen-Apeldorn', area: '5966'},
    { city: 'Merkers', area: '36969'},
    { city: 'Merseburg Saale', area: '3461'},
    { city: 'Mertingen', area: '9078'},
    { city: 'Merzen', area: '5466'},
    { city: 'Merzig', area: '6861'},
    { city: 'Merzig-Silwingen', area: '6869'},
    { city: 'Meschede', area: '291'},
    { city: 'Meschede-Freienohl', area: '2903'},
    { city: 'Mesekenhagen', area: '38351'},
    { city: 'Messdorf', area: '39083'},
    { city: 'Messel', area: '6159'},
    { city: 'Messkirch', area: '7575'},
    { city: 'Messstetten-Oberdigisheim', area: '7436'},
    { city: 'Mestlin', area: '38727'},
    { city: 'Metelen', area: '2556'},
    { city: 'Metschow', area: '39994'},
    { city: 'Mettendorf', area: '6522'},
    { city: 'Mettingen Westf', area: '5452'},
    { city: 'Mettlach', area: '6864'},
    { city: 'Mettlach-Orscholz', area: '6865'},
    { city: 'Mettlach-Tünsdorf', area: '6868'},
    { city: 'Mettmann', area: '2104'},
    { city: 'Metzingen Württ', area: '7123'},
    { city: 'Meuselwitz Thür', area: '3448'},
    { city: 'Meyenburg Kr Prignitz', area: '33968'},
    { city: 'Michelsneukirchen', area: '9467'},
    { city: 'Michelstadt', area: '6061'},
    { city: 'Michelstadt-Vielbrunn', area: '6066'},
    { city: 'Michendorf', area: '33205'},
    { city: 'Mickhausen', area: '8204'},
    { city: 'Miesbach', area: '8025'},
    { city: 'Mieste', area: '39082'},
    { city: 'Miesterhorst', area: '39006'},
    { city: 'Mihla', area: '36924'},
    { city: 'Milmersdorf', area: '39886'},
    { city: 'Miltach', area: '9944'},
    { city: 'Miltenberg', area: '9371'},
    { city: 'Miltzow', area: '38328'},
    { city: 'Mindelheim', area: '8261'},
    { city: 'Minden Westf', area: '571'},
    { city: 'Mintraching', area: '9406'},
    { city: 'Mirow Kr Neustrelitz', area: '39833'},
    { city: 'Missen-Wilhams', area: '8320'},
    { city: 'Mistelgau', area: '9279'},
    { city: 'Mistelgau-Obernsees', area: '9206'},
    { city: 'Mistorf', area: '38453'},
    { city: 'Mittelneufnach', area: '8262'},
    { city: 'Mittenwald', area: '8823'},
    { city: 'Mittenwalde Mark', area: '33764'},
    { city: 'Mitterfels', area: '9961'},
    { city: 'Mitterteich', area: '9633'},
    { city: 'Mittweida', area: '3727'},
    { city: 'Mitwitz', area: '9266'},
    { city: 'Mochau-Lüttewitz', area: '34325'},
    { city: 'Möckern b Magdeburg', area: '39221'},
    { city: 'Möckmühl', area: '6298'},
    { city: 'Mockrehna', area: '34244'},
    { city: 'Modautal', area: '6167'},
    { city: 'Moers', area: '2841'},
    { city: 'Mögglingen', area: '7174'},
    { city: 'Möhnesee', area: '2924'},
    { city: 'Mohorn', area: '35209'},
    { city: 'Mohrkirch', area: '4646'},
    { city: 'Moitin', area: '38297'},
    { city: 'Molbergen', area: '4475'},
    { city: 'Molbergen-Peheim', area: '4479'},
    { city: 'Möllenhagen', area: '39928'},
    { city: 'Mölln Lauenb', area: '4542'},
    { city: 'Molzhain', area: '2747'},
    { city: 'Mömbris', area: '6029'},
    { city: 'Mommenheim', area: '6138'},
    { city: 'Mönchengladbach', area: '2161'},
    { city: 'Mönchengladbach-Rheydt', area: '2166'},
    { city: 'Mönchsdeggingen', area: '9088'},
    { city: 'Monheim Schwab', area: '9091'},
    { city: 'Mönkebude', area: '39774'},
    { city: 'Monschau', area: '2472'},
    { city: 'Monsheim', area: '6243'},
    { city: 'Mönsheim', area: '7044'},
    { city: 'Montabaur', area: '2602'},
    { city: 'Moorenweis', area: '8146'},
    { city: 'Moormerland', area: '4954'},
    { city: 'Moormerland-Oldersum', area: '4924'},
    { city: 'Moos Niederbay', area: '9938'},
    { city: 'Moosbach b Vohenstrauß', area: '9656'},
    { city: 'Moosburg a d Isar', area: '8761'},
    { city: 'Moosinning', area: '8123'},
    { city: 'Morbach Hunsrück', area: '6533'},
    { city: 'Mörfelden-Walldorf', area: '6105'},
    { city: 'Moringen', area: '5554'},
    { city: 'Möringen', area: '39329'},
    { city: 'Moringen-Fredelsloh', area: '5555'},
    { city: 'Moritzburg', area: '35207'},
    { city: 'Mörlenbach', area: '6209'},
    { city: 'Morsbach Sieg', area: '2294'},
    { city: 'Morschen', area: '5664'},
    { city: 'Mosbach Baden', area: '6261'},
    { city: 'Mosel', area: '37604'},
    { city: 'Möser', area: '39222'},
    { city: 'Mössingen', area: '7473'},
    { city: 'Motten', area: '9748'},
    { city: 'Möttingen', area: '9083'},
    { city: 'Much', area: '2245'},
    { city: 'Mücheln Geiseltal', area: '34632'},
    { city: 'Mücka', area: '35893'},
    { city: 'Mücke', area: '6400'},
    { city: 'Mudau', area: '6284'},
    { city: 'Müden Aller', area: '5375'},
    { city: 'Mügeln b Oschatz', area: '34362'},
    { city: 'Mühlacker', area: '7041'},
    { city: 'Mühlanger', area: '34922'},
    { city: 'Mühlberg Elbe', area: '35342'},
    { city: 'Mühldorf a Inn', area: '8631'},
    { city: 'Mühlen Eichsen', area: '38871'},
    { city: 'Mühlenbeck Kr Oberhavel', area: '33056'},
    { city: 'Mühlhausen Mittelfr', area: '9548'},
    { city: 'Mühlhausen Oberpf', area: '9185'},
    { city: 'Mühlhausen Thür', area: '3601'},
    { city: 'Mühlheim am Main', area: '6108'},
    { city: 'Mühlheim an der Donau', area: '7463'},
    { city: 'Mühlingen', area: '7775'},
    { city: 'Mühltroff', area: '36645'},
    { city: 'Mulda Sachs', area: '37320'},
    { city: 'Mulfingen Jagst', area: '7938'},
    { city: 'Mülheim Mosel', area: '6534'},
    { city: 'Mülheim-Kärlich', area: '2630'},
    { city: 'Müllheim Baden', area: '7631'},
    { city: 'Müllrose', area: '33606'},
    { city: 'Mülsen Skt Jacob', area: '37601'},
    { city: 'Münchberg', area: '9251'},
    { city: 'Müncheberg', area: '33432'},
    { city: 'Münchehofe Kr Dahme- Spreewald', area: '33760'},
    { city: 'München', area: '89'},
    { city: 'Münchenbernsdorf', area: '36604'},
    { city: 'Münchsmünster', area: '8402'},
    { city: 'Münchsteinach', area: '9166'},
    { city: 'Münchweiler an der Rodalb', area: '6395'},
    { city: 'Munderkingen', area: '7393'},
    { city: 'Mündersbach', area: '2680'},
    { city: 'Münnerstadt', area: '9733'},
    { city: 'Münsing Starnberger See', area: '8177'},
    { city: 'Münsingen', area: '7381'},
    { city: 'Münsingen-Buttenhausen', area: '7383'},
    { city: 'Munster', area: '5192'},
    { city: 'Münster', area: '251'},
    { city: 'Münster-Albachten', area: '2536'},
    { city: 'Münster-Hiltrup', area: '2501'},
    { city: 'Münster-Nienberge', area: '2533'},
    { city: 'Münster-Roxel', area: '2534'},
    { city: 'Münstertal Schwarzwald', area: '7636'},
    { city: 'Münster-Wolbeck', area: '2506'},
    { city: 'Murg', area: '7763'},
    { city: 'Murnau a Staffelsee', area: '8841'},
    { city: 'Murrhardt', area: '7192'},
    { city: 'Mustin Lauenburg', area: '4546'},
    { city: 'Mutterstadt', area: '6234'},
    { city: 'Mutzschen', area: '34385'},
    { city: 'Nabburg', area: '9433'},
    { city: 'Nagel', area: '9236'},
    { city: 'Nagold', area: '7452'},
    { city: 'Nagold-Hochdorf', area: '7459'},
    { city: 'Nahe', area: '4535'},
    { city: 'Nahrendorf', area: '5855'},
    { city: 'Naila', area: '9282'},
    { city: 'Namborn', area: '6857'},
    { city: 'Nandlstadt', area: '8756'},
    { city: 'Narsdorf', area: '34346'},
    { city: 'Nassau Lahn', area: '2604'},
    { city: 'Nassenfels', area: '8424'},
    { city: 'Nassenheide', area: '33051'},
    { city: 'Nastätten', area: '6772'},
    { city: 'Nauen Brandenb', area: '3321'},
    { city: 'Nauendorf Sachs-Anh', area: '34603'},
    { city: 'Naumburg Hess', area: '5625'},
    { city: 'Naumburg Saale', area: '3445'},
    { city: 'Naunhof b Grimma', area: '34293'},
    { city: 'Nauort', area: '2601'},
    { city: 'Nebra Unstrut', area: '34461'},
    { city: 'Nechlin', area: '39740'},
    { city: 'Neckargemünd', area: '6223'},
    { city: 'Neckargerach', area: '6263'},
    { city: 'Neckarsteinach', area: '6229'},
    { city: 'Neckarsulm', area: '7132'},
    { city: 'Neckartenzlingen', area: '7127'},
    { city: 'Neddenaverbergen', area: '4238'},
    { city: 'Nedlitz b Zerbst', area: '39243'},
    { city: 'Neenstetten', area: '7340'},
    { city: 'Neetze', area: '5850'},
    { city: 'Neheim-Hüsten', area: '2932'},
    { city: 'Nellingen Alb', area: '7337'},
    { city: 'Nennhausen', area: '33878'},
    { city: 'Nennslingen', area: '9147'},
    { city: 'Nentershausen Hess', area: '6627'},
    { city: 'Nentershausen Westerw', area: '6485'},
    { city: 'Nerchau', area: '34382'},
    { city: 'Neresheim', area: '7326'},
    { city: 'Nersingen', area: '7308'},
    { city: 'Neschwitz', area: '35933'},
    { city: 'Nesselwang', area: '8361'},
    { city: 'Netphen', area: '2738'},
    { city: 'Netphen-Deuz', area: '2737'},
    { city: 'Nettersheim', area: '2486'},
    { city: 'Nettersheim-Tondorf', area: '2440'},
    { city: 'Nettetal-Kaldenkirchen', area: '2157'},
    { city: 'Nettetal-Lobberich', area: '2153'},
    { city: 'Neu Darchau', area: '5853'},
    { city: 'Neu Lübbenau', area: '35473'},
    { city: 'Neu Wulmstorf-Elstorf', area: '4168'},
    { city: 'Neualbenreuth', area: '9638'},
    { city: 'Neubörger', area: '4966'},
    { city: 'Neubrandenburg', area: '395'},
    { city: 'Neubukow', area: '38294'},
    { city: 'Neuburg a d Donau', area: '8431'},
    { city: 'Neuburg a d Kammel', area: '8283'},
    { city: 'Neuburg a Inn', area: '8507'},
    { city: 'Neuburg-Steinhausen', area: '38426'},
    { city: 'Neudenau', area: '6264'},
    { city: 'Neudietendorf', area: '36202'},
    { city: 'Neudrossenfeld', area: '9203'},
    { city: 'Neuenbürg Württ', area: '7082'},
    { city: 'Neuendettelsau', area: '9874'},
    { city: 'Neuengeseke', area: '2927'},
    { city: 'Neuenhagen b Berlin', area: '3342'},
    { city: 'Neuenhaus Dinkel', area: '5941'},
    { city: 'Neuenhof Thür', area: '36928'},
    { city: 'Neuenkirchen b Bassum', area: '4245'},
    { city: 'Neuenkirchen b Bramsche', area: '5465'},
    { city: 'Neuenkirchen b Soltau', area: '5195'},
    { city: 'Neuenkirchen Dithm', area: '4837'},
    { city: 'Neuenkirchen Kr Steinfurt', area: '5973'},
    { city: 'Neuenkirchen Kr Vechta', area: '5493'},
    { city: 'Neuenmarkt', area: '9227'},
    { city: 'Neuenrade-Affeln', area: '2394'},
    { city: 'Neuenstadt am Kocher', area: '7139'},
    { city: 'Neuenstein Hess', area: '6677'},
    { city: 'Neuenstein Württ', area: '7942'},
    { city: 'Neuental', area: '6693'},
    { city: 'Neuerburg Eifel', area: '6564'},
    { city: 'Neufahrn b Freising', area: '8165'},
    { city: 'Neufahrn i NB', area: '8773'},
    { city: 'Neuffen', area: '7025'},
    { city: 'Neugersdorf Sachs', area: '3586'},
    { city: 'Neuhardenberg', area: '33476'},
    { city: 'Neuharlingersiel', area: '4974'},
    { city: 'Neuhaus a d Pegnitz', area: '9156'},
    { city: 'Neuhaus a Inn', area: '8503'},
    { city: 'Neuhaus a Rennweg', area: '3679'},
    { city: 'Neuhaus Elbe', area: '38841'},
    { city: 'Neuhaus Oste', area: '4752'},
    { city: 'Neuhäusel Westerw', area: '2620'},
    { city: 'Neuhausen auf den Fildern', area: '7158'},
    { city: 'Neuhausen Erzgeb', area: '37361'},
    { city: 'Neuhausen ob Eck', area: '7467'},
    { city: 'Neuhaus-Schierschnitz', area: '36764'},
    { city: 'Neuhof Kr Fulda', area: '6655'},
    { city: 'Neuhofen Pfalz', area: '6236'},
    { city: 'Neuhof-Hauswurz', area: '6669'},
    { city: 'Neu-Isenburg', area: '6102'},
    { city: 'Neukalen', area: '39956'},
    { city: 'Neukieritzsch', area: '34342'},
    { city: 'Neukirch b Tettnang', area: '7528'},
    { city: 'Neukirch Lausitz', area: '35951'},
    { city: 'Neukirchen Altmark', area: '39396'},
    { city: 'Neukirchen b Hl Blut', area: '9947'},
    { city: 'Neukirchen b Niebüll', area: '4664'},
    { city: 'Neukirchen b Sulzbach- Rosenberg', area: '9663'},
    { city: 'Neukirchen Knüll', area: '6694'},
    { city: 'Neukirchen-Balbini', area: '9465'},
    { city: 'Neukirchen-Vluyn', area: '2845'},
    { city: 'Neukloster', area: '38422'},
    { city: 'Neulehe', area: '4968'},
    { city: 'Neulewin', area: '33452'},
    { city: 'Neulingen Enzkreis', area: '7237'},
    { city: 'Neumagen-Dhron', area: '6507'},
    { city: 'Neumark Sachs', area: '37600'},
    { city: 'Neumarkt i d Opf', area: '9181'},
    { city: 'Neumarkt-Sankt Veit', area: '8639'},
    { city: 'Neumünster', area: '4321'},
    { city: 'Neunburg vorm Wald', area: '9672'},
    { city: 'Neunburg-Kemnath', area: '9439'},
    { city: 'Neunkirchen a Brand', area: '9134'},
    { city: 'Neunkirchen Saar', area: '6821'},
    { city: 'Neunkirchen Siegerl', area: '2735'},
    { city: 'Neunkirchen-Seelscheid', area: '2247'},
    { city: 'Neureichenau', area: '8583'},
    { city: 'Neuried Ortenaukreis', area: '7807'},
    { city: 'Neuruppin', area: '3391'},
    { city: 'Neusalza-Spremberg', area: '35872'},
    { city: 'Neusorg', area: '9234'},
    { city: 'Neuss', area: '2131'},
    { city: 'Neuss-Norf', area: '2137'},
    { city: 'Neustadt a d Aisch', area: '9161'},
    { city: 'Neustadt a d Donau', area: '9445'},
    { city: 'Neustadt a d Waldnaab', area: '9602'},
    { city: 'Neustadt a Kulm', area: '9648'},
    { city: 'Neustadt am Rübenberge', area: '5032'},
    { city: 'Neustadt an der Orla', area: '36481'},
    { city: 'Neustadt an der Weinstraße', area: '6321'},
    { city: 'Neustadt b Coburg', area: '9568'},
    { city: 'Neustadt Dosse', area: '33970'},
    { city: 'Neustadt Hessen', area: '6692'},
    { city: 'Neustadt i Sa', area: '3596'},
    { city: 'Neustadt in Holstein', area: '4561'},
    { city: 'Neustadt-Esperke', area: '5073'},
    { city: 'Neustadt-Glewe', area: '38757'},
    { city: 'Neustadt-Hagen', area: '5034'},
    { city: 'Neustadt-Lachen', area: '6327'},
    { city: 'Neustadt-Mandelsloh', area: '5072'},
    { city: 'Neustadt-Schneeren', area: '5036'},
    { city: 'Neustrelitz', area: '3981'},
    { city: 'Neutraubling', area: '9401'},
    { city: 'Neutrebbin', area: '33474'},
    { city: 'Neuwegersleben', area: '39401'},
    { city: 'Neuweiler Kr Calw', area: '7055'},
    { city: 'Neuwied', area: '2631'},
    { city: 'Neuzelle', area: '33652'},
    { city: 'Nidda', area: '6043'},
    { city: 'Nideggen', area: '2427'},
    { city: 'Nideggen-Embken', area: '2425'},
    { city: 'Nideggen-Schmidt', area: '2474'},
    { city: 'Niebüll', area: '4661'},
    { city: 'Niederaula', area: '6625'},
    { city: 'Niederbobritzsch', area: '37325'},
    { city: 'Niederbrombach', area: '6787'},
    { city: 'Niedereschach', area: '7728'},
    { city: 'Niedergörsdorf', area: '33741'},
    { city: 'Niederkassel', area: '2208'},
    { city: 'Niederkirchen', area: '6363'},
    { city: 'Niederndodeleben', area: '39204'},
    { city: 'Niedernhausen Taunus', area: '6127'},
    { city: 'Nieder-Olm', area: '6136'},
    { city: 'Niederorschel', area: '36076'},
    { city: 'Niederpöllnitz', area: '36607'},
    { city: 'Niederreifenberg', area: '6082'},
    { city: 'Nieder-Seifersdorf', area: '35827'},
    { city: 'Niederstetten Württ', area: '7932'},
    { city: 'Niederzier', area: '2428'},
    { city: 'Niefern-Öschelbronn', area: '7233'},
    { city: 'Nieheim', area: '5274'},
    { city: 'Nieheim-Himmighausen', area: '5238'},
    { city: 'Niemberg', area: '34604'},
    { city: 'Niemegk', area: '33843'},
    { city: 'Nienburg Saale', area: '34721'},
    { city: 'Nienburg Weser', area: '5021'},
    { city: 'Niesky', area: '3588'},
    { city: 'Nittenau', area: '9436'},
    { city: 'Nittendorf', area: '9404'},
    { city: 'Nitzahn', area: '33877'},
    { city: 'Nöbdenitz', area: '34496'},
    { city: 'Nohfelden', area: '6852'},
    { city: 'Nohn Eifel', area: '2696'},
    { city: 'Nonnweiler', area: '6873'},
    { city: 'Nonnweiler-Primstal', area: '6875'},
    { city: 'Norden', area: '4931'},
    { city: 'Nordendorf', area: '8273'},
    { city: 'Nordenham', area: '4731'},
    { city: 'Norderney', area: '4932'},
    { city: 'Nordhalben', area: '9267'},
    { city: 'Nordhastedt', area: '4804'},
    { city: 'Nordhausen Thür', area: '3631'},
    { city: 'Nordheim v d Rhön', area: '9779'},
    { city: 'Nordholz b Bremerhaven', area: '4741'},
    { city: 'Nordhorn', area: '5921'},
    { city: 'Nordkirchen', area: '2596'},
    { city: 'Nordleda', area: '4758'},
    { city: 'Nördlingen', area: '9081'},
    { city: 'Nordrach', area: '7838'},
    { city: 'Nordstemmen', area: '5069'},
    { city: 'Nordstrand', area: '4842'},
    { city: 'Nordwalde', area: '2573'},
    { city: 'Nörten-Hardenberg', area: '5503'},
    { city: 'Northeim', area: '5551'},
    { city: 'Nortorf b Neumünster', area: '4392'},
    { city: 'Nortrup', area: '5436'},
    { city: 'Nörvenich', area: '2426'},
    { city: 'Nossen', area: '35242'},
    { city: 'Nossendorf', area: '39995'},
    { city: 'Nossentiner Hütte', area: '39927'},
    { city: 'Nottuln', area: '2502'},
    { city: 'Nottuln-Appelhülsen', area: '2509'},
    { city: 'Nümbrecht', area: '2293'},
    { city: 'Nürnberg', area: '911'},
    { city: 'Nürtingen', area: '7022'},
    { city: 'Nußbach Pfalz', area: '6364'},
    { city: 'Nusse', area: '4543'},
    { city: 'Oberammergau', area: '8822'},
    { city: 'Oberau Loisach', area: '8824'},
    { city: 'Oberaudorf', area: '8033'},
    { city: 'Oberaula', area: '6628'},
    { city: 'Oberaurach', area: '9529'},
    { city: 'Oberbach Unterfr', area: '9749'},
    { city: 'Oberbaldingen', area: '7706'},
    { city: 'Obercunnersdorf b Löbau', area: '35875'},
    { city: 'Oberdachstetten', area: '9845'},
    { city: 'Oberderdingen', area: '7045'},
    { city: 'Oberderdingen-Flehingen', area: '7258'},
    { city: 'Oberdolling', area: '8404'},
    { city: 'Oberelsbach', area: '9774'},
    { city: 'Obergünzburg', area: '8372'},
    { city: 'Oberhaid Oberfr', area: '9503'},
    { city: 'Oberharmersbach', area: '7837'},
    { city: 'Oberhausen Rheinl', area: '208'},
    { city: 'Ober-Hilbersheim', area: '6728'},
    { city: 'Oberhof Thür', area: '36842'},
    { city: 'Oberkail', area: '6567'},
    { city: 'Oberkirch Baden', area: '7802'},
    { city: 'Oberkochen', area: '7364'},
    { city: 'Oberkotzau', area: '9286'},
    { city: 'Oberland', area: '36878'},
    { city: 'Obermarchtal', area: '7375'},
    { city: 'Obermaßfeld-Grimmenthal', area: '36949'},
    { city: 'Ober-Mörlen', area: '6002'},
    { city: 'Obernburg a Main', area: '6022'},
    { city: 'Oberndorf am Neckar', area: '7423'},
    { city: 'Oberndorf b Apolda', area: '36465'},
    { city: 'Oberndorf Oste', area: '4772'},
    { city: 'Oberneukirchen', area: '8630'},
    { city: 'Obernkirchen', area: '5724'},
    { city: 'Obernzell', area: '8591'},
    { city: 'Obernzenn', area: '9844'},
    { city: 'Oberpöring', area: '9937'},
    { city: 'Ober-Ramstadt', area: '6154'},
    { city: 'Oberried Breisgau', area: '7602'},
    { city: 'Oberrot b Gaildorf', area: '7977'},
    { city: 'Oberscheinfeld', area: '9167'},
    { city: 'Oberschneiding', area: '9426'},
    { city: 'Obersöchering', area: '8847'},
    { city: 'Obersontheim', area: '7973'},
    { city: 'Oberstaufen', area: '8386'},
    { city: 'Oberstaufen-Thalkirchdorf', area: '8325'},
    { city: 'Oberstdorf', area: '8322'},
    { city: 'Oberteuringen', area: '7546'},
    { city: 'Oberthal Saar', area: '6854'},
    { city: 'Oberthulba', area: '9736'},
    { city: 'Obertrubach', area: '9245'},
    { city: 'Oberursel Taunus', area: '6171'},
    { city: 'Oberviechtach', area: '9671'},
    { city: 'Oberviechtach-Pullenried', area: '9677'},
    { city: 'Oberweis', area: '6527'},
    { city: 'Oberweißbach Thür Wald', area: '36705'},
    { city: 'Oberwesel', area: '6744'},
    { city: 'Oberweser', area: '5574'},
    { city: 'Oberwiesenthal Kurort', area: '37348'},
    { city: 'Obing', area: '8624'},
    { city: 'Ochsenfurt', area: '9331'},
    { city: 'Ochsenhausen', area: '7352'},
    { city: 'Ochtendung', area: '2625'},
    { city: 'Ochtrup', area: '2553'},
    { city: 'Ockholm', area: '4674'},
    { city: 'Odelzhausen', area: '8134'},
    { city: 'Oderberg', area: '33369'},
    { city: 'Odernheim am Glan', area: '6755'},
    { city: 'Oderwitz', area: '35842'},
    { city: 'Odisheim', area: '4756'},
    { city: 'Oebisfelde', area: '39002'},
    { city: 'Oederan', area: '37292'},
    { city: 'Oehna Brandenb', area: '33742'},
    { city: 'Oelde', area: '2522'},
    { city: 'Oelde-Stromberg', area: '2529'},
    { city: 'Oelsnitz Erzgeb', area: '37298'},
    { city: 'Oelsnitz Vogtl', area: '37421'},
    { city: 'Oelzschau b Borna', area: '34347'},
    { city: 'Oepfershausen', area: '36940'},
    { city: 'Oer-Erkenschwick', area: '2368'},
    { city: 'Oerlinghausen', area: '5202'},
    { city: 'Oertzenhof b Strasburg', area: '3967'},
    { city: 'Oestrich-Winkel', area: '6723'},
    { city: 'Oettingen i Bay', area: '9082'},
    { city: 'Oetzen', area: '5805'},
    { city: 'Offenbach an der Queich', area: '6348'},
    { city: 'Offenburg', area: '781'},
    { city: 'Offenhausen Mittelfr', area: '9158'},
    { city: 'Offingen Donau', area: '8224'},
    { city: 'Öhningen', area: '7735'},
    { city: 'Ohrdruf', area: '3624'},
    { city: 'Öhringen', area: '7941'},
    { city: 'Öhringen-Ohrnberg', area: '7948'},
    { city: 'Olbernhau', area: '37360'},
    { city: 'Olching', area: '8142'},
    { city: 'Oldenburg (Oldb)', area: '441'},
    { city: 'Oldenburg in Holstein', area: '4361'},
    { city: 'Oldenswort', area: '4864'},
    { city: 'Oldsum', area: '4683'},
    { city: 'Olfen', area: '2595'},
    { city: 'Olpe Biggesee', area: '2761'},
    { city: 'Olsberg', area: '2962'},
    { city: 'Olsbrücken', area: '6308'},
    { city: 'Olzheim', area: '6552'},
    { city: 'Oppenau', area: '7804'},
    { city: 'Oppenheim', area: '6133'},
    { city: 'Oranienbaum', area: '34904'},
    { city: 'Oranienburg', area: '3301'},
    { city: 'Orlamünde', area: '36423'},
    { city: 'Ortenberg Hess', area: '6046'},
    { city: 'Ortenburg', area: '8542'},
    { city: 'Ortrand', area: '35755'},
    { city: 'Osann-Monzel', area: '6535'},
    { city: 'Oschatz', area: '3435'},
    { city: 'Oschersleben Bode', area: '3949'},
    { city: 'Osnabrück', area: '541'},
    { city: 'Ossling', area: '35792'},
    { city: 'Ossmannstedt', area: '36462'},
    { city: 'Ostbevern', area: '2532'},
    { city: 'Osten-Altendorf', area: '4776'},
    { city: 'Ostenfeld Husum', area: '4845'},
    { city: 'Osterburg Altmark', area: '3937'},
    { city: 'Ostercappeln', area: '5473'},
    { city: 'Ostercappeln-Venne', area: '5476'},
    { city: 'Osterfeld', area: '34422'},
    { city: 'Osterhever', area: '4865'},
    { city: 'Osterhofen', area: '9932'},
    { city: 'Osterhofen-Gergweis', area: '8547'},
    { city: 'Osterholz-Scharmbeck', area: '4791'},
    { city: 'Osternienburg', area: '34973'},
    { city: 'Osterode am Harz', area: '5522'},
    { city: 'Oster-Ohrstedt', area: '4847'},
    { city: 'Osterwieck', area: '39421'},
    { city: 'Ostheim v d Rhön', area: '9777'},
    { city: 'Osthofen', area: '6242'},
    { city: 'Ostrach', area: '7585'},
    { city: 'Ostramondra', area: '36378'},
    { city: 'Ostrau Saalkreis', area: '34600'},
    { city: 'Ostrau Sachs', area: '34324'},
    { city: 'Östringen-Odenheim', area: '7259'},
    { city: 'Ostritz', area: '35823'},
    { city: 'Ottendorf b Stadtroda', area: '36426'},
    { city: 'Ottendorf-Okrilla', area: '35205'},
    { city: 'Ottenstein Niedersachs', area: '5286'},
    { city: 'Otterbach Pfalz', area: '6301'},
    { city: 'Otterndorf', area: '4751'},
    { city: 'Ottersberg', area: '4205'},
    { city: 'Ottersberg-Fischerhude', area: '4293'},
    { city: 'Ottersberg-Posthausen', area: '4297'},
    { city: 'Ottobeuren', area: '8332'},
    { city: 'Ottrau', area: '6639'},
    { city: 'Ottweiler', area: '6824'},
    { city: 'Ottweiler-Fürth', area: '6858'},
    { city: 'Ovelgönne-Großenmeer', area: '4483'},
    { city: 'Ovelgönne-Strückhausen', area: '4480'},
    { city: 'Overath', area: '2206'},
    { city: 'Owschlag', area: '4336'},
    { city: 'Oybin Kurort', area: '35844'},
    { city: 'Oy-Mittelberg', area: '8366'},
    { city: 'Oyten', area: '4207'},
    { city: 'Pabstorf', area: '39428'},
    { city: 'Paderborn', area: '5251'},
    { city: 'Paderborn-Dahl', area: '5293'},
    { city: 'Paderborn-Schloss Neuhaus', area: '5254'},
    { city: 'Pähl', area: '8808'},
    { city: 'Pahlen', area: '4803'},
    { city: 'Painten', area: '9499'},
    { city: 'Palling', area: '8629'},
    { city: 'Palzem', area: '6583'},
    { city: 'Panschwitz-Kuckau', area: '35796'},
    { city: 'Papenburg', area: '4961'},
    { city: 'Papenburg-Aschendorf', area: '4962'},
    { city: 'Pappenheim Mittelfr', area: '9143'},
    { city: 'Parchen', area: '39345'},
    { city: 'Parchim', area: '3871'},
    { city: 'Parey Elbe', area: '39349'},
    { city: 'Parmen-Weggun', area: '39855'},
    { city: 'Parsau', area: '5368'},
    { city: 'Parsberg', area: '9492'},
    { city: 'Pasewalk', area: '3973'},
    { city: 'Passau', area: '851'},
    { city: 'Passow Kr Uckermark', area: '33336'},
    { city: 'Pattensen', area: '5101'},
    { city: 'Paulinenaue', area: '33237'},
    { city: 'Pausa Vogtl', area: '37432'},
    { city: 'Pausin', area: '33231'},
    { city: 'Päwesin', area: '33838'},
    { city: 'Pechern', area: '35775'},
    { city: 'Pegnitz', area: '9241'},
    { city: 'Pegnitz-Trockau', area: '9246'},
    { city: 'Peine', area: '5171'},
    { city: 'Peissenberg', area: '8803'},
    { city: 'Peitz', area: '35601'},
    { city: 'Pellworm', area: '4844'},
    { city: 'Penig', area: '37381'},
    { city: 'Penkun', area: '39751'},
    { city: 'Pennigsehl', area: '5028'},
    { city: 'Penzberg', area: '8856'},
    { city: 'Penzlin b Waren', area: '3962'},
    { city: 'Perl', area: '6867'},
    { city: 'Perleberg', area: '3876'},
    { city: 'Perlesreut', area: '8555'},
    { city: 'Perl-Nennig', area: '6866'},
    { city: 'Petershagen Weser', area: '5707'},
    { city: 'Petershagen-Friedewalde', area: '5704'},
    { city: 'Petershagen-Heimsen', area: '5768'},
    { city: 'Petershagen-Lahde', area: '5702'},
    { city: 'Petershagen-Windheim', area: '5705'},
    { city: 'Petershausen', area: '8137'},
    { city: 'Petkus', area: '33745'},
    { city: 'Petting', area: '8686'},
    { city: 'Pfaffendorfb Beeskow', area: '33672'},
    { city: 'Pfaffenhausen Schwab', area: '8265'},
    { city: 'Pfaffenhofen a d Ilm', area: '8441'},
    { city: 'Pfaffenhofen a d Roth', area: '7302'},
    { city: 'Pfaffing', area: '8076'},
    { city: 'Pfalzfeld', area: '6746'},
    { city: 'Pfalzgrafenweiler', area: '7445'},
    { city: 'Pfarrkirchen Niederbay', area: '8561'},
    { city: 'Pfarrweisach', area: '9535'},
    { city: 'Pfatter', area: '9481'},
    { city: 'Pfedelbach-Untersteinbach', area: '7949'},
    { city: 'Pfeffenhausen', area: '8782'},
    { city: 'Pfinztal', area: '7240'},
    { city: 'Pförring', area: '8403'},
    { city: 'Pforzen', area: '8346'},
    { city: 'Pforzheim', area: '7231'},
    { city: 'Pfreimd', area: '9606'},
    { city: 'Pfronstetten', area: '7388'},
    { city: 'Pfronten', area: '8363'},
    { city: 'Pfullendorf', area: '7552'},
    { city: 'Pfungstadt', area: '6157'},
    { city: 'Philippsburg', area: '7256'},
    { city: 'Philippsreut', area: '8550'},
    { city: 'Philippsthal Werra', area: '6620'},
    { city: 'Picher', area: '38751'},
    { city: 'Pielenhofen', area: '9409'},
    { city: 'Pilsting', area: '9953'},
    { city: 'Pinneberg', area: '4101'},
    { city: 'Pinnow Kr Uckermark', area: '33335'},
    { city: 'Pirmasens', area: '6331'},
    { city: 'Pirna', area: '3501'},
    { city: 'Plaaz', area: '38455'},
    { city: 'Plankenfels', area: '9204'},
    { city: 'Plate', area: '3861'},
    { city: 'Plattling', area: '9931'},
    { city: 'Plau am See', area: '38735'},
    { city: 'Plaue Thür', area: '36207'},
    { city: 'Plauen', area: '3741'},
    { city: 'Pleinfeld', area: '9144'},
    { city: 'Pleiskirchen', area: '8635'},
    { city: 'Plettenberg', area: '2391'},
    { city: 'Pleystein', area: '9654'},
    { city: 'Plochingen', area: '7153'},
    { city: 'Plön', area: '4522'},
    { city: 'Plößberg', area: '9636'},
    { city: 'Pluwig', area: '6588'},
    { city: 'Pocking', area: '8531'},
    { city: 'Pocking-Hartkirchen', area: '8538'},
    { city: 'Podelzig', area: '33601'},
    { city: 'Polch', area: '2654'},
    { city: 'Polle', area: '5535'},
    { city: 'Polsingen', area: '9093'},
    { city: 'Pommelsbrunn', area: '9154'},
    { city: 'Poppenhausen Unterfr', area: '9725'},
    { city: 'Poppenhausen Wasserkuppe', area: '6658'},
    { city: 'Pörnbach', area: '8446'},
    { city: 'Porta Westfalica', area: '5706'},
    { city: 'Poseritz', area: '38307'},
    { city: 'Pößneck', area: '3647'},
    { city: 'Postbauer-Heng', area: '9188'},
    { city: 'Potsdam', area: '331'},
    { city: 'Pottenstein', area: '9243'},
    { city: 'Pöttmes', area: '8253'},
    { city: 'Preetz Kr Plön', area: '4342'},
    { city: 'Premnitz', area: '3386'},
    { city: 'Prenzlau', area: '3984'},
    { city: 'Prerow Ostseebad', area: '38233'},
    { city: 'Pressath', area: '9644'},
    { city: 'Presseck', area: '9222'},
    { city: 'Pressig', area: '9265'},
    { city: 'Prettin', area: '35386'},
    { city: 'Pretzier', area: '39037'},
    { city: 'Pretzsch Elbe', area: '34926'},
    { city: 'Pretzschendorf', area: '35058'},
    { city: 'Preussisch Oldendorf', area: '5742'},
    { city: 'Preussisch Ströhen', area: '5776'},
    { city: 'Preusslitz', area: '34722'},
    { city: 'Priborn', area: '39923'},
    { city: 'Prien a Chiemsee', area: '8051'},
    { city: 'Prieros', area: '33768'},
    { city: 'Priessen', area: '35327'},
    { city: 'Prischwitz', area: '35937'},
    { city: 'Pritzerbe', area: '33834'},
    { city: 'Pritzier b Hagenow', area: '38856'},
    { city: 'Pritzwalk', area: '3395'},
    { city: 'Probstzella', area: '36735'},
    { city: 'Prödel', area: '39242'},
    { city: 'Prohn', area: '38323'},
    { city: 'Pronsfeld', area: '6556'},
    { city: 'Prosselsheim', area: '9386'},
    { city: 'Prötzel', area: '33436'},
    { city: 'Prüm', area: '6551'},
    { city: 'Puderbach Westerw', area: '2684'},
    { city: 'Pulheim', area: '2238'},
    { city: 'Pulsnitz', area: '35955'},
    { city: 'Pürgen', area: '8196'},
    { city: 'Putbus', area: '38301'},
    { city: 'Putlitz', area: '33981'},
    { city: 'Pyrbaum', area: '9180'},
    { city: 'Quakenbrück', area: '5431'},
    { city: 'Quedlinburg', area: '3946'},
    { city: 'Quellendorf', area: '34977'},
    { city: 'Querfurt', area: '34771'},
    { city: 'Quickborn Kr Pinneberg', area: '4106'},
    { city: 'Raben', area: '33848'},
    { city: 'Raben Steinfeld', area: '3860'},
    { city: 'Rabenau Hess', area: '6407'},
    { city: 'Rackwitz', area: '34294'},
    { city: 'Radbruch', area: '4178'},
    { city: 'Raddestorf', area: '5765'},
    { city: 'Radeberg', area: '3528'},
    { city: 'Radeburg', area: '35208'},
    { city: 'Radegast Kr Köthen', area: '34978'},
    { city: 'Radevormwald', area: '2195'},
    { city: 'Radolfzell am Bodensee', area: '7732'},
    { city: 'Raduhn', area: '38722'},
    { city: 'Raesfeld', area: '2865'},
    { city: 'Rägelin', area: '33924'},
    { city: 'Raguhn', area: '34906'},
    { city: 'Rahden Westf', area: '5771'},
    { city: 'Rain Lech', area: '9090'},
    { city: 'Rain Niederbay', area: '9429'},
    { city: 'Raisdorf', area: '4307'},
    { city: 'Rakow Vorpom', area: '38331'},
    { city: 'Ralingen', area: '6585'},
    { city: 'Ramsau b Berchtesgaden', area: '8657'},
    { city: 'Rangsdorf', area: '33708'},
    { city: 'Ransbach-Baumbach', area: '2623'},
    { city: 'Rantrum', area: '4848'},
    { city: 'Rasdorf', area: '6651'},
    { city: 'Rastatt', area: '7222'},
    { city: 'Rastdorf', area: '5956'},
    { city: 'Rastede', area: '4402'},
    { city: 'Rastenberg', area: '36377'},
    { city: 'Rastow', area: '3868'},
    { city: 'Ratekau', area: '4504'},
    { city: 'Rathenow', area: '3385'},
    { city: 'Ratingen', area: '2102'},
    { city: 'Ratzeburg', area: '4541'},
    { city: 'Rätzlingen Kr Uelzen', area: '5804'},
    { city: 'Rätzlingen Sachs-Anh', area: '39057'},
    { city: 'Raubling', area: '8035'},
    { city: 'Rauschenberg Hess', area: '6425'},
    { city: 'Ravensburg', area: '751'},
    { city: 'Ravenstein Baden', area: '6297'},
    { city: 'Rechenberg-Bienenmühle', area: '37327'},
    { city: 'Rechlin', area: '39823'},
    { city: 'Recke', area: '5453'},
    { city: 'Reckerscheid', area: '2257'},
    { city: 'Recklinghausen', area: '2361'},
    { city: 'Redefin', area: '38854'},
    { city: 'Redekin', area: '39341'},
    { city: 'Rees', area: '2851'},
    { city: 'Rees-Haldern', area: '2850'},
    { city: 'Rees-Mehr', area: '2857'},
    { city: 'Reetz b Perleberg', area: '38782'},
    { city: 'Regen', area: '9921'},
    { city: 'Regensburg', area: '941'},
    { city: 'Regenstauf', area: '9402'},
    { city: 'Regis-Breitingen', area: '34343'},
    { city: 'Regnitzlosau', area: '9294'},
    { city: 'Rehau', area: '9283'},
    { city: 'Rehburg-Loccum', area: '5766'},
    { city: 'Rehden', area: '5446'},
    { city: 'Reher Holst', area: '4876'},
    { city: 'Rehfelde', area: '33435'},
    { city: 'Rehlingen-Siersburg', area: '6833'},
    { city: 'Rehna', area: '38872'},
    { city: 'Reichelsheim Odenwald', area: '6164'},
    { city: 'Reichelsheim Wetterau', area: '6035'},
    { city: 'Reichenau Baden', area: '7534'},
    { city: 'Reichenbach OL', area: '35828'},
    { city: 'Reichenbach Vogtl', area: '3765'},
    { city: 'Reichenbach-Steegen', area: '6385'},
    { city: 'Reichenberg b Strausberg', area: '33437'},
    { city: 'Reichertshofen Oberbay', area: '8453'},
    { city: 'Reichshof-Brüchermühle', area: '2296'},
    { city: 'Reichshof-Eckenhagen', area: '2265'},
    { city: 'Reinfeld Holstein', area: '4533'},
    { city: 'Reinhardshagen', area: '5544'},
    { city: 'Reinheim Odenw', area: '6162'},
    { city: 'Reinholterode', area: '36085'},
    { city: 'Reinsberg Sachs', area: '37324'},
    { city: 'Reinstädt Thür', area: '36422'},
    { city: 'Reisbach Niederbay', area: '8734'},
    { city: 'Reischach Kr Altötting', area: '8670'},
    { city: 'Reit Im Winkl', area: '8640'},
    { city: 'Reitzenhain Erzgeb', area: '37364'},
    { city: 'Reken', area: '2864'},
    { city: 'Remagen', area: '2642'},
    { city: 'Remagen-Rolandseck', area: '2228'},
    { city: 'Remda', area: '36744'},
    { city: 'Remptendorf', area: '36640'},
    { city: 'Remscheid', area: '2191'},
    { city: 'Remseck am Neckar', area: '7146'},
    { city: 'Renchen', area: '7843'},
    { city: 'Rendsburg', area: '4331'},
    { city: 'Rengsdorf', area: '2634'},
    { city: 'Rennerod', area: '2664'},
    { city: 'Rennertshofen', area: '8434'},
    { city: 'Renningen', area: '7159'},
    { city: 'Rentwertshausen', area: '36944'},
    { city: 'Rerik Ostseebad', area: '38296'},
    { city: 'Rethem Aller', area: '5165'},
    { city: 'Rettenberg', area: '8327'},
    { city: 'Reuden b Zeitz', area: '34424'},
    { city: 'Reuth b Plauen', area: '37435'},
    { city: 'Reutlingen', area: '7121'},
    { city: 'Rhade b Zeven', area: '4285'},
    { city: 'Rhauderfehn', area: '4952'},
    { city: 'Rhauderfehn-Burlage', area: '4967'},
    { city: 'Rhaunen', area: '6544'},
    { city: 'Rheda-Wiedenbrück', area: '5242'},
    { city: 'Rhede Ems', area: '4964'},
    { city: 'Rhede Westf', area: '2872'},
    { city: 'Rheinau', area: '7844'},
    { city: 'Rheinbach', area: '2226'},
    { city: 'Rheinberg', area: '2843'},
    { city: 'Rheinberg-Orsoy', area: '2844'},
    { city: 'Rheinböllen', area: '6764'},
    { city: 'Rheinbrohl', area: '2635'},
    { city: 'Rheine', area: '5971'},
    { city: 'Rheine-Mesum', area: '5975'},
    { city: 'Rheinfelden Baden', area: '7623'},
    { city: 'Rheinsberg Mark', area: '33931'},
    { city: 'Rheinstetten', area: '7242'},
    { city: 'Rhens', area: '2628'},
    { city: 'Rhinow', area: '33875'},
    { city: 'Rhumspringe', area: '5529'},
    { city: 'Ribnitz-Damgarten', area: '3821'},
    { city: 'Richtenberg', area: '38322'},
    { city: 'Rickenbach Hotzenw', area: '7765'},
    { city: 'Rickling', area: '4328'},
    { city: 'Riedbach', area: '9526'},
    { city: 'Riede Kr Verden', area: '4294'},
    { city: 'Riedenburg', area: '9442'},
    { city: 'Riedlingen Württ', area: '7371'},
    { city: 'Riedstadt', area: '6158'},
    { city: 'Rieneck', area: '9354'},
    { city: 'Riesa', area: '3525'},
    { city: 'Rieseby', area: '4355'},
    { city: 'Rietberg', area: '5244'},
    { city: 'Rietberg-Mastholte', area: '2944'},
    { city: 'Rietschen', area: '35772'},
    { city: 'Rietzneuendorf-Friedrichshof', area: '35477'},
    { city: 'Rimpar', area: '9365'},
    { city: 'Ringenwalde b Templin', area: '39881'},
    { city: 'Ringgau', area: '5659'},
    { city: 'Ringstedt', area: '4708'},
    { city: 'Rinteln', area: '5751'},
    { city: 'Ritterhude', area: '4292'},
    { city: 'Rittersgrün', area: '37757'},
    { city: 'Röbel Müritz', area: '39931'},
    { city: 'Röblingen am See', area: '34774'},
    { city: 'Rochau', area: '39328'},
    { city: 'Rochlitz', area: '3737'},
    { city: 'Rockenhausen', area: '6361'},
    { city: 'Rödental', area: '9563'},
    { city: 'Rödermark', area: '6074'},
    { city: 'Rodershausen', area: '6524'},
    { city: 'Rodewald', area: '5074'},
    { city: 'Rodgau', area: '6106'},
    { city: 'Roding', area: '9461'},
    { city: 'Rödinghausen', area: '5746'},
    { city: 'Roding-Neubäu', area: '9469'},
    { city: 'Roetgen Eifel', area: '2471'},
    { city: 'Rogäsen', area: '33832'},
    { city: 'Roggenburg', area: '7300'},
    { city: 'Roggendorf', area: '38876'},
    { city: 'Rohr i NB', area: '8783'},
    { city: 'Rohr Mittelfr', area: '9876'},
    { city: 'Rohr Thür', area: '36844'},
    { city: 'Rohrdorf Kr Rosenheim', area: '8032'},
    { city: 'Röhrmoos', area: '8139'},
    { city: 'Röhrnbach', area: '8582'},
    { city: 'Rohrsen Kr Nienburg Weser', area: '5024'},
    { city: 'Roitzsch b Bitterfeld', area: '34954'},
    { city: 'Rolofshagen', area: '38325'},
    { city: 'Römerstein', area: '7382'},
    { city: 'Römhild', area: '36948'},
    { city: 'Rommerskirchen', area: '2183'},
    { city: 'Romrod', area: '6636'},
    { city: 'Rönnebeck Sachs-Ahn', area: '39392'},
    { city: 'Ronneburg Thür', area: '36602'},
    { city: 'Ronnenberg', area: '5109'},
    { city: 'Ronsberg', area: '8306'},
    { city: 'Rosbach v d Höhe', area: '6003'},
    { city: 'Rosbach-Rodheim', area: '6007'},
    { city: 'Rosche', area: '5803'},
    { city: 'Rosdorf Kr Göttingen', area: '5509'},
    { city: 'Roseburg', area: '4158'},
    { city: 'Rosenberg Baden', area: '6295'},
    { city: 'Rosendahl-Darfeld', area: '2545'},
    { city: 'Rosendahl-Osterwick', area: '2547'},
    { city: 'Rosenfeld', area: '7428'},
    { city: 'Rosengarten Kr Harburg', area: '4108'},
    { city: 'Rosenheim Oberbay', area: '8031'},
    { city: 'Rosenthal Hess', area: '6458'},
    { city: 'Rosenthal Sächs Schweiz', area: '35033'},
    { city: 'Rositz', area: '34498'},
    { city: 'Röslau', area: '9238'},
    { city: 'Rösrath', area: '2205'},
    { city: 'Rossdorf Rhön', area: '36968'},
    { city: 'Roßhaupten Forggensee', area: '8367'},
    { city: 'Rossla', area: '34651'},
    { city: 'Roßlau Elbe', area: '34901'},
    { city: 'Rossleben', area: '34672'},
    { city: 'Rosstal Mittelfr', area: '9127'},
    { city: 'Rosswein', area: '34322'},
    { city: 'Rostock', area: '381'},
    { city: 'Rot Am See-Brettheim', area: '7958'},
    { city: 'Rotenburg a d Fulda', area: '6623'},
    { city: 'Rotenburg Wümme', area: '4261'},
    { city: 'Roth Mittelfr', area: '9171'},
    { city: 'Rötha', area: '34206'},
    { city: 'Rothemühl', area: '39772'},
    { city: 'Röthenbach Allgäu', area: '8384'},
    { city: 'Rothenberg Odenw', area: '6275'},
    { city: 'Rothenburg ob der Tauber', area: '9861'},
    { city: 'Rothenburg OL', area: '35891'},
    { city: 'Rothenfels Unterfr', area: '9393'},
    { city: 'Rothenkirchen Vogtl', area: '37462'},
    { city: 'Rothenklempenow', area: '39744'},
    { city: 'Rothenschirmbach', area: '34776'},
    { city: 'Röthlein', area: '9723'},
    { city: 'Rott a Inn', area: '8039'},
    { city: 'Rottenbach', area: '36739'},
    { city: 'Rottenbuch Oberbay', area: '8867'},
    { city: 'Rottenburg a d Laaber', area: '8781'},
    { city: 'Rottenburg am Neckar', area: '7472'},
    { city: 'Rottenburg-Ergenzingen', area: '7457'},
    { city: 'Rottenburg-Oberroning', area: '8785'},
    { city: 'Rottendorf Unterfr', area: '9302'},
    { city: 'Rottershausen', area: '9738'},
    { city: 'Rotthalmünster', area: '8533'},
    { city: 'Röttingen Unterfr', area: '9338'},
    { city: 'Rottleberode', area: '34653'},
    { city: 'Rottweil', area: '741'},
    { city: 'Rötz', area: '9976'},
    { city: 'Rübenau', area: '37366'},
    { city: 'Rückersdorf b Finsterwalde', area: '35325'},
    { city: 'Rückholz', area: '8369'},
    { city: 'Rudersberg Württ', area: '7183'},
    { city: 'Rüdersdorf b Berlin', area: '33638'},
    { city: 'Ruderting', area: '8509'},
    { city: 'Rüdesheim am Rhein', area: '6722'},
    { city: 'Rudolstadt', area: '3672'},
    { city: 'Rugendorf', area: '9223'},
    { city: 'Rügland', area: '9828'},
    { city: 'Rühen', area: '5367'},
    { city: 'Ruhla', area: '36929'},
    { city: 'Ruhland', area: '35752'},
    { city: 'Ruhmannsfelden', area: '9929'},
    { city: 'Ruhpolding', area: '8663'},
    { city: 'Rülzheim', area: '7272'},
    { city: 'Runkel', area: '6482'},
    { city: 'Ruppichteroth', area: '2295'},
    { city: 'Rüsselsheim', area: '6142'},
    { city: 'Rüthen', area: '2952'},
    { city: 'Rüthen-Oestereiden', area: '2954'},
    { city: 'Saal a d Saale', area: '9762'},
    { city: 'Saal Vorpom', area: '38223'},
    { city: 'Saalburg Thür', area: '36647'},
    { city: 'Saalfeld Saale', area: '3671'},
    { city: 'Saarbrücken', area: '681'},
    { city: 'Saarbrücken-Ensheim', area: '6893'},
    { city: 'Saarburg', area: '6581'},
    { city: 'Saarlouis', area: '6831'},
    { city: 'Saarwellingen', area: '6838'},
    { city: 'Sachsenheim Württ', area: '7147'},
    { city: 'Sadenbeck', area: '33989'},
    { city: 'Saerbeck', area: '2574'},
    { city: 'Sagard', area: '38302'},
    { city: 'Salem Baden', area: '7553'},
    { city: 'Salmtal', area: '6578'},
    { city: 'Salzbergen', area: '5976'},
    { city: 'Salzgitter', area: '5341'},
    { city: 'Salzgitter-Üfingen', area: '5300'},
    { city: 'Salzhausen', area: '4172'},
    { city: 'Salzhemmendorf', area: '5153'},
    { city: 'Salzhemmendorf-Wallensen', area: '5186'},
    { city: 'Salzkotten', area: '5258'},
    { city: 'Salzmünde', area: '34609'},
    { city: 'Salzwedel', area: '3901'},
    { city: 'Samtens', area: '38306'},
    { city: 'Sandau Elbe', area: '39383'},
    { city: 'Sandberg Unterfr', area: '9701'},
    { city: 'Sande Kr Friesl', area: '4422'},
    { city: 'Sandersleben', area: '34785'},
    { city: 'Sandhausen Baden', area: '6224'},
    { city: 'Sandstedt', area: '4702'},
    { city: 'Sangerhausen', area: '3464'},
    { city: 'Sanitz b Rostock', area: '38209'},
    { city: 'Sankt Andreasberg', area: '5582'},
    { city: 'Sankt Englmar', area: '9965'},
    { city: 'Sankt Julian', area: '6387'},
    { city: 'Sankt Margarethen Holst', area: '4858'},
    { city: 'Sankt Michaelisdonn', area: '4853'},
    { city: 'Sankt Peter-Ording', area: '4863'},
    { city: 'Sankt Wolfgang', area: '8085'},
    { city: 'Sarnow b Anklam', area: '39722'},
    { city: 'Sarstedt', area: '5066'},
    { city: 'Sarzbüttel', area: '4806'},
    { city: 'Sassenberg', area: '2583'},
    { city: 'Sassenburg-Grussendorf', area: '5379'},
    { city: 'Sassenburg-Platendorf', area: '5378'},
    { city: 'Sassnitz', area: '38392'},
    { city: 'Saterland', area: '4492'},
    { city: 'Saterland-Ramsloh', area: '4498'},
    { city: 'Satow b Bad Doberan', area: '38295'},
    { city: 'Satrup', area: '4633'},
    { city: 'Sauensiek', area: '4169'},
    { city: 'Sauerlach', area: '8104'},
    { city: 'Sauldorf', area: '7777'},
    { city: 'Saulgau', area: '7581'},
    { city: 'Sayda', area: '37365'},
    { city: 'Schafflund', area: '4639'},
    { city: 'Schafstädt', area: '34636'},
    { city: 'Schafstedt', area: '4805'},
    { city: 'Schalkau', area: '36766'},
    { city: 'Schalksmühle', area: '2355'},
    { city: 'Schapbach', area: '7839'},
    { city: 'Scharbeutz-Haffkrug', area: '4563'},
    { city: 'Scharbeutz-Pönitz', area: '4524'},
    { city: 'Scharnebeck', area: '4136'},
    { city: 'Schashagen', area: '4564'},
    { city: 'Schauenburg', area: '5601'},
    { city: 'Scheden', area: '5546'},
    { city: 'Scheessel', area: '4263'},
    { city: 'Schefflenz', area: '6293'},
    { city: 'Scheibenberg', area: '37349'},
    { city: 'Scheinfeld', area: '9162'},
    { city: 'Schelklingen', area: '7394'},
    { city: 'Schelklingen-Hütten', area: '7384'},
    { city: 'Schellerten', area: '5123'},
    { city: 'Schemmerhofen', area: '7356'},
    { city: 'Schenefeld Mittelholst', area: '4892'},
    { city: 'Schenklengsfeld', area: '6629'},
    { city: 'Schermbeck', area: '2853'},
    { city: 'Schesslitz', area: '9542'},
    { city: 'Schieder-Schwalenberg', area: '5282'},
    { city: 'Schiedungen', area: '36337'},
    { city: 'Schierke', area: '39455'},
    { city: 'Schierling', area: '9451'},
    { city: 'Schiffdorf', area: '4706'},
    { city: 'Schiffdorf-Geestenseth', area: '4749'},
    { city: 'Schifferstadt', area: '6235'},
    { city: 'Schildau Gneisenaustadt', area: '34221'},
    { city: 'Schillingsfürst', area: '9868'},
    { city: 'Schiltach', area: '7836'},
    { city: 'Schiltberg', area: '8259'},
    { city: 'Schinne', area: '39320'},
    { city: 'Schkeuditz', area: '34204'},
    { city: 'Schkölen Thür', area: '36694'},
    { city: 'Schladen', area: '5335'},
    { city: 'Schlagsdorf b Gadebusch', area: '38875'},
    { city: 'Schlangenbad', area: '6129'},
    { city: 'Schleching', area: '8649'},
    { city: 'Schleiden Eifel', area: '2445'},
    { city: 'Schleiden-Dreiborn', area: '2485'},
    { city: 'Schleiden-Gemünd', area: '2444'},
    { city: 'Schleife', area: '35773'},
    { city: 'Schleiz', area: '3663'},
    { city: 'Schlepzig', area: '35472'},
    { city: 'Schlesen', area: '4303'},
    { city: 'Schleswig', area: '4621'},
    { city: 'Schleusingen', area: '36841'},
    { city: 'Schlieben', area: '35361'},
    { city: 'Schliengen', area: '7635'},
    { city: 'Schlitz', area: '6642'},
    { city: 'Schloss Holte-Stukenbrock', area: '5207'},
    { city: 'Schlossvippach', area: '36371'},
    { city: 'Schlotheim', area: '36021'},
    { city: 'Schluchsee', area: '7656'},
    { city: 'Schlüchtern', area: '6661'},
    { city: 'Schlüsselfeld-Aschbach', area: '9555'},
    { city: 'Schmalkalden', area: '3683'},
    { city: 'Schmallenberg', area: '2972'},
    { city: 'Schmallenberg-Bödefeld', area: '2977'},
    { city: 'Schmallenberg-Dorlar', area: '2971'},
    { city: 'Schmallenberg-Fredeburg', area: '2974'},
    { city: 'Schmallenberg-Oberkirchen', area: '2975'},
    { city: 'Schmelz Saar', area: '6887'},
    { city: 'Schmidmühlen', area: '9474'},
    { city: 'Schmiedefeld a Rennsteig', area: '36782'},
    { city: 'Schmitten Taunus', area: '6084'},
    { city: 'Schmölln b Prenzlau', area: '39862'},
    { city: 'Schmölln Thür', area: '34491'},
    { city: 'Schnackenburg', area: '5840'},
    { city: 'Schnaitsee', area: '8074'},
    { city: 'Schnaittach', area: '9153'},
    { city: 'Schneeberg Erzgeb', area: '3772'},
    { city: 'Schnega', area: '5842'},
    { city: 'Schneidlingen', area: '39267'},
    { city: 'Schnelldorf', area: '7950'},
    { city: 'Schneverdingen', area: '5193'},
    { city: 'Schneverdingen-Heber', area: '5199'},
    { city: 'Schneverdingen-Wintermoor', area: '5198'},
    { city: 'Schöffengrund', area: '6445'},
    { city: 'Schöfweg', area: '9908'},
    { city: 'Schollene', area: '39389'},
    { city: 'Schöllkrippen', area: '6024'},
    { city: 'Schöllnach', area: '9903'},
    { city: 'Schömberg b Balingen', area: '7427'},
    { city: 'Schömberg b Neuenbürg', area: '7084'},
    { city: 'Schönau a d Brend', area: '9775'},
    { city: 'Schönau im Schwarzwald', area: '7673'},
    { city: 'Schönau Niederbay', area: '8726'},
    { city: 'Schönau Odenw', area: '6228'},
    { city: 'Schönbeck Meckl', area: '3968'},
    { city: 'Schönberg Holstein', area: '4344'},
    { city: 'Schönberg Meckl', area: '38828'},
    { city: 'Schönberg Niederbay', area: '8554'},
    { city: 'Schönborn Kr Elbe-Elster', area: '35326'},
    { city: 'Schönbrunn b Hildburghaus', area: '36874'},
    { city: 'Schondorf a Ammersee', area: '8192'},
    { city: 'Schönebeck Elbe', area: '3928'},
    { city: 'Schöneck', area: '6187'},
    { city: 'Schöneck Vogtl', area: '37464'},
    { city: 'Schönecken', area: '6553'},
    { city: 'Schönenberg-Kübelberg', area: '6373'},
    { city: 'Schönermark b Prenzlau', area: '39852'},
    { city: 'Schönewalde b Herzberg', area: '35362'},
    { city: 'Schönfeld b Großenhain', area: '35248'},
    { city: 'Schongau', area: '8861'},
    { city: 'Schönhausen Elbe', area: '39323'},
    { city: 'Schönheide Erzgeb', area: '37755'},
    { city: 'Schöningen', area: '5352'},
    { city: 'Schönkirchen', area: '4348'},
    { city: 'Schönsee', area: '9674'},
    { city: 'Schöntal Jagst', area: '7943'},
    { city: 'Schönthal Oberpf', area: '9978'},
    { city: 'Schonungen-Marktsteinach', area: '9727'},
    { city: 'Schönwalde am Bungsberg', area: '4528'},
    { city: 'Schönwalde b Lübben', area: '35474'},
    { city: 'Schopfheim', area: '7622'},
    { city: 'Schopfheim-Gersbach', area: '7620'},
    { city: 'Schopfloch Mittelfr', area: '9857'},
    { city: 'Schopp', area: '6307'},
    { city: 'Schöppenstedt', area: '5332'},
    { city: 'Schöppingen', area: '2555'},
    { city: 'Schorndorf Württ', area: '7181'},
    { city: 'Schotten Hess', area: '6044'},
    { city: 'Schramberg', area: '7422'},
    { city: 'Schrecksbach', area: '6698'},
    { city: 'Schrobenhausen', area: '8252'},
    { city: 'Schrozberg', area: '7935'},
    { city: 'Schrozberg-Bartenstein', area: '7936'},
    { city: 'Schrozberg-Spielbach', area: '7939'},
    { city: 'Schulenberg im Oberharz', area: '5329'},
    { city: 'Schulzendorf Kr Oberhavel', area: '33083'},
    { city: 'Schuttertal', area: '7826'},
    { city: 'Schüttorf', area: '5923'},
    { city: 'Schwaan', area: '3844'},
    { city: 'Schwabach', area: '9122'},
    { city: 'Schwabenheim an der Selz', area: '6130'},
    { city: 'Schwabhausen b Dachau', area: '8138'},
    { city: 'Schwäbisch Gmünd', area: '7171'},
    { city: 'Schwäbisch Hall', area: '791'},
    { city: 'Schwäbisch Hall-Sulzdorf', area: '7907'},
    { city: 'Schwabmünchen', area: '8232'},
    { city: 'Schwabsoien', area: '8868'},
    { city: 'Schwabstedt', area: '4884'},
    { city: 'Schwaförden', area: '4277'},
    { city: 'Schwaigern', area: '7138'},
    { city: 'Schwalenberg', area: '5284'},
    { city: 'Schwalmstadt', area: '6691'},
    { city: 'Schwalmtal Niederrhein', area: '2163'},
    { city: 'Schwalmtal-Renzendorf', area: '6638'},
    { city: 'Schwalmtal-Storndorf', area: '6630'},
    { city: 'Schwanau', area: '7824'},
    { city: 'Schwandorf', area: '9431'},
    { city: 'Schwanebeck Sachs-Anh', area: '39424'},
    { city: 'Schwanewede', area: '4209'},
    { city: 'Schwanewede-Aschwarden', area: '4296'},
    { city: 'Schwanfeld', area: '9384'},
    { city: 'Schwanstetten', area: '9170'},
    { city: 'Schwarme', area: '4258'},
    { city: 'Schwarmstedt', area: '5071'},
    { city: 'Schwarz b Neustrelitz', area: '39827'},
    { city: 'Schwarzach Niederbay', area: '9962'},
    { city: 'Schwarze Pumpe', area: '3564'},
    { city: 'Schwarzenbach a d Saale', area: '9284'},
    { city: 'Schwarzenbach a Wald', area: '9289'},
    { city: 'Schwarzenbek', area: '4151'},
    { city: 'Schwarzenberg', area: '3774'},
    { city: 'Schwarzenborn Knüll', area: '5686'},
    { city: 'Schwarzenfeld', area: '9435'},
    { city: 'Schwedeneck', area: '4308'},
    { city: 'Schwedt/Oder', area: '3332'},
    { city: 'Schwegenheim', area: '6344'},
    { city: 'Schweich', area: '6502'},
    { city: 'Schweigen-Rechtenbach', area: '6342'},
    { city: 'Schweinfurt', area: '9721'},
    { city: 'Schweinsberg Hess', area: '6429'},
    { city: 'Schweitenkirchen', area: '8444'},
    { city: 'Schwelm', area: '2336'},
    { city: 'Schwendi', area: '7353'},
    { city: 'Schwenningen a Neckar', area: '7720'},
    { city: 'Schwenningen Baden', area: '7579'},
    { city: 'Schwepnitz', area: '35797'},
    { city: 'Schwerin Meckl', area: '385'},
    { city: 'Schweringen', area: '4257'},
    { city: 'Schwerte', area: '2304'},
    { city: 'Schwetzingen', area: '6202'},
    { city: 'Schwindegg', area: '8082'},
    { city: 'Schwinkendorf', area: '39953'},
    { city: 'Schwittersdorf', area: '34773'},
    { city: 'Sebnitz', area: '35971'},
    { city: 'Seckach', area: '6292'},
    { city: 'Seedorf b Bad Segeberg', area: '4555'},
    { city: 'Seedorf Lauenb', area: '4545'},
    { city: 'Seeg', area: '8364'},
    { city: 'Seegrehna', area: '34928'},
    { city: 'Seehausen Altmark', area: '39386'},
    { city: 'Seehausen b Prenzlau', area: '39863'},
    { city: 'Seehausen Börde', area: '39407'},
    { city: 'Seeheim-Jugenheim', area: '6257'},
    { city: 'Seelbach Schutter', area: '7823'},
    { city: 'Seelingstädt b Gera', area: '36608'},
    { city: 'Seelow', area: '3346'},
    { city: 'Seelze', area: '5137'},
    { city: 'Seeon-Seebruck', area: '8667'},
    { city: 'Seesen', area: '5381'},
    { city: 'Seesen-Groß Rhüden', area: '5384'},
    { city: 'Seeshaupt', area: '8801'},
    { city: 'Seestermühe', area: '4125'},
    { city: 'Seevetal', area: '4105'},
    { city: 'Seewald', area: '7448'},
    { city: 'Segeletz', area: '33978'},
    { city: 'Sehestedt Eider', area: '4357'},
    { city: 'Sehnde', area: '5138'},
    { city: 'Seiffen Erzgeb', area: '37362'},
    { city: 'Seilershof', area: '33085'},
    { city: 'Seitschen', area: '35930'},
    { city: 'Selb', area: '9287'},
    { city: 'Selbitz Oberfr', area: '9280'},
    { city: 'Selent', area: '4384'},
    { city: 'Selfkant', area: '2456'},
    { city: 'Seligenstadt', area: '6182'},
    { city: 'Sellin Ostseebad', area: '38303'},
    { city: 'Selm', area: '2592'},
    { city: 'Selmsdorf', area: '38823'},
    { city: 'Selsingen', area: '4284'},
    { city: 'Selters Taunus', area: '6483'},
    { city: 'Selters Westferwald', area: '2626'},
    { city: 'Semlow', area: '38222'},
    { city: 'Semmenstedt', area: '5336'},
    { city: 'Senden Iller', area: '7307'},
    { city: 'Senden Westf', area: '2597'},
    { city: 'Sendenhorst', area: '2526'},
    { city: 'Sendenhorst-Albersloh', area: '2535'},
    { city: 'Senden-Ottmarsbocholt', area: '2598'},
    { city: 'Senftenberg', area: '3573'},
    { city: 'Senzke', area: '33238'},
    { city: 'Sesslach', area: '9569'},
    { city: 'Seßlach-Gemünda', area: '9567'},
    { city: 'Seubersdorf i d Opf', area: '9497'},
    { city: 'Seyda', area: '35387'},
    { city: 'Sibbesse', area: '5065'},
    { city: 'Sickte', area: '5305'},
    { city: 'Siedenbollentin', area: '3969'},
    { city: 'Siedenburg', area: '4272'},
    { city: 'Siegbach', area: '2778'},
    { city: 'Siegburg', area: '2241'},
    { city: 'Siegen', area: '271'},
    { city: 'Siegenburg', area: '9444'},
    { city: 'Siegsdorf Kr Traunstein', area: '8662'},
    { city: 'Siek Kr Stormarn', area: '4107'},
    { city: 'Sielenbach', area: '8258'},
    { city: 'Sien', area: '6788'},
    { city: 'Sievershütten', area: '4194'},
    { city: 'Siggelkow', area: '38724'},
    { city: 'Sigmaringen', area: '7571'},
    { city: 'Sigmaringen-Gutenstein', area: '7570'},
    { city: 'Simbach a Inn', area: '8571'},
    { city: 'Simbach Niederbay', area: '9954'},
    { city: 'Simmelsdorf', area: '9155'},
    { city: 'Simmerath', area: '2473'},
    { city: 'Simmern Hunsrück', area: '6761'},
    { city: 'Simmersdorf', area: '35695'},
    { city: 'Simmersfeld', area: '7484'},
    { city: 'Simmershofen', area: '9848'},
    { city: 'Simonswald', area: '7683'},
    { city: 'Singen Hohentwiel', area: '7731'},
    { city: 'Sinntal-Altengronau', area: '6665'},
    { city: 'Sinntal-Sterbfritz', area: '6664'},
    { city: 'Sinsheim', area: '7261'},
    { city: 'Sinsheim-Hilsbach', area: '7260'},
    { city: 'Sittensen', area: '4282'},
    { city: 'Sitzendorf', area: '36730'},
    { city: 'Soest', area: '2921'},
    { city: 'Soest-Ostönnen', area: '2928'},
    { city: 'Sögel', area: '5952'},
    { city: 'Sohland Spree', area: '35936'},
    { city: 'Söhlde', area: '5129'},
    { city: 'Söhrewald', area: '5608'},
    { city: 'Solingen*1', area: '212'},
    { city: 'Söllmnitz', area: '36695'},
    { city: 'Solnhofen', area: '9145'},
    { city: 'Soltau', area: '5191'},
    { city: 'Soltau-Emmingen', area: '5190'},
    { city: 'Soltau-Frielingen', area: '5197'},
    { city: 'Soltendieck', area: '5874'},
    { city: 'Sömmerda', area: '3634'},
    { city: 'Sommerhausen', area: '9333'},
    { city: 'Sondershausen', area: '3632'},
    { city: 'Sonneberg Thür', area: '3675'},
    { city: 'Sonnefeld', area: '9562'},
    { city: 'Sonnenbühl', area: '7128'},
    { city: 'Sonnewalde', area: '35323'},
    { city: 'Sonsbeck', area: '2838'},
    { city: 'Sontheim a d Brenz', area: '7325'},
    { city: 'Sonthofen', area: '8321'},
    { city: 'Sontra', area: '5653'},
    { city: 'Sörup', area: '4635'},
    { city: 'Sottrum Kr Rotenburg', area: '4264'},
    { city: 'Spaichingen', area: '7424'},
    { city: 'Spalt', area: '9175'},
    { city: 'Spangenberg', area: '5663'},
    { city: 'Spantekow', area: '39727'},
    { city: 'Speicher', area: '6562'},
    { city: 'Speichersdorf', area: '9275'},
    { city: 'Spelle', area: '5977'},
    { city: 'Spenge', area: '5225'},
    { city: 'Sperenberg', area: '33703'},
    { city: 'Speyer', area: '6232'},
    { city: 'Spiegelau', area: '8553'},
    { city: 'Spiegelberg', area: '7194'},
    { city: 'Spiekeroog', area: '4976'},
    { city: 'Spornitz', area: '38726'},
    { city: 'Spraitbach', area: '7176'},
    { city: 'Sprakensehl', area: '5837'},
    { city: 'Spreenhagen', area: '33633'},
    { city: 'Spremberg', area: '3563'},
    { city: 'Sprendlingen Rheinhess', area: '6701'},
    { city: 'Springe Deister', area: '5041'},
    { city: 'Springe-Bennigsen', area: '5045'},
    { city: 'Springe-Eldagsen', area: '5044'},
    { city: 'Sprockhövel-Haßlinghausen', area: '2339'},
    { city: 'St Blasien', area: '7672'},
    { city: 'St Georgen im Schwarzwald', area: '7724'},
    { city: 'St Goar', area: '6741'},
    { city: 'St Goarshausen', area: '6771'},
    { city: 'St Ingbert', area: '6894'},
    { city: 'St Johann Württ', area: '7122'},
    { city: 'St Märgen', area: '7669'},
    { city: 'St Peter Schwarzw', area: '7660'},
    { city: 'St Wendel', area: '6851'},
    { city: 'St Wendel-Niederkirchen', area: '6856'},
    { city: 'Stäbelow', area: '38207'},
    { city: 'Stade', area: '4141'},
    { city: 'Stade-Bützfleth', area: '4146'},
    { city: 'Stadelhofen', area: '9504'},
    { city: 'Stadland-Rodenkirchen', area: '4732'},
    { city: 'Stadland-Schwei', area: '4737'},
    { city: 'Stadland-Seefeld', area: '4734'},
    { city: 'Stadt Wehlen', area: '35024'},
    { city: 'Stadtallendorf', area: '6428'},
    { city: 'Stadthagen', area: '5721'},
    { city: 'Stadtilm', area: '3629'},
    { city: 'Stadtlauringen', area: '9724'},
    { city: 'Stadtlengsfeld', area: '36965'},
    { city: 'Stadtlohn', area: '2563'},
    { city: 'Stadtoldendorf', area: '5532'},
    { city: 'Stadtroda', area: '36428'},
    { city: 'Stadtsteinach', area: '9225'},
    { city: 'Staffelstein Oberfr', area: '9573'},
    { city: 'Stafstedt', area: '4875'},
    { city: 'Stahnsdorf', area: '3329'},
    { city: 'Stallwang', area: '9964'},
    { city: 'Stammbach', area: '9256'},
    { city: 'Stammham b Ingolstadt', area: '8405'},
    { city: 'Stamsried', area: '9466'},
    { city: 'Standenbühl', area: '6357'},
    { city: 'Starnberg', area: '8151'},
    { city: 'Stassfurt', area: '3925'},
    { city: 'Stauchitz', area: '35268'},
    { city: 'Staufen im Breisgau', area: '7633'},
    { city: 'Staufenberg Niedersachs', area: '5543'},
    { city: 'Staven', area: '39608'},
    { city: 'Stavenhagen Reuterstadt', area: '39954'},
    { city: 'Stechow Brandenb', area: '33874'},
    { city: 'Steimbke', area: '5026'},
    { city: 'Steinach Thür', area: '36762'},
    { city: 'Steinau an der Straße', area: '6663'},
    { city: 'Steinau-Marjoss', area: '6660'},
    { city: 'Steinau-Ulmbach', area: '6667'},
    { city: 'Steinbach-Hallenberg', area: '36847'},
    { city: 'Steinbergkirche', area: '4632'},
    { city: 'Steinburg Kr Storman', area: '4534'},
    { city: 'Steinen Kr Lörrach', area: '7627'},
    { city: 'Steinfeld Oldenburg', area: '5492'},
    { city: 'Steinfurt-Borghorst', area: '2552'},
    { city: 'Steinfurt-Burgsteinfurt', area: '2551'},
    { city: 'Steingaden Oberbay', area: '8862'},
    { city: 'Steinhagen Westf', area: '5204'},
    { city: 'Steinheid', area: '36704'},
    { city: 'Steinheim am Albuch', area: '7329'},
    { city: 'Steinheim Westf', area: '5233'},
    { city: 'Steinhöfel Kr Oder-Spree', area: '33636'},
    { city: 'Steinhöring', area: '8094'},
    { city: 'Steinhorst Lauenb', area: '4536'},
    { city: 'Steinhorst Niedersachs', area: '5148'},
    { city: 'Steinkirchen Kr Stade', area: '4142'},
    { city: 'Stein-Neukirch', area: '2667'},
    { city: 'Steinsdorf b Jessen', area: '35384'},
    { city: 'Steinsdorf Brandenb', area: '33657'},
    { city: 'Steisslingen', area: '7738'},
    { city: 'Stelle Kr Harburg', area: '4174'},
    { city: 'Stemwede-Dielingen', area: '5474'},
    { city: 'Stemwede-Levern', area: '5745'},
    { city: 'Stemwede-Wehdem', area: '5773'},
    { city: 'Stendal', area: '3931'},
    { city: 'Stepenitz', area: '33969'},
    { city: 'Stephanskirchen Simssee', area: '8036'},
    { city: 'Stephansposching', area: '9935'},
    { city: 'Sternberg', area: '3847'},
    { city: 'Sterup', area: '4637'},
    { city: 'Stetten am kalten Markt', area: '7573'},
    { city: 'Steutz', area: '39244'},
    { city: 'Steyerberg', area: '5764'},
    { city: 'Steyerberg-Voigtei', area: '5769'},
    { city: 'Stockach', area: '7771'},
    { city: 'Stockelsdorf-Curau', area: '4505'},
    { city: 'Stockelsdorf-Krumbeck', area: '4506'},
    { city: 'Stockstadt a Main', area: '6027'},
    { city: 'Stödtlen', area: '7964'},
    { city: 'Stoetze', area: '5872'},
    { city: 'Stolberg Harz', area: '34654'},
    { city: 'Stolberg Rheinl', area: '2402'},
    { city: 'Stolberg-Gressenich', area: '2409'},
    { city: 'Stollberg Erzgeb', area: '37296'},
    { city: 'Stolpe/Oder', area: '33338'},
    { city: 'Stolpen', area: '35973'},
    { city: 'Stolzenau', area: '5761'},
    { city: 'Storkow Mark', area: '33678'},
    { city: 'Stößen', area: '34445'},
    { city: 'Stötten a Auerberg', area: '8349'},
    { city: 'Stotternheim', area: '36204'},
    { city: 'Stöttwang', area: '8345'},
    { city: 'Straach', area: '34929'},
    { city: 'Straelen', area: '2834'},
    { city: 'Straelen-Herongen', area: '2839'},
    { city: 'Stralsund', area: '3831'},
    { city: 'Strasburg', area: '39753'},
    { city: 'Strassberg Harz', area: '39489'},
    { city: 'Strasskirchen', area: '9424'},
    { city: 'Straßlach-Dingharting', area: '8170'},
    { city: 'Straubing', area: '9421'},
    { city: 'Straufhain-Streufdorf', area: '36875'},
    { city: 'Straupitz', area: '35475'},
    { city: 'Strausberg', area: '3341'},
    { city: 'Straussfurt', area: '36376'},
    { city: 'Strehla', area: '35264'},
    { city: 'Ströbeck', area: '39427'},
    { city: 'Stromberg Hunsrück', area: '6724'},
    { city: 'Struppen', area: '35020'},
    { city: 'Struth b Mühlhausen Thür', area: '36026'},
    { city: 'Strüth Taunus', area: '6775'},
    { city: 'Stubben b Bremerhaven', area: '4748'},
    { city: 'Stuer', area: '39924'},
    { city: 'Stühlingen', area: '7744'},
    { city: 'Stuhr-Heiligenrode', area: '4206'},
    { city: 'Stülpe', area: '33733'},
    { city: 'Stutensee', area: '7249'},
    { city: 'Stuttgart', area: '711'},
    { city: 'Stützerbach', area: '36784'},
    { city: 'Südbrookmerland', area: '4942'},
    { city: 'Süderbrarup', area: '4641'},
    { city: 'Suderburg', area: '5826'},
    { city: 'Süderhastedt', area: '4830'},
    { city: 'Süderlügum', area: '4663'},
    { city: 'Süderstapel', area: '4883'},
    { city: 'Südlohn', area: '2862'},
    { city: 'Sugenheim', area: '9165'},
    { city: 'Suhl', area: '3681'},
    { city: 'Suhl-Dietzhausen', area: '36846'},
    { city: 'Suhlendorf', area: '5820'},
    { city: 'Sülfeld Holst', area: '4537'},
    { city: 'Sulingen', area: '4271'},
    { city: 'Sulz am Neckar', area: '7454'},
    { city: 'Sulzbach a Main', area: '6028'},
    { city: 'Sulzbach an der Murr', area: '7193'},
    { city: 'Sulzbach Saar', area: '6897'},
    { city: 'Sulzbach-Laufen', area: '7976'},
    { city: 'Sulzbach-Rosenberg', area: '9661'},
    { city: 'Sulzberg Allgäu', area: '8376'},
    { city: 'Sulzburg', area: '7634'},
    { city: 'Sulzdorf a d Lederhecke', area: '9763'},
    { city: 'Sulzemoos', area: '8135'},
    { city: 'Sulzfeld Baden', area: '7269'},
    { city: 'Sünching', area: '9480'},
    { city: 'Sundern Sauerland', area: '2933'},
    { city: 'Sundern-Allendorf', area: '2393'},
    { city: 'Sundern-Altenhellefeld', area: '2934'},
    { city: 'Sundern-Hachen', area: '2935'},
    { city: 'Süplingen', area: '39053'},
    { city: 'Surwold', area: '4965'},
    { city: 'Süsel-Bujendorf', area: '4529'},
    { city: 'Süßen', area: '7162'},
    { city: 'Sustrum', area: '5939'},
    { city: 'Syke', area: '4242'},
    { city: 'Syke-Heiligenfelde', area: '4240'},
    { city: 'Sylda', area: '34742'},
    { city: 'Sylt', area: '4651'},
    { city: 'Taarstedt', area: '4622'},
    { city: 'Tabarz Thür Wald', area: '36259'},
    { city: 'Tacherting- Peterskirchen', area: '8622'},
    { city: 'Taching-Tengling', area: '8687'},
    { city: 'Tagmersheim', area: '9094'},
    { city: 'Talheim Kr Tuttlingen', area: '7464'},
    { city: 'Talkau', area: '4156'},
    { city: 'Tambach-Dietharz Thür Wald', area: '36252'},
    { city: 'Tangeln', area: '39007'},
    { city: 'Tangerhütte', area: '3935'},
    { city: 'Tangermünde', area: '39322'},
    { city: 'Tangstedt Bz Hamburg', area: '4109'},
    { city: 'Tann Niederbay', area: '8572'},
    { city: 'Tann Rhön', area: '6682'},
    { city: 'Tanna b Schleiz', area: '36646'},
    { city: 'Tannenbergsthal Vogtl', area: '37465'},
    { city: 'Tännesberg', area: '9655'},
    { city: 'Tannheim Württ', area: '8395'},
    { city: 'Tantow', area: '33333'},
    { city: 'Tapfheim', area: '9070'},
    { city: 'Tarmstedt', area: '4283'},
    { city: 'Tarnow b Bützow', area: '38450'},
    { city: 'Tarp', area: '4638'},
    { city: 'Tauberbischofsheim', area: '9341'},
    { city: 'Taucha b Leipzig', area: '34298'},
    { city: 'Tauche', area: '33675'},
    { city: 'Taufkirchen Vils', area: '8084'},
    { city: 'Taunusstein', area: '6128'},
    { city: 'Tauscha b Großenhain', area: '35240'},
    { city: 'Tecklenburg', area: '5482'},
    { city: 'Tecklenburg-Brochterbeck', area: '5455'},
    { city: 'Tegernau Baden', area: '7629'},
    { city: 'Tegernsee', area: '8022'},
    { city: 'Teicha Sachs-Anh', area: '34606'},
    { city: 'Teichel', area: '36743'},
    { city: 'Teichwolframsdorf', area: '36624'},
    { city: 'Teisendorf', area: '8666'},
    { city: 'Teisnach', area: '9923'},
    { city: 'Teistungen', area: '36071'},
    { city: 'Telgte', area: '2504'},
    { city: 'Tellingstedt', area: '4838'},
    { city: 'Teltow', area: '3328'},
    { city: 'Templin', area: '3987'},
    { city: 'Tengen', area: '7736'},
    { city: 'Tennenbronn', area: '7729'},
    { city: 'Terpt', area: '35456'},
    { city: 'Tessin b Rostock', area: '38205'},
    { city: 'Teterow', area: '3996'},
    { city: 'Tettau Kr Kronach', area: '9269'},
    { city: 'Tettenweis', area: '8534'},
    { city: 'Tettnang', area: '7542'},
    { city: 'Teuchern', area: '34443'},
    { city: 'Teufelsmoor', area: '4796'},
    { city: 'Teupitz', area: '33766'},
    { city: 'Teuschnitz', area: '9268'},
    { city: 'Teutschenthal', area: '34601'},
    { city: 'Tewswoos', area: '38759'},
    { city: 'Thale', area: '3947'},
    { city: 'Thaleischweiler-Fröschen', area: '6334'},
    { city: 'Thalfang', area: '6504'},
    { city: 'Thalmassing', area: '9453'},
    { city: 'Thalmässing', area: '9173'},
    { city: 'Thannhausen Schwab', area: '8281'},
    { city: 'Tharandt', area: '35203'},
    { city: 'Thedinghausen', area: '4204'},
    { city: 'Theessen', area: '39223'},
    { city: 'Theilenhofen', area: '9834'},
    { city: 'Themar', area: '36873'},
    { city: 'Thierstein', area: '9235'},
    { city: 'Thimmendorf', area: '36643'},
    { city: 'Thomasburg', area: '5859'},
    { city: 'Thum Sachs', area: '37297'},
    { city: 'Thüngen', area: '9360'},
    { city: 'Thürkow', area: '39975'},
    { city: 'Thurnau', area: '9228'},
    { city: 'Thurnau-Alladorf', area: '9271'},
    { city: 'Thyrnau', area: '8501'},
    { city: 'Tiefenbach Oberpf', area: '9673'},
    { city: 'Tiefenbronn', area: '7234'},
    { city: 'Tiengen Hochrhein', area: '7741'},
    { city: 'Timmendorfer Strand', area: '4503'},
    { city: 'Tirschenreuth', area: '9631'},
    { city: 'Titisee-Neustadt', area: '7651'},
    { city: 'Titting', area: '8423'},
    { city: 'Tittling', area: '8504'},
    { city: 'Tittmoning', area: '8683'},
    { city: 'Titz', area: '2463'},
    { city: 'Todenbüttel', area: '4874'},
    { city: 'Todesfelde', area: '4558'},
    { city: 'Todtmoos', area: '7674'},
    { city: 'Todtnau', area: '7671'},
    { city: 'Tonna', area: '36042'},
    { city: 'Tönning', area: '4861'},
    { city: 'Töpchin', area: '33769'},
    { city: 'Töpen', area: '9295'},
    { city: 'Töplitz', area: '33202'},
    { city: 'Torfhaus', area: '5320'},
    { city: 'Torgau', area: '3421'},
    { city: 'Torgelow b Ueckermünde', area: '3976'},
    { city: 'Törpin', area: '39996'},
    { city: 'Tostedt', area: '4182'},
    { city: 'Traben-Trarbach', area: '6541'},
    { city: 'Traitsching', area: '9974'},
    { city: 'Trappstadt', area: '9765'},
    { city: 'Traunreut', area: '8669'},
    { city: 'Traunstein', area: '861'},
    { city: 'Trautskirchen', area: '9107'},
    { city: 'Trebatsch', area: '33674'},
    { city: 'Trebbin', area: '33731'},
    { city: 'Trebel', area: '5848'},
    { city: 'Trebnitz b Müncheberg', area: '33477'},
    { city: 'Trebsen Mulde', area: '34383'},
    { city: 'Trebur', area: '6147'},
    { city: 'Treffurt', area: '36923'},
    { city: 'Treia', area: '4626'},
    { city: 'Treis-Karden', area: '2672'},
    { city: 'Trendelburg', area: '5675'},
    { city: 'Trent', area: '38309'},
    { city: 'Treuchtlingen', area: '9142'},
    { city: 'Treuen Vogtl', area: '37468'},
    { city: 'Treuenbrietzen', area: '33748'},
    { city: 'Triberg im Schwarzwald', area: '7722'},
    { city: 'Tribsees', area: '38320'},
    { city: 'Triebes', area: '36622'},
    { city: 'Triefenstein', area: '9395'},
    { city: 'Triepkendorf', area: '39820'},
    { city: 'Trier', area: '651'},
    { city: 'Triftern', area: '8562'},
    { city: 'Trinwillershagen', area: '38225'},
    { city: 'Trippstadt', area: '6306'},
    { city: 'Triptis', area: '36482'},
    { city: 'Trittau', area: '4154'},
    { city: 'Trochtelfingen Hohenz', area: '7124'},
    { city: 'Trossingen', area: '7425'},
    { city: 'Trostberg', area: '8621'},
    { city: 'Trulben', area: '6335'},
    { city: 'Trusetal', area: '36840'},
    { city: 'Tübingen', area: '7071'},
    { city: 'Tucheim', area: '39346'},
    { city: 'Tuntenhausen', area: '8067'},
    { city: 'Tuntenhausen-Schönau', area: '8065'},
    { city: 'Türkheim Wertach', area: '8245'},
    { city: 'Tussenhausen', area: '8268'},
    { city: 'Tüßling', area: '8633'},
    { city: 'Tutow', area: '39999'},
    { city: 'Tuttlingen', area: '7461'},
    { city: 'Tutzing', area: '8158'},
    { city: 'Twist', area: '5936'},
    { city: 'Twistetal', area: '5695'},
    { city: 'Twistringen', area: '4243'},
    { city: 'Twistringen-Heiligenloh', area: '4246'},
    { city: 'Twist-Schöninghsdorf', area: '5935'},
    { city: 'Überherrn', area: '6836'},
    { city: 'Überlingen Bodensee', area: '7551'},
    { city: 'Übersee', area: '8642'},
    { city: 'Uchte', area: '5763'},
    { city: 'Üchtelhausen', area: '9720'},
    { city: 'Uckro', area: '35454'},
    { city: 'Uder', area: '36083'},
    { city: 'Üdersdorf', area: '6596'},
    { city: 'Ueckermünde', area: '39771'},
    { city: 'Uedem', area: '2825'},
    { city: 'Uelsen', area: '5942'},
    { city: 'Uelzen', area: '581'},
    { city: 'Uersfeld', area: '2657'},
    { city: 'Uetersen', area: '4122'},
    { city: 'Uettingen', area: '9369'},
    { city: 'Uetze', area: '5173'},
    { city: 'Uetze-Hänigsen', area: '5147'},
    { city: 'Uffenheim', area: '9842'},
    { city: 'Uffing a Staffelsee', area: '8846'},
    { city: 'Uhldingen-Mühlhofen', area: '7556'},
    { city: 'Ühlingen-Birkendorf', area: '7743'},
    { city: 'Uhlstädt', area: '36742'},
    { city: 'Uhyst Spree', area: '35728'},
    { city: 'Ulm Donau', area: '731'},
    { city: 'Ulmen', area: '2676'},
    { city: 'Ulrichstein', area: '6645'},
    { city: 'Undeloh', area: '4189'},
    { city: 'Unna', area: '2303'},
    { city: 'Unna-Hemmerde', area: '2308'},
    { city: 'Unseburg', area: '39263'},
    { city: 'Unsleben', area: '9773'},
    { city: 'Unteregg b Mindelheim', area: '8269'},
    { city: 'Unterellen', area: '36927'},
    { city: 'Untergriesbach', area: '8593'},
    { city: 'Untergröningen', area: '7975'},
    { city: 'Unterloquitz', area: '36731'},
    { city: 'Unterlüß', area: '5827'},
    { city: 'Untermerzbach', area: '9533'},
    { city: 'Unterpleichfeld', area: '9367'},
    { city: 'Unterreichenbach Kr Calw', area: '7235'},
    { city: 'Unterschneidheim', area: '7966'},
    { city: 'Untersiemau', area: '9565'},
    { city: 'Untersteinbach Unterfr', area: '9554'},
    { city: 'Unterthingau', area: '8377'},
    { city: 'Uplengen', area: '4956'},
    { city: 'Ursensollen', area: '9628'},
    { city: 'Urspringen b Lohr', area: '9396'},
    { city: 'Usedom', area: '38372'},
    { city: 'Usingen', area: '6081'},
    { city: 'Uslar', area: '5571'},
    { city: 'Uslar-Volpriehausen', area: '5573'},
    { city: 'Uthmöden', area: '39058'},
    { city: 'Uttenweiler', area: '7374'},
    { city: 'Utting a Ammersee', area: '8806'},
    { city: 'Vacha', area: '36962'},
    { city: 'Vaihingen an der Enz', area: '7042'},
    { city: 'Varel Jadebusen', area: '4451'},
    { city: 'Varel-Altjührden', area: '4456'},
    { city: 'Varrel b Sulingen', area: '4274'},
    { city: 'Vaterstetten', area: '8106'},
    { city: 'Vechelde', area: '5302'},
    { city: 'Vechta', area: '4441'},
    { city: 'Vechta-Langförden', area: '4447'},
    { city: 'Velbert', area: '2051'},
    { city: 'Velbert-Langenberg', area: '2052'},
    { city: 'Velbert-Neviges', area: '2053'},
    { city: 'Velburg', area: '9182'},
    { city: 'Velden Vils', area: '8742'},
    { city: 'Velen', area: '2863'},
    { city: 'Velgast', area: '38324'},
    { city: 'Vellahn', area: '38848'},
    { city: 'Velpke', area: '5364'},
    { city: 'Velten', area: '3304'},
    { city: 'Ventschow', area: '38484'},
    { city: 'Verden Aller', area: '4231'},
    { city: 'Verden-Walle', area: '4230'},
    { city: 'Veringenstadt', area: '7577'},
    { city: 'Verl', area: '5246'},
    { city: 'Versmold', area: '5423'},
    { city: 'Vetschau', area: '35433'},
    { city: 'Vettelschoss', area: '2645'},
    { city: 'Vettweiss', area: '2424'},
    { city: 'Viechtach', area: '9942'},
    { city: 'Vienenburg', area: '5324'},
    { city: 'Viereck', area: '39748'},
    { city: 'Viernheim', area: '6204'},
    { city: 'Viersen', area: '2162'},
    { city: 'Viesecke', area: '38796'},
    { city: 'Vieselbach', area: '36203'},
    { city: 'Vilgertshofen', area: '8194'},
    { city: 'Villenbach', area: '8296'},
    { city: 'Villingen i Schwarzw', area: '7721'},
    { city: 'Villmar-Aumenau', area: '6474'},
    { city: 'Vilsbiburg', area: '8741'},
    { city: 'Vilseck', area: '9662'},
    { city: 'Vilsheim', area: '8706'},
    { city: 'Vilshofen Niederbay', area: '8541'},
    { city: 'Vilshofen-Pleinting', area: '8549'},
    { city: 'Vilshofen-Sandbach', area: '8548'},
    { city: 'Vinzelberg', area: '39325'},
    { city: 'Viöl', area: '4843'},
    { city: 'Virneburg', area: '2656'},
    { city: 'Visbek Kr Vechta', area: '4445'},
    { city: 'Visselhövede', area: '4262'},
    { city: 'Visselhövede-Wittorf', area: '4260'},
    { city: 'Vlotho', area: '5733'},
    { city: 'Vlotho-Exter', area: '5228'},
    { city: 'Voerde Niederrhein', area: '2855'},
    { city: 'Vogtareuth', area: '8038'},
    { city: 'Vogtsburg im Kaiserstuhl', area: '7662'},
    { city: 'Vohburg a d Donau', area: '8457'},
    { city: 'Vohenstrauss', area: '9651'},
    { city: 'Vöhl', area: '5635'},
    { city: 'Vöhrenbach', area: '7727'},
    { city: 'Vöhringen Iller', area: '7306'},
    { city: 'Volkach', area: '9381'},
    { city: 'Volkenschwand', area: '8754'},
    { city: 'Volkenshagen', area: '38202'},
    { city: 'Völklingen', area: '6898'},
    { city: 'Völklingen-Lauterbach', area: '6802'},
    { city: 'Volkmarsen', area: '5693'},
    { city: 'Vollrathsruhe', area: '39933'},
    { city: 'Völpke', area: '39402'},
    { city: 'Voltlage', area: '5467'},
    { city: 'Vorbach', area: '9205'},
    { city: 'Vörden Kr Vechta', area: '5495'},
    { city: 'Vorderweidenthal', area: '6398'},
    { city: 'Vreden', area: '2564'},
    { city: 'Waakirchen', area: '8021'},
    { city: 'Waal', area: '8246'},
    { city: 'Wabern Hess', area: '5683'},
    { city: 'Wachtendonk', area: '2836'},
    { city: 'Wächtersbach', area: '6053'},
    { city: 'Wacken', area: '4827'},
    { city: 'Waddeweitz', area: '5849'},
    { city: 'Wadern', area: '6871'},
    { city: 'Wadern-Nunkirchen', area: '6874'},
    { city: 'Wadersloh', area: '2523'},
    { city: 'Wadersloh-Diestedde', area: '2520'},
    { city: 'Wagenfeld', area: '5444'},
    { city: 'Wagenfeld-Ströhen', area: '5774'},
    { city: 'Waghäusel', area: '7254'},
    { city: 'Waging a See', area: '8681'},
    { city: 'Wahlstedt', area: '4554'},
    { city: 'Wahrenholz', area: '5835'},
    { city: 'Waiblingen', area: '7151'},
    { city: 'Waibstadt', area: '7263'},
    { city: 'Waidhaus', area: '9652'},
    { city: 'Waischenfeld', area: '9202'},
    { city: 'Wald Hohenz', area: '7578'},
    { city: 'Wald Oberpf', area: '9463'},
    { city: 'Waldböckelheim', area: '6758'},
    { city: 'Waldbreitbach', area: '2638'},
    { city: 'Waldbröl', area: '2291'},
    { city: 'Waldbrunn Odenw', area: '6274'},
    { city: 'Waldbrunn Westerwald', area: '6479'},
    { city: 'Waldburg Württ', area: '7529'},
    { city: 'Walddrehna', area: '35455'},
    { city: 'Waldeck-Sachsenhausen', area: '5634'},
    { city: 'Waldems', area: '6087'},
    { city: 'Waldenbuch', area: '7157'},
    { city: 'Waldenburg Sachs', area: '37608'},
    { city: 'Walderbach', area: '9464'},
    { city: 'Waldfeucht', area: '2455'},
    { city: 'Waldfischbach-Burgalben', area: '6333'},
    { city: 'Waldheim Sachs', area: '34327'},
    { city: 'Waldkappel', area: '5656'},
    { city: 'Waldkirch Breisgau', area: '7681'},
    { city: 'Waldkirchen Niederbay', area: '8581'},
    { city: 'Waldkraiburg', area: '8638'},
    { city: 'Wald-Michelbach', area: '6207'},
    { city: 'Waldmünchen', area: '9972'},
    { city: 'Waldmünchen-Geigant', area: '9975'},
    { city: 'Waldrach', area: '6500'},
    { city: 'Waldsassen', area: '9632'},
    { city: 'Waldshut', area: '7751'},
    { city: 'Waldsolms', area: '6085'},
    { city: 'Waldthurn', area: '9657'},
    { city: 'Walkendorf', area: '39972'},
    { city: 'Walkenried', area: '5525'},
    { city: 'Walldorf Baden', area: '6227'},
    { city: 'Walldürn', area: '6282'},
    { city: 'Walldürn-Altheim', area: '6285'},
    { city: 'Walldürn-Rippberg', area: '6286'},
    { city: 'Wallendorf Luppe', area: '34639'},
    { city: 'Wallenfels', area: '9262'},
    { city: 'Wallenhorst', area: '5407'},
    { city: 'Wallerfangen', area: '6837'},
    { city: 'Wallerfing', area: '9936'},
    { city: 'Wallersdorf', area: '9933'},
    { city: 'Wallhalben', area: '6375'},
    { city: 'Wallhausen Nahe', area: '6706'},
    { city: 'Wallhausen Sachs-Anh', area: '34656'},
    { city: 'Wallhausen Württ', area: '7955'},
    { city: 'Wallmerod', area: '6435'},
    { city: 'Wallstawe', area: '39033'},
    { city: 'Walschleben', area: '36201'},
    { city: 'Walsleben b Neuruppin', area: '33920'},
    { city: 'Walsrode', area: '5161'},
    { city: 'Walsrode-Kirchboitzen', area: '5166'},
    { city: 'Walsrode-Stellichte', area: '5168'},
    { city: 'Walsrode-Westenholz', area: '5167'},
    { city: 'Waltenhofen', area: '8303'},
    { city: 'Waltenhofen-Oberdorf', area: '8379'},
    { city: 'Waltershausen Thür', area: '3622'},
    { city: 'Walting Kr Eichstätt', area: '8426'},
    { city: 'Waltrop', area: '2309'},
    { city: 'Walzbachtal', area: '7203'},
    { city: 'Wanderup', area: '4606'},
    { city: 'Wandlitz', area: '33397'},
    { city: 'Wanfried', area: '5655'},
    { city: 'Wangels', area: '4382'},
    { city: 'Wangen im Allgäu', area: '7522'},
    { city: 'Wangen-Leupolz', area: '7506'},
    { city: 'Wangerland', area: '4463'},
    { city: 'Wangerland-Hooksiel', area: '4425'},
    { city: 'Wangerland-Horumersiel', area: '4426'},
    { city: 'Wangerooge', area: '4469'},
    { city: 'Wankendorf', area: '4326'},
    { city: 'Wanna', area: '4757'},
    { city: 'Wanne-Eickel', area: '2325'},
    { city: 'Wanzer', area: '39395'},
    { city: 'Wanzleben', area: '39209'},
    { city: 'Warburg', area: '5641'},
    { city: 'Warburg-Scherfede', area: '5642'},
    { city: 'Wardenburg', area: '4407'},
    { city: 'Waren Müritz', area: '3991'},
    { city: 'Warendorf', area: '2581'},
    { city: 'Warendorf-Hoetmar', area: '2585'},
    { city: 'Warendorf-Milte', area: '2584'},
    { city: 'Warin', area: '38482'},
    { city: 'Warmensteinach', area: '9277'},
    { city: 'Warmsen', area: '5767'},
    { city: 'Warstein', area: '2902'},
    { city: 'Warstein-Allagen', area: '2925'},
    { city: 'Wartenberg Oberbay', area: '8762'},
    { city: 'Wartmannsroth', area: '9737'},
    { city: 'Wassenberg', area: '2432'},
    { city: 'Wasserburg a Inn', area: '8071'},
    { city: 'Wasserleben', area: '39451'},
    { city: 'Wassertrüdingen', area: '9832'},
    { city: 'Wasungen', area: '36941'},
    { city: 'Wathlingen', area: '5144'},
    { city: 'Waxweiler', area: '6554'},
    { city: 'Wechmar', area: '36256'},
    { city: 'Wechselburg', area: '37384'},
    { city: 'Wedel', area: '4103'},
    { city: 'Wedemark', area: '5130'},
    { city: 'Weener', area: '4951'},
    { city: 'Weesenstein', area: '35027'},
    { city: 'Weeze', area: '2837'},
    { city: 'Wefensleben', area: '39400'},
    { city: 'Weferlingen', area: '39061'},
    { city: 'Wegberg', area: '2434'},
    { city: 'Wegberg-Rödgen', area: '2436'},
    { city: 'Wegeleben', area: '39423'},
    { city: 'Wegenstedt', area: '39059'},
    { city: 'Wegscheid Niederbay', area: '8592'},
    { city: 'Wehr Baden', area: '7762'},
    { city: 'Wehretal', area: '5658'},
    { city: 'Weibern', area: '2655'},
    { city: 'Weibersbrunn', area: '6094'},
    { city: 'Weichensdorf', area: '33673'},
    { city: 'Weida', area: '36603'},
    { city: 'Weiden i d Opf', area: '961'},
    { city: 'Weidenbach b Gerolstein', area: '6599'},
    { city: 'Weidenbach Mittelfr', area: '9826'},
    { city: 'Weidenberg', area: '9278'},
    { city: 'Weidenthal Pfalz', area: '6329'},
    { city: 'Weierbach', area: '6784'},
    { city: 'Weiherhammer', area: '9605'},
    { city: 'Weihmichl-Unterneuhausen', area: '8708'},
    { city: 'Weikersheim', area: '7934'},
    { city: 'Weil Der Stadt', area: '7033'},
    { city: 'Weil Kr Landsberg a Lech', area: '8195'},
    { city: 'Weilburg', area: '6471'},
    { city: 'Weilerbach', area: '6374'},
    { city: 'Weiler-Simmerberg', area: '8387'},
    { city: 'Weilerswist', area: '2254'},
    { city: 'Weilheim an der Teck', area: '7023'},
    { city: 'Weilheim i OB', area: '881'},
    { city: 'Weilheim Kr Waldshut', area: '7755'},
    { city: 'Weilmünster', area: '6472'},
    { city: 'Weilmünster-Wolfenhausen', area: '6475'},
    { city: 'Weilrod', area: '6083'},
    { city: 'Weimar Thür', area: '3643'},
    { city: 'Weinböhla', area: '35243'},
    { city: 'Weingarten Baden', area: '7244'},
    { city: 'Weinheim Bergstr', area: '6201'},
    { city: 'Weinsberg', area: '7134'},
    { city: 'Weischlitz', area: '37436'},
    { city: 'Weiskirchen Saar', area: '6876'},
    { city: 'Weismain', area: '9575'},
    { city: 'Weissenberg Sachs', area: '35876'},
    { city: 'Weißenborn-Lüderode', area: '36072'},
    { city: 'Weißenburg i Bay', area: '9141'},
    { city: 'Weissenburg-Suffersheim', area: '9149'},
    { city: 'Weissenfels Sachs-Anh', area: '3443'},
    { city: 'Weissenhorn', area: '7309'},
    { city: 'Weissensberg', area: '8389'},
    { city: 'Weissensee', area: '36374'},
    { city: 'Weissenstadt', area: '9253'},
    { city: 'Weissenthurm', area: '2637'},
    { city: 'Weisswasser', area: '3576'},
    { city: 'Weisweil Breisgau', area: '7646'},
    { city: 'Weiterstadt', area: '6150'},
    { city: 'Weitnau', area: '8375'},
    { city: 'Welden b Augsburg', area: '8293'},
    { city: 'Welle Nordheide', area: '4188'},
    { city: 'Wellen Mosel', area: '6584'},
    { city: 'Wellheim', area: '8427'},
    { city: 'Welschbillig', area: '6506'},
    { city: 'Welschen Ennest', area: '2764'},
    { city: 'Welschneudorf', area: '2608'},
    { city: 'Welsleben', area: '39296'},
    { city: 'Welver', area: '2384'},
    { city: 'Welzheim', area: '7182'},
    { city: 'Welzow', area: '35751'},
    { city: 'Wemding', area: '9092'},
    { city: 'Wendeburg', area: '5303'},
    { city: 'Wendelstein', area: '9129'},
    { city: 'Wenden Südsauerland', area: '2762'},
    { city: 'Wendisch Rietz', area: '33679'},
    { city: 'Wendlingen am Neckar', area: '7024'},
    { city: 'Wennigsen Deister', area: '5103'},
    { city: 'Wensin', area: '4559'},
    { city: 'Wenzenbach', area: '9407'},
    { city: 'Werbach-Gamburg', area: '9348'},
    { city: 'Werbach-Wenkheim', area: '9349'},
    { city: 'Werben Elbe', area: '39393'},
    { city: 'Werbig b Jüterbog', area: '33746'},
    { city: 'Werdau Sachs', area: '3761'},
    { city: 'Werder Havel', area: '3327'},
    { city: 'Werdohl', area: '2392'},
    { city: 'Werl', area: '2922'},
    { city: 'Werlte', area: '5951'},
    { city: 'Wermelskirchen', area: '2196'},
    { city: 'Wermsdorf', area: '34364'},
    { city: 'Wernberg-Köblitz', area: '9604'},
    { city: 'Werne', area: '2389'},
    { city: 'Werneck', area: '9722'},
    { city: 'Werneuchen', area: '33398'},
    { city: 'Wernigerode', area: '3943'},
    { city: 'Wernshausen', area: '36848'},
    { city: 'Wershofen', area: '2694'},
    { city: 'Wertach*4', area: '8365'},
    { city: 'Wertheim', area: '9342'},
    { city: 'Wertheim-Dertingen', area: '9397'},
    { city: 'Werther Westf', area: '5203'},
    { city: 'Wertingen', area: '8272'},
    { city: 'Wesel', area: '281'},
    { city: 'Wesel-Bislich', area: '2859'},
    { city: 'Wesel-Büderich', area: '2803'},
    { city: 'Wesenberg Meckl', area: '39832'},
    { city: 'Wesendorf Kr Gifhorn', area: '5376'},
    { city: 'Weseram', area: '33831'},
    { city: 'Wesselburen', area: '4833'},
    { city: 'Wesseling Rheinl', area: '2236'},
    { city: 'Wessling', area: '8153'},
    { city: 'Wessobrunn', area: '8809'},
    { city: 'Westendorf b Kaufbeuren', area: '8344'},
    { city: 'Westensee', area: '4305'},
    { city: 'Westerau', area: '4539'},
    { city: 'Westerburg Westerw', area: '2663'},
    { city: 'Westerholt Ostfriesl', area: '4975'},
    { city: 'Westerhorn', area: '4127'},
    { city: 'Westerkappeln', area: '5404'},
    { city: 'Westerkappeln-Velpe', area: '5456'},
    { city: 'Westerstede', area: '4488'},
    { city: 'Westerstede-Ocholt', area: '4409'},
    { city: 'Westfehmarn', area: '4372'},
    { city: 'Westhofen Rheinhess', area: '6244'},
    { city: 'Westoverledingen', area: '4955'},
    { city: 'Wetter Hessen', area: '6423'},
    { city: 'Wetter Ruhr', area: '2335'},
    { city: 'Wettin', area: '34607'},
    { city: 'Wettringen Kr Steinfurt', area: '2557'},
    { city: 'Wettringen Mittelfr', area: '9869'},
    { city: 'Wettrup', area: '5909'},
    { city: 'Wetzlar', area: '6441'},
    { city: 'Wewelsfleth', area: '4829'},
    { city: 'Weyarn', area: '8020'},
    { city: 'Weyerbusch', area: '2686'},
    { city: 'Weyhe b Bremen', area: '4203'},
    { city: 'Wickede Ruhr', area: '2377'},
    { city: 'Wieda', area: '5586'},
    { city: 'Wiedensahl', area: '5726'},
    { city: 'Wiefelstede-Spohle', area: '4458'},
    { city: 'Wiehl', area: '2262'},
    { city: 'Wienhausen', area: '5149'},
    { city: 'Wieren', area: '5825'},
    { city: 'Wiesau', area: '9634'},
    { city: 'Wiesbaden', area: '611'},
    { city: 'Wiesen Unterfr', area: '6096'},
    { city: 'Wiesenburg Mark', area: '33849'},
    { city: 'Wiesenfelden', area: '9966'},
    { city: 'Wiesensteig', area: '7335'},
    { city: 'Wiesentheid', area: '9383'},
    { city: 'Wiesenttal', area: '9196'},
    { city: 'Wiesloch', area: '6222'},
    { city: 'Wiesmoor', area: '4944'},
    { city: 'Wiesmoor-Marcardsmoor', area: '4948'},
    { city: 'Wietmarschen', area: '5925'},
    { city: 'Wietmarschen-Lohne', area: '5908'},
    { city: 'Wietze', area: '5146'},
    { city: 'Wietzen', area: '5022'},
    { city: 'Wietzendorf', area: '5196'},
    { city: 'Wiggensbach', area: '8370'},
    { city: 'Wilburgstetten', area: '9853'},
    { city: 'Wildberg b Altentreptow', area: '39604'},
    { city: 'Wildberg Brandenb', area: '33928'},
    { city: 'Wildberg Württ', area: '7054'},
    { city: 'Wildbergerhütte', area: '2297'},
    { city: 'Wildeck-Hönebach', area: '6678'},
    { city: 'Wildeck-Obersuhl', area: '6626'},
    { city: 'Wildenfels', area: '37603'},
    { city: 'Wildeshausen', area: '4431'},
    { city: 'Wildflecken', area: '9745'},
    { city: 'Wildpoldsried', area: '8304'},
    { city: 'Wilhelmsdorf Württ', area: '7503'},
    { city: 'Wilhelmsfeld', area: '6220'},
    { city: 'Wilhelmshaven', area: '4421'},
    { city: 'Wilhelmsthal Oberfr', area: '9260'},
    { city: 'Wilhermsdorf', area: '9102'},
    { city: 'Willebadessen', area: '5646'},
    { city: 'Willebadessen-Peckelsheim', area: '5644'},
    { city: 'Willich', area: '2154'},
    { city: 'Willich-Anrath', area: '2156'},
    { city: 'Willingen Upland', area: '5632'},
    { city: 'Willingshausen', area: '6697'},
    { city: 'Willstätt', area: '7852'},
    { city: 'Wilnsdorf', area: '2739'},
    { city: 'Wilsdruff', area: '35204'},
    { city: 'Wilster', area: '4823'},
    { city: 'Wilsum', area: '5945'},
    { city: 'Windbergen', area: '4859'},
    { city: 'Windeck Sieg', area: '2292'},
    { city: 'Windesheim', area: '6707'},
    { city: 'Windischeschenbach', area: '9681'},
    { city: 'Windorf-Otterskirchen', area: '8546'},
    { city: 'Windsbach', area: '9871'},
    { city: 'Wingst', area: '4778'},
    { city: 'Winklarn', area: '9676'},
    { city: 'Winnenden', area: '7195'},
    { city: 'Winningen Mosel', area: '2606'},
    { city: 'Winningen Sachs-Anh', area: '34745'},
    { city: 'Winnweiler', area: '6302'},
    { city: 'Winsen Aller', area: '5143'},
    { city: 'Winsen Luhe', area: '4171'},
    { city: 'Winsen-Meissendorf', area: '5056'},
    { city: 'Winsen-Tönnhausen', area: '4179'},
    { city: 'Winterbach Soonwald', area: '6756'},
    { city: 'Winterberg Westf', area: '2981'},
    { city: 'Winterberg-Niedersfeld', area: '2985'},
    { city: 'Winterberg-Siedlinghausen', area: '2983'},
    { city: 'Winterlingen', area: '7434'},
    { city: 'Wipperfürth', area: '2267'},
    { city: 'Wippra', area: '34775'},
    { city: 'Wirdum', area: '4920'},
    { city: 'Wischhafen', area: '4770'},
    { city: 'Wismar Meckl', area: '3841'},
    { city: 'Wissen', area: '2742'},
    { city: 'Wittelshofen', area: '9854'},
    { city: 'Witten', area: '2302'},
    { city: 'Wittenberge', area: '3877'},
    { city: 'Wittenburg', area: '38852'},
    { city: 'Wittgensdorf b Chemnitz', area: '37200'},
    { city: 'Wittibreut', area: '8574'},
    { city: 'Wittichenau', area: '35725'},
    { city: 'Wittighausen', area: '9347'},
    { city: 'Wittingen', area: '5831'},
    { city: 'Wittingen-Knesebeck', area: '5834'},
    { city: 'Wittingen-Ohrdorf', area: '5839'},
    { city: 'Wittingen-Radenbeck', area: '5836'},
    { city: 'Wittislingen', area: '9076'},
    { city: 'Wittlich', area: '6571'},
    { city: 'Wittmannsdorf-Bückchen', area: '35476'},
    { city: 'Wittmund', area: '4462'},
    { city: 'Wittmund-Ardorf', area: '4466'},
    { city: 'Wittmund-Burhafe', area: '4973'},
    { city: 'Wittmund-Carolinensiel', area: '4464'},
    { city: 'Wittmund-Funnix', area: '4467'},
    { city: 'Wittorf Kr Lünebeburg', area: '4133'},
    { city: 'Wittstock Dosse', area: '3394'},
    { city: 'Witzenhausen', area: '5542'},
    { city: 'Witzin', area: '38481'},
    { city: 'Wöbbelin', area: '38753'},
    { city: 'Wöhrden Dithm', area: '4839'},
    { city: 'Wokuhl', area: '39825'},
    { city: 'Woldegk', area: '3963'},
    { city: 'Wolfach', area: '7834'},
    { city: 'Wolfegg', area: '7527'},
    { city: 'Wolfen', area: '3494'},
    { city: 'Wolfenbüttel', area: '5331'},
    { city: 'Wölfersheim', area: '6036'},
    { city: 'Wolfhagen', area: '5692'},
    { city: 'Wolframs-Eschenbach', area: '9875'},
    { city: 'Wolfratshausen', area: '8171'},
    { city: 'Wolfsburg', area: '5361'},
    { city: 'Wolfsburg-Fallersleben', area: '5362'},
    { city: 'Wolfsburg-Neindorf', area: '5365'},
    { city: 'Wolfsburg-Vorsfelde', area: '5363'},
    { city: 'Wolfshagen b Perleberg', area: '38789'},
    { city: 'Wolfstein Pfalz', area: '6304'},
    { city: 'Wolgast', area: '3836'},
    { city: 'Wolkenburg Mulde', area: '37609'},
    { city: 'Wolkenstein', area: '37369'},
    { city: 'Wolkramshausen', area: '36334'},
    { city: 'Wollin b Brandenburg', area: '33833'},
    { city: 'Wöllstadt', area: '6034'},
    { city: 'Wöllstein Rheinhess', area: '6703'},
    { city: 'Wolmirstedt', area: '39201'},
    { city: 'Wolnzach', area: '8442'},
    { city: 'Wolpertswende', area: '7502'},
    { city: 'Wolsfeld', area: '6568'},
    { city: 'Wölsickendorf/Wollenberg', area: '33454'},
    { city: 'Wolterdingen Schwarzw', area: '7705'},
    { city: 'Worbis', area: '36074'},
    { city: 'Wörlitz', area: '34905'},
    { city: 'Worms', area: '6241'},
    { city: 'Worms-Pfeddersheim', area: '6247'},
    { city: 'Wormstedt', area: '36464'},
    { city: 'Worpswede', area: '4792'},
    { city: 'Worpswede-Ostersode', area: '4794'},
    { city: 'Wörrstadt', area: '6732'},
    { city: 'Wörth a d Donau', area: '9482'},
    { city: 'Wörth a d Isar', area: '8702'},
    { city: 'Wörth am Rhein', area: '7271'},
    { city: 'Wörth-Büchelberg', area: '7277'},
    { city: 'Wörth-Schaidt', area: '6340'},
    { city: 'Wredenhagen', area: '39925'},
    { city: 'Wremen', area: '4705'},
    { city: 'Wrestedt', area: '5802'},
    { city: 'Wriedel', area: '5829'},
    { city: 'Wriezen', area: '33456'},
    { city: 'Wrohm', area: '4802'},
    { city: 'Wulfen Sachs-Anh', area: '34979'},
    { city: 'Wulfersdorf b Wittstock', area: '33963'},
    { city: 'Wülfershausen Unterfr', area: '9728'},
    { city: 'Wülfrath', area: '2058'},
    { city: 'Wulfsen', area: '4173'},
    { city: 'Wünnenberg', area: '2953'},
    { city: 'Wünnenberg-Haaren', area: '2957'},
    { city: 'Wünsdorf', area: '33702'},
    { city: 'Wunsiedel', area: '9232'},
    { city: 'Wunstorf', area: '5031'},
    { city: 'Wunstorf-Grossenheidorn', area: '5033'},
    { city: 'Wuppertal', area: '202'},
    { city: 'Wurmannsquick', area: '8725'},
    { city: 'Würselen', area: '2405'},
    { city: 'Wurzbach', area: '36652'},
    { city: 'Würzburg', area: '931'},
    { city: 'Wurzen', area: '3425'},
    { city: 'Wüstenrot', area: '7945'},
    { city: 'Wusterhausen Dosse', area: '33979'},
    { city: 'Wusterhusen', area: '38354'},
    { city: 'Wustermark', area: '33234'},
    { city: 'Wusterwitz', area: '33839'},
    { city: 'Wüstheuterode', area: '36087'},
    { city: 'Wustrau-Altfriesack', area: '33925'},
    { city: 'Wustrow Kr Mecklenburg-Strelitz', area: '39828'},
    { city: 'Wustrow Ostseebad', area: '38220'},
    { city: 'Wustrow Wendland', area: '5843'},
    { city: 'Wutach', area: '7709'},
    { city: 'Wutha-Farnroda', area: '36921'},
    { city: 'Wutike', area: '33976'},
    { city: 'Wutöschingen', area: '7746'},
    { city: 'Wyk auf Föhr', area: '4681'},
    { city: 'Wymeer', area: '4903'},
    { city: 'Xanten', area: '2801'},
    { city: 'Xanten-Marienbaum', area: '2804'},
    { city: 'Zaberfeld', area: '7046'},
    { city: 'Zahna', area: '34924'},
    { city: 'Zapfendorf', area: '9547'},
    { city: 'Zarrentin Meckl', area: '38851'},
    { city: 'Zechin', area: '33473'},
    { city: 'Zechlinerhütte', area: '33921'},
    { city: 'Zehdenick', area: '3307'},
    { city: 'Zehlendorf Kr Oberhavel', area: '33053'},
    { city: 'Zehna', area: '38458'},
    { city: 'Zehren Sachs', area: '35247'},
    { city: 'Zeil a Main', area: '9524'},
    { city: 'Zeitlofs', area: '9746'},
    { city: 'Zeitlofs-Detter', area: '9744'},
    { city: 'Zeitz', area: '3441'},
    { city: 'Zell am Harmersbach', area: '7835'},
    { city: 'Zell im Wiesental', area: '7625'},
    { city: 'Zell Oberfr', area: '9257'},
    { city: 'Zell Oberpf', area: '9468'},
    { city: 'Zella-Mehlis', area: '3682'},
    { city: 'Zellingen', area: '9364'},
    { city: 'Zeltingen-Rachtig', area: '6532'},
    { city: 'Zemmer', area: '6580'},
    { city: 'Zenting', area: '9907'},
    { city: 'Zerbst', area: '3923'},
    { city: 'Zerf', area: '6587'},
    { city: 'Zernien', area: '5863'},
    { city: 'Zernitz b Neustadt Dosse', area: '33973'},
    { city: 'Zerpenschleuse', area: '33395'},
    { city: 'Zerrenthin', area: '39743'},
    { city: 'Zetel', area: '4453'},
    { city: 'Zetel-Neuenburg', area: '4452'},
    { city: 'Zeulenroda', area: '36628'},
    { city: 'Zeuthen', area: '33762'},
    { city: 'Zeven', area: '4281'},
    { city: 'Zichtau', area: '39085'},
    { city: 'Ziegendorf', area: '38721'},
    { city: 'Ziegenhain Sachs', area: '35246'},
    { city: 'Ziegenrück', area: '36483'},
    { city: 'Ziemetshausen', area: '8284'},
    { city: 'Zierenberg', area: '5606'},
    { city: 'Zierzow b Ludwigslust', area: '38752'},
    { city: 'Ziesar', area: '33830'},
    { city: 'Ziltendorf', area: '33653'},
    { city: 'Zingst Ostseebad', area: '38232'},
    { city: 'Zinnitz', area: '35439'},
    { city: 'Zinnowitz', area: '38377'},
    { city: 'Zirchow', area: '38376'},
    { city: 'Zittau', area: '3583'},
    { city: 'Zöblitz', area: '37363'},
    { city: 'Zodel', area: '35820'},
    { city: 'Zollchow b Rathenow', area: '33870'},
    { city: 'Zolling', area: '8167'},
    { city: 'Zörbig', area: '34956'},
    { city: 'Zöschen', area: '34638'},
    { city: 'Zossen Brandenb', area: '3377'},
    { city: 'Zschopau', area: '3725'},
    { city: 'Zuchau', area: '39295'},
    { city: 'Zülpich', area: '2252'},
    { city: 'Züsedom', area: '39747'},
    { city: 'Zusmarshausen', area: '8291'},
    { city: 'Züssow', area: '38355'},
    { city: 'Zweibrücken', area: '6332'},
    { city: 'Zwenkau', area: '34203'},
    { city: 'Zwickau', area: '375'},
    { city: 'Zwiedorf', area: '39600'},
    { city: 'Zwiefalten', area: '7373'},
    { city: 'Zwiesel', area: '9922'},
    { city: 'Zwochau', area: '34207'},
    { city: 'Zwönitz', area: '37754'}];

export function getCitiesAndAreas() {
    return citiesAndAreas;
}